import hagcStep1 from "@/assets/tutorials/how-axy-generates-campaigns/step-1.png";
import hagcStep2 from "@/assets/tutorials/how-axy-generates-campaigns/step-2.png";
import hagcStep5 from "@/assets/tutorials/how-axy-generates-campaigns/step-5.png";
import hagcStep6 from "@/assets/tutorials/how-axy-generates-campaigns/step-6.png";
import hagcStep7 from "@/assets/tutorials/how-axy-generates-campaigns/step-7.png";
import compStep1 from "@/assets/tutorials/add-your-competitors/step-1.png";
import compStep3 from "@/assets/tutorials/add-your-competitors/step-3.png";
import customCampWhat from "@/assets/tutorials/create-custom-campaigns/what-you-can-create.png";
import geoLangStep1 from "@/assets/tutorials/customize-geography-and-language/step-1.png";
import geoLangStep4 from "@/assets/tutorials/customize-geography-and-language/step-4.png";

import geoArtStep1 from "@/assets/tutorials/generate-a-geo-article/step-1.png";
import geoArtStep5 from "@/assets/tutorials/generate-a-geo-article/step-5.png";
import geoArtStep6 from "@/assets/tutorials/generate-a-geo-article/step-6.png";
import geoArtStep7 from "@/assets/tutorials/generate-a-geo-article/step-7.png";
import geoArtStep8 from "@/assets/tutorials/generate-a-geo-article/step-8.png";
import geoArtStep9 from "@/assets/tutorials/generate-a-geo-article/step-9.png";
import geoArtStep10 from "@/assets/tutorials/generate-a-geo-article/step-10.png";

import liStep1 from "@/assets/tutorials/generate-linkedin-posts/step-1.png";
import liStep4 from "@/assets/tutorials/generate-linkedin-posts/step-4.png";
import liStep5 from "@/assets/tutorials/generate-linkedin-posts/step-5.png";
import liStep6 from "@/assets/tutorials/generate-linkedin-posts/step-6.png";
import liStep7 from "@/assets/tutorials/generate-linkedin-posts/step-7.png";

import xStep1 from "@/assets/tutorials/generate-x-posts-and-threads/step-1.png";
import xStep4 from "@/assets/tutorials/generate-x-posts-and-threads/step-4.png";
import xStep5 from "@/assets/tutorials/generate-x-posts-and-threads/step-5.png";
import xStep7 from "@/assets/tutorials/generate-x-posts-and-threads/step-7.png";

import mbStep1 from "@/assets/tutorials/manage-multiple-brands/step-1.png";
import mbStep2 from "@/assets/tutorials/manage-multiple-brands/step-2.png";

import kbBefore from "@/assets/tutorials/populate-your-knowledge-base/before-you-start.png";
import kbStep1 from "@/assets/tutorials/populate-your-knowledge-base/step-1.png";
import kbStep4 from "@/assets/tutorials/populate-your-knowledge-base/step-4.png";
import kbStep5 from "@/assets/tutorials/populate-your-knowledge-base/step-5.png";
import kbStep6 from "@/assets/tutorials/populate-your-knowledge-base/step-6.png";

import mkStep1 from "@/assets/tutorials/read-market-signals/step-1.png";
import mkStep3 from "@/assets/tutorials/read-market-signals/step-3.png";
import mkStep6 from "@/assets/tutorials/read-market-signals/step-6.png";

import mtStep1 from "@/assets/tutorials/read-market-trends/step-1.png";
import mtStep7 from "@/assets/tutorials/read-market-trends/step-7.png";

import ssStep1 from "@/assets/tutorials/read-search-opportunities/step-1.png";
import ssStep2 from "@/assets/tutorials/read-search-opportunities/step-2.png";
import ssStep7 from "@/assets/tutorials/read-search-opportunities/step-7.png";

import avStep1 from "@/assets/tutorials/read-your-ai-visibility-report/step-1.png";
import avStep2 from "@/assets/tutorials/read-your-ai-visibility-report/step-2.png";
import avStep3 from "@/assets/tutorials/read-your-ai-visibility-report/step-3.png";
import avStep4 from "@/assets/tutorials/read-your-ai-visibility-report/step-4.png";
import avStep7 from "@/assets/tutorials/read-your-ai-visibility-report/step-7.png";
import avStep8 from "@/assets/tutorials/read-your-ai-visibility-report/step-8.png";
import avStep9 from "@/assets/tutorials/read-your-ai-visibility-report/step-9.png";
import avStep10 from "@/assets/tutorials/read-your-ai-visibility-report/step-10.png";

import midStep2 from "@/assets/tutorials/read-your-market-intelligence-dashboard/step-2.png";
import midStep3 from "@/assets/tutorials/read-your-market-intelligence-dashboard/step-3.png";
import midStep4 from "@/assets/tutorials/read-your-market-intelligence-dashboard/step-4.png";
import midStep5 from "@/assets/tutorials/read-your-market-intelligence-dashboard/step-5.png";

import msStep1 from "@/assets/tutorials/review-marketing-strategy-and-channel-plans/step-1.png";

import usrStep1 from "@/assets/tutorials/update-strategy-with-new-resources/step-1.png";
import usrStep2 from "@/assets/tutorials/update-strategy-with-new-resources/step-2.png";
import usrStep4 from "@/assets/tutorials/update-strategy-with-new-resources/step-4.png";
import usrStep5 from "@/assets/tutorials/update-strategy-with-new-resources/step-5.png";
import usrStep7 from "@/assets/tutorials/update-strategy-with-new-resources/step-7.png";

import mcStep1 from "@/assets/tutorials/use-the-marketing-calendar/step-1.png";

import ccStep1 from "@/assets/tutorials/create-custom-campaigns/step-1.png";
import ccStep4 from "@/assets/tutorials/create-custom-campaigns/step-4.png";

import setBefore from "@/assets/tutorials/set-up-your-axy-engine/before-you-start.png";
import setStep2 from "@/assets/tutorials/set-up-your-axy-engine/step-2.png";
import setStep3 from "@/assets/tutorials/set-up-your-axy-engine/step-3.png";
import setStep4 from "@/assets/tutorials/set-up-your-axy-engine/step-4.png";
import setStep6 from "@/assets/tutorials/set-up-your-axy-engine/step-6.png";
import setStep7 from "@/assets/tutorials/set-up-your-axy-engine/step-7.png";
import setStep8 from "@/assets/tutorials/set-up-your-axy-engine/step-8.png";
import setStep9 from "@/assets/tutorials/set-up-your-axy-engine/step-9.png";

import msStep4 from "@/assets/tutorials/review-marketing-strategy-and-channel-plans/step-4.png";
import msStep5 from "@/assets/tutorials/review-marketing-strategy-and-channel-plans/step-5.png";
import { type Article, type ArticleSection, p, h2, h3, ul, img } from "./content-blocks";

export type { Article, ArticleSection, TutorialBlock } from "./content-blocks";

export const tutorialSections: ArticleSection[] = [
  {
    title: "Configuring your Axy.digital Engine",
    articles: [
      {
        slug: "set-up-your-axy-engine",
        title: "How to Set Up Your Axy.digital Engine",
        metaTitle: "How to Set Up Your Axy.digital Engine | Axy.digital Tutorial",
        metaDescription:
          "Learn how to set up your Axy.digital Engine: add your website, review discovered channels, populate your knowledge base, and approve your strategy.",
        category: "Getting Started",
        product: "Axy.digital Engine Knowledge Base",
        difficulty: "Beginner",
        estimatedTime: "5 minutes",
        bestFor:
          "Founders, marketers, agencies, and teams setting up Axy.digital for the first time",
        intro:
          "Your Axy.digital engine is the foundation of your algorithmic marketing engine. During onboarding, Axy.digital learns your business, analyzes your website, discovers your social channels, builds your knowledge base, identifies competitors, and generates your first marketing strategy. Once your Engine is reviewed and approved, Axy.digital can start generating AI visibility analytics, market intelligence dashboards, and campaigns across GEO, LinkedIn, and X. This tutorial walks you through the setup process.",
        blocks: [
          img(
            setBefore,
            "Welcome to axy.digital onboarding overview listing the four-step process: create organization, marketing channels, populate knowledge base, review strategy",
          ),
          h2("Before you start"),
          p("You will need:"),
          ul([
            "Your company website URL",
            "Any additional social channels you want Axy.digital to know about",
            "Optional resources such as docs pages, GitHub repositories, whitepapers, pitch decks, PDFs, blog links, or product pages",
            "A few minutes to review and approve the generated strategy",
          ]),
          p(
            "You do not need to have everything perfect before continuing. Axy.digital will generate most fields for you, and you can always come back later to edit your strategy, competitors, channels, and plans.",
          ),
          img(),
          h2("Step 1: Start onboarding"),
          p(
            "When you first create an account, Axy.digital will take you to the onboarding page. This guided onboarding flow helps Axy.digital understand your business before generating strategy or campaigns.",
          ),
          p(
            "Start by entering your company website URL. Axy.digital will use your website as the first source of truth for your Engine.",
          ),
          img(
            setStep2,
            "Knowledge Base onboarding step asking for the company's official website URL",
          ),
          h2("Step 2: Let Axy.digital analyze your website"),
          p("After you enter your website, Axy.digital will analyze your site to understand:"),
          ul([
            "What your company does",
            "Your product or service offering",
            "Your target audience",
            "Your positioning",
            "Your category",
            "Your existing content",
            "Your current marketing foundation",
          ]),
          p(
            "Axy.digital uses this information to begin building the context layer for your marketing engine. This context helps future campaigns stay relevant to your business instead of producing generic AI content.",
          ),
          img(
            setStep3,
            "Marketing Channels review listing discovered X, Blog, TikTok and LinkedIn URLs with checkboxes",
          ),
          h2("Step 3: Review discovered social channels"),
          p(
            "Axy.digital will automatically look for your existing social channels from your website and public presence. This may include:",
          ),
          ul([
            "LinkedIn company page",
            "Founder LinkedIn profiles",
            "X/Twitter accounts",
            "YouTube",
            "Instagram",
            "Other relevant channels",
          ]),
          p(
            "Review the channels Axy.digital finds. If a channel is missing, you can add it manually. Axy.digital will analyze your social pages to understand your current messaging, audience, posting style, and content history.",
          ),
          img(
            setStep4,
            "Add Knowledge dialog with From file and From website link options for adding additional online resources",
          ),
          h2("Step 4: Add additional online resources"),
          p(
            "Next, add any additional resources that can help Axy.digital understand your company more deeply. Useful resources include:",
          ),
          ul([
            "Documentation pages",
            "GitHub repositories",
            "Product pages",
            "Help center articles",
            "Whitepapers",
            "Pitch decks",
            "Sales decks",
            "Blog posts",
            "Case studies",
            "Technical docs",
            "Public reports",
            "Brand guidelines",
          ]),
          p(
            "These sources help populate your knowledge base. The more useful context Axy.digital has, the better it can generate strategy, market insights, and campaigns. You do not need to upload everything at once. You can always add more resources later.",
          ),
          img(),
          h2("Step 5: Populate your knowledge base"),
          p(
            "Axy.digital will use your website, social channels, uploaded documents, and added URLs to populate your knowledge base. Your knowledge base is where Axy.digital stores the core context it needs to understand your business. This may include:",
          ),
          ul([
            "Company description",
            "Product overview",
            "Key features",
            "Target customers",
            "Use cases",
            "Positioning",
            "Differentiators",
            "Proof points",
            "Market context",
            "Founder voice",
            "Brand voice",
            "Existing content themes",
          ]),
          p(
            "This is one of the most important parts of setup because it affects how Axy.digital generates future marketing strategy and content.",
          ),
          img(
            setStep6,
            "Generated Marketing Strategy showing Key Messages with Mission, Vision, Problem Statement and Value Proposition fields",
          ),
          h2("Step 6: Review your generated marketing strategy"),
          p(
            "Once your knowledge base is populated, Axy.digital will automatically generate your marketing strategy. This strategy gives the engine a clear direction for future recommendations and campaigns.",
          ),
          p(
            "Review the generated strategy and edit anything that feels inaccurate or incomplete. You may see fields such as:",
          ),
          ul([
            "Positioning",
            "Ideal customer profile",
            "Target segments",
            "Key pain points",
            "Core messaging",
            "Differentiators",
            "Content pillars",
            "Market narrative",
            "Channel priorities",
            "Brand voice",
          ]),
          p(
            "The strategy does not need to be perfect. It only needs to be directionally accurate enough for Axy.digital to begin generating useful outputs. You can come back and refine it later, and those updates will improve the entire engine.",
          ),
          img(
            setStep7,
            "Suggested competitors selection with manual add field and a list of cards including promptql, getgenie, elatre, searchatlas, snezzi and rankalchemist",
          ),
          h2("Step 7: Review suggested competitors"),
          p(
            "Axy.digital will automatically identify competitors based on your website, market category, and positioning. Review the suggested competitors and select the most relevant ones.",
          ),
          p("Competitors help Axy.digital understand:"),
          ul([
            "Who you are compared against",
            "Which companies are visible in your category",
            "What narratives they are using",
            "What content they are publishing",
            "Which competitors show up in AI search",
            "Where your brand may have visibility gaps",
          ]),
          p("You can remove irrelevant competitors and add missing ones manually."),
          img(
            setStep8,
            "Marketing Plan configuration for the Blog channel showing content pillars, publishing schedule and per-day pillar assignments",
          ),
          h2("Step 8: Review channel-specific marketing plans"),
          p(
            "After your strategy and competitors are reviewed, Axy.digital will generate channel-specific marketing plans. These plans guide how Axy.digital creates campaigns for each channel. You may see plans for:",
          ),
          ul(["GEO / AEO / SEO", "LinkedIn", "X"]),
          p(
            "Each plan is generated based on your business context, market signals, audience, and channel opportunities. Review each plan and make edits where needed. For example, you may want to adjust:",
          ),
          ul([
            "Target audience",
            "Tone of voice",
            "Content themes",
            "Campaign priorities",
            "Geographic focus",
            "Product focus",
            "Competitor references",
            "Posting style",
          ]),
          p(
            "Again, these plans do not need to be perfect. They are living inputs that you can update as your business evolves.",
          ),
          img(
            setStep9,
            "Channel content guidelines with content length, FAQ and emoji toggles, words to avoid chips and a custom guidelines text area before approving",
          ),
          h2("Step 9: Approve your onboarded pages"),
          p(
            "Your onboarding is considered complete when all onboarding pages have been reviewed and approved. Before approving, check that:",
          ),
          ul([
            "Your website has been analyzed",
            "Your social channels are correct",
            "Your knowledge base has useful context",
            "Your marketing strategy is directionally accurate",
            "Your competitors are relevant",
            "Your GEO, LinkedIn, and X plans make sense",
          ]),
          p("Once approved, Axy.digital is ready to start generating dashboards and campaigns."),
          img(),
          h2("Step 10: Start using your marketing engine"),
          p("After onboarding is complete, Axy.digital can begin generating:"),
          ul([
            "AI visibility analytics",
            "Market intelligence dashboards",
            "GEO / AEO / SEO campaigns",
            "LinkedIn posts",
            "X posts and threads",
            "Channel-specific marketing plans",
            "Campaign recommendations",
          ]),
          p(
            "Your Engine now acts as the foundation for your algorithmic marketing engine. Axy.digital will use your approved strategy, knowledge base, competitors, and channel plans to generate more relevant recommendations and content over time.",
          ),
          img(),
          h2("FAQ"),
          h3("Does everything need to be perfect?"),
          p(
            "No. Your onboarding fields do not need to be perfect before you start using Axy.digital. Axy.digital is designed to improve as your context improves. You can always come back and edit your marketing strategy, competitor list, channel plans, and knowledge base. When you update these fields, the changes update the entire engine. That means future dashboards, recommendations, and campaigns will reflect your latest strategy. The goal of onboarding is not perfection. The goal is to give Axy.digital enough context to start generating useful marketing outputs.",
          ),
          img(),
          h2("Best practices"),
          h3("Add your most important resources first"),
          p(
            "Start with your website, main social channels, product docs, pitch deck, or whitepaper. You can add more resources later.",
          ),
          h3("Choose relevant competitors"),
          p(
            "Do not select every company Axy.digital suggests. Choose the competitors your buyers are most likely to compare you against.",
          ),
          h3("Review strategy for direction, not perfection"),
          p(
            "Your strategy should be directionally right. It does not need to read like a finished brand deck.",
          ),
          h3("Keep your Engine updated"),
          p(
            "As your product, positioning, audience, or market changes, update your Engine. This keeps your engine aligned with your business.",
          ),
          h3("Use onboarding as a starting point"),
          p(
            "The first setup creates the baseline. Axy.digital becomes more useful as you generate reports, review campaigns, and feed more context back into the system.",
          ),
          p("Once your onboarding is complete, start with one of these next steps:"),
          ul([
            "Generate your first AI visibility report",
            "Open your Market Intelligence dashboard",
            "Generate your first GEO campaign",
            "Generate your first LinkedIn post",
            "Generate your first X thread",
          ]),
        ],
        next: ["/tutorials/read-your-ai-visibility-report"],
      },
      {
        slug: "populate-your-knowledge-base",
        title: "How to Populate Your Knowledge Base",
        metaTitle: "How Populate your knowledge base | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital analyzes your website, discovers your social channels, indexes your pages for internal linking, and generates your strategy.",
        category: "Getting Started",
        product: "Axy.digital Engine Knowledge Base",
        difficulty: "Beginner",
        estimatedTime: "5 minutes",
        bestFor: "New users setting up their Axy.digital Engine Knowledge Base",
        intro:
          "Your website is the first source of truth Axy.digital uses to understand your business. When you add your website URL during onboarding, Axy.digital analyzes your public presence, discovers your social channels, indexes the pages on your site, and begins generating your company profile. This profile becomes part of your Engine context and helps Axy.digital generate more relevant strategy, market intelligence, AI visibility analytics, and campaigns.",
        blocks: [
          img(kbBefore, "Axy.digital onboarding welcome screen with knowledge base setup steps"),
          h2("Before you start"),
          p("You will need:"),
          ul([
            "Your company website URL",
            "Any additional URLs you want Axy.digital to analyze",
            "Optional resources like documentation pages, GitHub repositories, decks, whitepapers, product pages, blog links, or case studies",
          ]),
          p(
            "You do not need a perfect website to use Axy.digital. The goal is to give the engine a strong starting point.",
          ),
          img(kbStep1, "Official website URL input during Axy.digital knowledge base setup"),
          h2("Step 1: Enter your website URL"),
          p(
            "On the onboarding page, enter your main company website. Use the URL that best represents your business today. For most companies, this will be your homepage.",
          ),
          p("Example: https://yourcompany.com"),
          p("Once you submit the URL, Axy.digital will begin analyzing your website."),
          img(),
          h2("Step 2: Let Axy.digital analyze your website"),
          p(
            "Axy.digital reviews your website to understand your company context. It looks for signals such as:",
          ),
          ul([
            "What your company does",
            "Your product or service category",
            "Your target audience",
            "Your existing messaging",
            "Your main use cases",
            "Your product pages",
            "Your blog or content library",
            "Your calls to action",
            "Your positioning and differentiators",
          ]),
          p("This gives Axy.digital the foundation it needs to generate your company profile."),
          img(),
          h2("Step 3: Axy.digital indexes your site pages"),
          p(
            "In addition to reading your website, Axy.digital indexes the pages on your site. This gives the engine a map of your existing content, including:",
          ),
          ul([
            "Homepage",
            "Product pages",
            "Use-case pages",
            "Blog posts",
            "Case studies",
            "Tutorials",
            "Resource pages",
            "Documentation pages",
          ]),
          p(
            "Axy.digital uses this site index to recommend internal links when generating future campaigns. For example, if Axy.digital generates a GEO article about AI visibility, it can suggest links to your AI Visibility Analytics product page, related tutorials, relevant comparison pages, and case studies. This helps every new campaign strengthen your existing content architecture instead of creating disconnected pages.",
          ),
          img(kbStep4, "Marketing channels review screen with detected social profiles"),
          h2("Step 4: Review discovered social channels"),
          p(
            "Axy.digital will automatically detect social channels connected to your website and public presence. These may include:",
          ),
          ul([
            "LinkedIn company page",
            "Founder LinkedIn profiles",
            "X/Twitter accounts",
            "YouTube",
            "Instagram",
            "Other relevant channels",
          ]),
          p(
            "Review the channels Axy.digital finds. If a channel is missing, add it manually. Axy.digital will analyze your social pages to understand your current messaging, audience, posting style, content history, and channel activity.",
          ),
          img(kbStep5, "Add knowledge modal with file upload and website link options"),
          h2("Step 5: Add additional resources"),
          p(
            "To improve the quality of your company profile, add any resources that help explain your business in more depth. Useful resources include:",
          ),
          ul([
            "Product documentation",
            "GitHub repositories",
            "Whitepapers",
            "Pitch decks",
            "Sales decks",
            "Blog posts",
            "Case studies",
            "Help center pages",
            "Technical documentation",
            "Brand guidelines",
            "Public reports",
          ]),
          p(
            "These resources help Axy.digital build a richer knowledge base. For example, your website may explain what your product does, while your whitepaper may explain your market thesis, your GitHub may show technical depth, and your deck may explain your positioning more clearly. You do not need to add everything during onboarding. You can always add more resources later.",
          ),
          img(kbStep6, "Generated marketing strategy review with key messages, mission and vision"),
          h2("Step 6: Review your generated marketing strategy"),
          p(
            "Once Axy.digital has analyzed your website, indexed your pages, reviewed your social channels, and processed your resources, it will generate a company profile. This may include:",
          ),
          ul([
            "Vision",
            "Mission",
            "Problem statement",
            "Value proposition",
            "Product statement",
            "Target audience",
            "Key use cases",
            "Brand positioning",
            "Personality and tone",
          ]),
          p(
            "Review the profile for accuracy. You can edit anything that feels wrong, outdated, or incomplete.",
          ),
          img(),
          h2("Step 7: Approve or update the strategy"),
          p(
            "If the generated strategy looks directionally correct, approve it and continue onboarding. If something is inaccurate, update it before moving forward. Common edits include:",
          ),
          ul([
            "Clarifying the company description",
            "Updating the target audience",
            "Correcting product names",
            "Adding missing use cases",
            "Removing irrelevant language",
            "Making the positioning more specific",
            "Adding important product or category details",
          ]),
          p("Your profile does not need to be perfect. You can always update it later."),
          img(),
          h2("FAQ"),
          h3("What if my website is outdated?"),
          p(
            "That is okay. Axy.digital can still use your website as a starting point. You should add more current resources, such as decks, docs, whitepapers, or product pages, to give the engine better context. If your website does not reflect your latest positioning, edit the generated company profile before approving it.",
          ),
          h3("Why does Axy.digital index my website pages?"),
          p(
            "Axy.digital indexes your site so it can understand what content already exists and recommend relevant internal links in future campaigns. This is useful for GEO, AEO, SEO, and content strategy because your campaigns should not exist in isolation. When Axy.digital knows your existing product pages, use-case pages, tutorials, comparison pages, and case studies, it can suggest links that help readers move through your site and help search engines and AI systems understand your topical authority.",
          ),
          img(),
          h2("Best practices"),
          h3("Add the most complete URL first"),
          p(
            "Use the main website that best represents your business, not a temporary landing page unless that is your current source of truth.",
          ),
          h3("Add supporting resources"),
          p(
            "Your website alone may not contain enough strategic context. Add docs, decks, whitepapers, GitHub repositories, or product pages where possible.",
          ),
          h3("Review for direction, not perfection"),
          p(
            "The company profile should be accurate enough to guide Axy.digital. It does not need to be a polished brand document.",
          ),
          h3("Keep your profile updated"),
          p(
            "When your product, positioning, or audience changes, update your company profile so future strategy and content stay aligned.",
          ),
          h3("Let your site index support future campaigns"),
          p(
            "Once your pages are indexed, Axy.digital can recommend internal links in future campaigns. Review these links before publishing to make sure they are accurate and useful.",
          ),
          p(
            "Once your website and company profile are approved, continue to your competitor setup.",
          ),
        ],
        next: ["/tutorials/add-your-competitors"],
      },
      {
        slug: "add-your-competitors",
        title: "How to Add Your Competitors",
        metaTitle: "How to Add Your Competitors | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital finds competitors, how to pick the most relevant ones, and how competitor context sharpens market intelligence and campaigns.",
        category: "Getting Started",
        product: "Axy.digital Engine Select Competitors",
        difficulty: "Beginner",
        estimatedTime: "5 minutes",
        bestFor: "New users configuring their engine",
        intro:
          "Competitors help Axy.digital understand your market. During onboarding, Axy.digital automatically suggests competitors based on your website, positioning, category, online presence, and market context. You can review the suggestions, select the most relevant companies, remove irrelevant ones, and add missing competitors manually. Your selected competitors influence market intelligence, AI visibility analytics, GEO content, LinkedIn campaigns, X campaigns, comparison content, internal linking recommendations, and future campaign strategy.",
        blocks: [
          img(),
          h2("Why competitors matter"),
          p("Axy.digital uses competitor context to understand:"),
          ul([
            "Who your buyers compare you against",
            "Which brands are visible in your category",
            "What narratives competitors are using",
            "What content they publish",
            "Which competitors show up in AI search",
            "Which prompts or topics your brand is missing from",
            "Which comparison pages or content gaps may be worth creating",
            "Where you have positioning opportunities",
          ]),
          p(
            "The goal is not to track every company in your space. The goal is to select the competitors that matter most to your buyers, market, and growth strategy.",
          ),
          img(compStep1, "Axy.digital onboarding competitors selection screen"),
          h2("Step 1: Review Axy.digital’s suggested competitors"),
          p(
            "After Axy.digital analyzes your website, company profile, social presence, and market category, it will suggest competitors. These suggestions may be based on:",
          ),
          ul([
            "Your category",
            "Your product description",
            "Your target audience",
            "Your website content",
            "Your positioning",
            "Search and market context",
            "AI search visibility patterns",
            "Similar companies in your space",
          ]),
          p("Review each suggested competitor carefully."),
          img(),
          h2("Step 2: Select the most relevant competitors"),
          p(
            "Choose competitors that your customers are most likely to compare you against. Good competitors usually include:",
          ),
          ul([
            "Companies with a similar product or service",
            "Companies targeting the same audience",
            "Companies showing up in search for your category",
            "Companies mentioned in AI answers for your market",
            "Companies your sales team hears about often",
            "Companies your prospects ask about",
            "Companies you want to compete with in positioning or visibility",
          ]),
          p(
            "Avoid selecting competitors just because they are well-known if they are not relevant to your buyer journey. A focused competitor list will usually produce better market intelligence than a broad, unfocused one. No need to remove irrelevant competitors.",
          ),
          img(compStep3, "Add new competitor modal in Axy.digital"),
          h2("Step 3: Add missing competitors manually"),
          p("If Axy.digital misses an important competitor, add it manually. You may want to add:"),
          ul([
            "Direct product competitors",
            "Category leaders",
            "Regional competitors",
            "Emerging startups",
            "Companies your customers mention",
            "Companies you want to displace in AI search",
            "Companies ranking for your target topics",
            "Companies you plan to compare against in future content",
          ]),
          p("For each competitor, add the company name and website URL if available."),
          img(),
          h2("Step 4: Approve your competitor list"),
          p(
            "Once your competitor list looks accurate, approve it. Axy.digital will use this competitor context across the engine, including:",
          ),
          ul([
            "Market intelligence dashboards",
            "Competitor content monitoring",
            "AI visibility analytics",
            "Prompt-level competitor comparison",
            "GEO content opportunities",
            "LinkedIn campaign ideas",
            "X content angles",
            "Positioning recommendations",
            "Comparison page opportunities",
            "Internal linking suggestions for relevant content",
          ]),
          p(
            "Competitor context helps Axy.digital understand not just what your company says, but how your market is framed by others.",
          ),
          img(),
          h2("Step 5: Use competitors to inform content architecture"),
          p(
            "Axy.digital can use your competitor list to identify topics, prompts, and pages that may be worth creating. For example, competitor context can help reveal opportunities for:",
          ),
          ul([
            "Comparison pages",
            "Alternative pages",
            "Category pages",
            "Use-case pages",
            "GEO articles",
            "AI visibility campaigns",
            "LinkedIn positioning posts",
            "X commentary",
          ]),
          p(
            "Because Axy.digital also indexes your website pages, it can later suggest internal links between new competitor-related content and your existing product, use-case, tutorial, and case study pages. For example, if Axy.digital generates a comparison campaign, it may suggest internal links to:",
          ),
          ul([
            "A relevant product page",
            "A related use-case page",
            "A tutorial explaining the workflow",
            "A case study that supports the claim",
            "Another comparison page in the same category",
          ]),
          p("This helps competitor content become part of a connected website system."),
          img(),
          h2("Step 6: Update competitors over time"),
          p(
            "Your competitor list is not fixed. As your company evolves, you may want to add or remove competitors. For example, update your competitor list when:",
          ),
          ul([
            "You enter a new market",
            "Your ICP changes",
            "A new competitor launches",
            "Your sales team starts hearing a new name",
            "You expand into a new region",
            "Your positioning changes",
            "You want to track a new category",
            "AI search starts recommending a new company in your space",
          ]),
          p(
            "Updating competitors helps Axy.digital keep your market intelligence and campaigns relevant.",
          ),
          img(),
          h2("FAQ"),
          h3("How many competitors should I add?"),
          p(
            "Start with a focused list. For most teams, 5–10 strong competitors is a good starting point. You can add more later, but the first list should prioritize relevance over quantity.",
          ),
          h3("Should I include aspirational competitors?"),
          p(
            "Yes, but only if they are useful. Aspirational competitors can help Axy.digital understand the category you want to be associated with. But your list should still include the companies your buyers actually compare you against today. A good competitor mix may include direct competitors, category leaders, regional competitors, emerging competitors, and aspirational competitors.",
          ),
          h3("Do competitors affect internal linking?"),
          p(
            "Indirectly, yes. Your competitor list helps Axy.digital understand which comparison topics, category narratives, and positioning gaps matter. Your website index helps Axy.digital understand which existing pages should be linked when those campaigns are created. Together, competitor context and website indexing help Axy.digital generate campaigns that are more strategically connected.",
          ),
          img(),
          h2("Best practices"),
          h3("Choose buyer-relevant competitors"),
          p("Ask: “Would my customer compare us to this company?” If yes, include it."),
          h3("Keep the list focused"),
          p("Too many irrelevant competitors can weaken the signal quality."),
          h3("Include competitors that show up in AI search"),
          p("If AI tools are recommending a company for your category, it may be worth tracking."),
          h3("Include competitors your sales team hears about"),
          p(
            "Sales conversations are often one of the best indicators of real buyer comparison behavior.",
          ),
          h3("Review your list regularly"),
          p(
            "Competitors change as your category evolves. Update your list when the market changes.",
          ),
          p(
            "Once your competitors are approved, Axy.digital can use them to generate stronger AI visibility analytics, market intelligence, and campaigns.",
          ),
        ],
        next: [
          "/tutorials/review-marketing-strategy-and-channel-plans",
          "/geo/use-competitor-visibility-to-find-content-opportunities",
        ],
      },
      {
        slug: "review-marketing-strategy-and-channel-plans",
        title: "How to Review and Edit Your Marketing Strategy and Channel Plans",
        metaTitle:
          "How to Review and Edit Your Marketing Strategy and Channel Plans | Axy.digital Tutorial",
        metaDescription:
          "Learn how to review and edit your generated marketing strategy, brand voice, positioning, ICP, competitors, and channel-specific plans for GEO, LinkedIn, and X.",
        category: "Getting Started",
        product: "Axy.digital Engine - marketing strategy & Channel plan",
        difficulty: "Beginner",
        estimatedTime: "10 minutes",
        bestFor: "Founders, marketers, agencies, and teams completing onboarding",
        intro:
          "After Axy.digital analyzes your website, social channels, online resources, uploaded documents, and competitors, it automatically generates your marketing strategy and channel-specific plans. These plans guide how Axy.digital creates future dashboards, campaign recommendations, GEO content, LinkedIn posts, and X content. You do not need to write your strategy from scratch. Axy.digital generates the first version for you. Your job is to review, adjust, and approve it.",
        blocks: [
          img(),
          h2("Why this matters"),
          p(
            "Axy.digital is not a generic AI writing tool. It uses your approved strategy, brand context, website index, competitor list, and channel plans to guide future outputs, including:",
          ),
          ul([
            "Market intelligence recommendations",
            "AI visibility opportunities",
            "GEO, AEO, and SEO content",
            "LinkedIn posts",
            "X posts and threads",
            "Campaign strategy",
            "Competitor positioning",
            "Internal linking recommendations",
            "Content tone and style",
          ]),
          p("The better your context, the more relevant your campaigns become."),
          img(),
          h2("Before you start"),
          p("Make sure you have already:"),
          ul([
            "Added your website",
            "Reviewed discovered social channels",
            "Added relevant online resources",
            "Uploaded key documents where needed",
            "Reviewed your generated company profile",
            "Selected your competitors",
          ]),
          p("Axy.digital uses this information to generate your strategy and plans."),
          img(
            msStep1,
            "Marketing Strategy review step in the Super Engine wizard with editable Mission, Vision, Problem and Value Proposition fields",
          ),
          h2("Step 1: Open your generated marketing strategy"),
          p(
            "Once your knowledge base is populated, Axy.digital will generate your marketing strategy automatically. This may include:",
          ),
          ul([
            "Vision",
            "Mission",
            "Problem statement",
            "Value proposition",
            "Taglines",
            "CTAs",
            "Marketing goals",
            "Target audience",
            "Pain points",
            "Industries",
            "Verticals",
            "Brand positioning",
            "Tone",
            "Personality",
          ]),
          p("Open the strategy review page and read through each section."),
          img(),
          h2("Step 2: Review your strategy"),
          p(
            "Your marketing strategy explains what your company does, who it serves, and why it is different. Check whether the generated strategy clearly explains:",
          ),
          ul([
            "What your product or service is",
            "Who your ideal customers are",
            "What problem you solve",
            "Why your approach is different",
            "What category you want to own",
            "What outcomes customers get",
          ]),
          p(
            "Edit anything that feels too generic, too broad, inaccurate, or outdated. Your strategy becomes one of the key inputs Axy.digital uses when deciding how to frame campaigns, product pages, comparison content, LinkedIn posts, and X commentary.",
          ),
          img(),
          h2("Step 3: Review your channel plans"),
          p("Axy.digital generates channel-specific plans for:"),
          ul(["GEO / AEO / SEO", "LinkedIn", "X"]),
          p(
            "Each plan translates your overall strategy into a channel-specific execution plan. Review the content pillars in each channel plan. These help Axy.digital understand the themes your brand should own. Examples include:",
          ),
          ul([
            "AI visibility",
            "Market intelligence",
            "Founder-led growth",
            "Cybersecurity risk",
            "Legal compliance",
            "Real estate market trends",
            "Supply chain resilience",
            "Wellness education",
            "Product comparisons",
            "Customer education",
          ]),
          p(
            "Remove themes that are not relevant. Add themes you want Axy.digital to prioritize. These pillars influence future GEO content, LinkedIn posts, X threads, comparison pages, tutorials, and cross-channel campaigns.",
          ),
          img(
            msStep4,
            "LinkedIn channel plan in detail showing content pillar tags and publishing schedule with per-day pillar and time assignments",
          ),
          h2("Step 4: Review each channel plan in detail"),
          h3("GEO / AEO / SEO plan"),
          p(
            "This plan guides how Axy.digital creates content for Google, answer engines, and AI search. Review whether it includes the right:",
          ),
          ul([
            "Search themes",
            "Prompt clusters",
            "Customer questions",
            "Target topics",
            "Product pages to support",
            "Use-case opportunities",
            "Comparison opportunities",
            "Internal linking priorities",
            "Content formats",
            "Geographic or industry focus",
          ]),
          p(
            "Because Axy.digital indexes your website pages, it can suggest internal links from future GEO content to relevant product pages, use-case pages, tutorials, case studies, and comparison pages.",
          ),
          h3("LinkedIn plan"),
          p(
            "This plan guides how Axy.digital creates LinkedIn content for your founder profile, company page, or team accounts. Review whether it reflects:",
          ),
          ul([
            "Your target audience on LinkedIn",
            "Founder voice",
            "Company voice",
            "Thought leadership themes",
            "Product education themes",
            "Market commentary angles",
            "Content formats",
            "Posting style",
            "CTA preferences",
            "Topics to avoid",
          ]),
          p(
            "A strong LinkedIn plan helps Axy.digital turn market signals into content that feels timely, relevant, and aligned with your point of view.",
          ),
          h3("X plan"),
          p(
            "This plan guides how Axy.digital creates faster-moving commentary, posts, and threads. Review whether it reflects:",
          ),
          ul([
            "Your target audience on X",
            "Topics your market discusses there",
            "Founder or brand voice",
            "Short-form content style",
            "Thread opportunities",
            "Community or ecosystem narratives",
            "Product update formats",
            "Commentary angles",
            "Topics to avoid",
          ]),
          p(
            "X moves quickly, so this plan helps Axy.digital decide which signals are worth turning into short-form content and which ones to ignore.",
          ),
          img(
            msStep5,
            "Channel Content Guidelines with content length range, emoji and hashtag toggles, words-to-avoid chips and a custom guidelines text area",
          ),
          h2("Step 5: Configure channel guidelines"),
          p(
            "Axy.digital lets you set guidelines for each channel so generated content fits the way you want to show up. You can configure guidelines for GEO / AEO / SEO, LinkedIn, and X. For each channel, review or add preferences such as:",
          ),
          ul([
            "Preferred post or article length",
            "Writing style",
            "Tone of voice",
            "Words or phrases to avoid",
            "CTA preferences",
            "Formatting preferences",
            "Topics to prioritize",
            "Topics to avoid",
            "Level of technical depth",
            "Use of emojis",
            "Use of hashtags",
            "Use of first-person voice",
            "Whether content should be founder-led, brand-led, educational, opinionated, or product-led",
          ]),
          p(
            "For example, your LinkedIn guidelines might say: Write in a direct, founder-led voice. Keep posts between 120–180 words. Avoid hype, em dashes, and generic AI phrases like “game-changing” or “revolutionary.” Use clear hooks, short paragraphs, and practical takeaways.",
          ),
          p(
            "Your X guidelines might say: Keep posts sharp and concise. Avoid corporate language. Prioritize timely commentary, contrarian angles, and short threads. Do not overuse hashtags.",
          ),
          p(
            "Your GEO guidelines might say: Write clear, citation-worthy articles with structured headings, FAQs, internal links, and direct answers to high-intent questions. Avoid vague thought leadership and unsupported claims.",
          ),
          p(
            "You can update channel guidelines anytime. When you change them, future GEO content, LinkedIn posts, and X posts will follow the updated preferences.",
          ),
          img(),
          h2("Step 6: Approve your strategy and plans"),
          p(
            "Once your marketing strategy and channel plans are directionally accurate, approve them. Axy.digital will use the approved strategy and plans across the engine. You can still edit them later. When you update your strategy or plans, Axy.digital uses that updated context to improve future dashboards, recommendations, internal linking, and campaigns.",
          ),
          img(),
          h2("FAQ"),
          h3("Does everything need to be perfect?"),
          p(
            "No. Your strategy and channel plans do not need to be perfect to start using Axy.digital. They only need to be accurate enough for the engine to generate useful recommendations and content. You can come back later to refine positioning, ICP, voice, competitors, content pillars, channel plans, product details, market focus, uploaded resources, and website context. Axy.digital is designed to improve as your context improves.",
          ),
          h3("What happens when I edit the strategy later?"),
          p(
            "When you edit your marketing strategy or channel plans, those updates affect the entire engine. Future market intelligence, AI visibility recommendations, GEO articles, LinkedIn posts, X threads, and internal link suggestions will use the updated context. Your strategy should be treated as a living input, not a one-time setup task.",
          ),
          h3("How do channel plans differ from the main strategy?"),
          p(
            "Your main marketing strategy defines the overall direction. Your channel plans explain how that strategy should be translated into specific channels. The GEO plan focuses on search, AI discovery, prompt clusters, and internal linking. The LinkedIn plan focuses on thought leadership, audience education, and professional credibility. The X plan focuses on fast-moving commentary, ecosystem narratives, and short-form visibility. Together, they help Axy.digital generate content that fits each channel while staying aligned with your overall strategy.",
          ),
          img(),
          h2("Best practices"),
          h3("Review for direction, not perfection"),
          p("Get the strategy and plans directionally right first. You can refine them later."),
          h3("Be specific about your audience"),
          p(
            "“B2B companies” is less useful than “seed-stage cybersecurity startups selling to CISOs.”",
          ),
          h3("Add strong differentiation"),
          p(
            "If your product is faster, cheaper, more automated, more secure, or more specialized, make that clear.",
          ),
          h3("Define what not to say"),
          p(
            "Words and phrases to avoid help Axy.digital stay on-brand and avoid generic AI output.",
          ),
          h3("Keep your strategy current"),
          p(
            "When your messaging changes, update it in Axy.digital so future campaigns reflect the new direction.",
          ),
          h3("Review internal link suggestions before publishing"),
          p(
            "Axy.digital can recommend internal links based on your website index and strategy. Review them before publishing to make sure they are accurate and useful.",
          ),
          p(
            "Once your marketing strategy and channel plans are approved, your Engine is ready for core product workflows.",
          ),
        ],
        next: ["/tutorials/how-axy-generates-campaigns"],
      },
    ],
  },
  {
    title: "Core Product Tutorials",
    articles: [
      {
        slug: "how-axy-generates-campaigns",
        title: "How Axy.digital Generates Campaigns",
        metaTitle: "How Axy.digital Generates Campaigns | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital turns market signals, AI visibility gaps, search demand, and competitor updates into channel-ready campaign briefs and content.",
        category: "Core Product Tutorials",
        product: "Campaign Generation",
        difficulty: "Beginner",
        estimatedTime: "6 minutes",
        bestFor:
          "Users who want to understand how campaigns are suggested, generated, and added to the marketing calendar",
        intro:
          "Axy.digital does not wait for you to start from a blank page. Once your workspace is set up, Axy.digital continuously uses your market data, AI visibility insights, competitors, strategy, channel plans, and website context to suggest campaign briefs inside your workspace. You can review these campaign briefs under Proposed Briefs and click Generate on the campaigns you want to create. Axy.digital then generates channel-ready content and adds it to your marketing calendar.",
        blocks: [
          img(),
          h2("How campaign generation works"),
          p(
            "Axy.digital uses live and contextual data to identify campaign opportunities. These may come from:",
          ),
          ul([
            "A market intelligence signal",
            "An AI visibility gap",
            "A search demand opportunity",
            "A competitor update",
            "A social trend",
            "A news headline",
          ]),
          p(
            "Each signal is matched against your approved marketing strategy, channel plans, website index, competitors, and content guidelines. This means campaign ideas are not generic. They are suggested because Axy.digital has identified a relevant opportunity for your business.",
          ),
          img(hagcStep1, "Axy.digital market signals dashboard showing detected trends"),
          h2("Step 1: Axy.digital detects campaign opportunities"),
          p(
            "Axy.digital continuously looks for signals that may be worth turning into campaigns. These signals can include:",
          ),
          h3("Market intelligence signals"),
          p(
            "Trends, narratives, customer questions, or industry shifts gaining relevance in your market. Example: “AI search visibility is becoming a priority for B2B SaaS teams.”",
          ),
          h3("AI visibility gaps"),
          p(
            "Prompts where your brand is missing, under-cited, or being outranked by competitors in AI-generated answers. Example: “Best AI marketing tools for startups.”",
          ),
          h3("Search demand opportunities"),
          p(
            "Keywords, prompts, or questions that show customers are actively looking for answers. Example: “How to improve AI search visibility.”",
          ),
          h3("Competitor updates"),
          p(
            "New pages, product launches, positioning shifts, content campaigns, or visibility changes from competitors. Example: “A competitor is ranking for comparison keywords in your category.”",
          ),
          h3("Social trends"),
          p(
            "Topics, debates, or formats gaining traction across LinkedIn, X, or other relevant social channels. Example: “Founders are discussing whether agencies are becoming obsolete in the AI era.”",
          ),
          h3("News headlines"),
          p(
            "Timely industry news, regulation changes, product launches, funding announcements, or market events. Example: “A new regulation is changing how your target customers think about compliance.”",
          ),
          img(hagcStep2, "Proposed briefs review screen in Axy.digital workspace"),
          h2("Step 2: Axy.digital turns signals into proposed briefs"),
          p(
            "When Axy.digital identifies a relevant opportunity, it creates a campaign brief inside your workspace. You can find these in: Workspace → Proposed Briefs.",
          ),
          p(
            "Each proposed brief gives you a quick view of the campaign idea before generating content. A brief may include:",
          ),
          ul([
            "Campaign topic",
            "Source signal",
            "Target audience",
            "Recommended channel",
            "Suggested angle",
            "Why this campaign matters",
            "Relevant prompt or search opportunity",
            "Competitor context",
            "Suggested CTA",
            "Internal link opportunities",
            "Channel-specific format",
          ]),
          p(
            "These briefs are designed to help you quickly decide which campaigns are worth generating.",
          ),
          img(),
          h2("Step 3: Review proposed briefs"),
          p(
            "Open Proposed Briefs and review the campaigns Axy.digital has suggested. When reviewing a brief, ask:",
          ),
          ul([
            "Is this relevant to our audience?",
            "Does this align with our current strategy?",
            "Is the timing right?",
            "Does this support a product, use case, or market narrative we want to own?",
            "Is this useful for GEO, LinkedIn, X, or multiple channels?",
            "Does this help us respond to a competitor, trend, or AI visibility gap?",
          ]),
          p(
            "You do not need to build the campaign yourself. The brief already contains the strategic direction. Your job is to choose which opportunities you want Axy.digital to generate.",
          ),
          img(),
          h2("Step 4: Click Generate on campaigns you like"),
          p(
            "When you find a proposed brief you want to use, click Generate. Axy.digital will generate content based on:",
          ),
          ul([
            "The campaign brief",
            "Your approved marketing strategy",
            "Your channel-specific plans",
            "Your channel guidelines",
            "Your brand voice",
            "Your competitors",
            "Your knowledge base",
            "Your website index",
            "Relevant market signals",
            "Relevant AI visibility or search data",
          ]),
          p(
            "The generated campaign is already optimized for the selected channel. For example: GEO campaigns are structured for search, AI discovery, direct answers, FAQs, and internal links. LinkedIn campaigns are aligned with your LinkedIn voice, post length, content pillars, and thought leadership style. X campaigns are aligned with your X style, tone, format, thread preferences, and commentary guidelines.",
          ),
          img(
            hagcStep5,
            "Marketing calendar showing drafted, in-review, approved, and published content",
          ),
          h2("Step 5: Content is added to the marketing calendar"),
          p(
            "Once a campaign is generated, the content is populated in your Marketing Calendar. The calendar helps you see what is ready to publish across channels. Depending on your campaign, the calendar may show:",
          ),
          ul([
            "GEO articles",
            "LinkedIn posts",
            "X posts",
            "X threads",
            "Scheduled campaign assets",
            "Draft content",
            "Approved content",
            "Channel-specific publication dates",
          ]),
          p(
            "This gives you a central view of your upcoming marketing execution. Instead of managing campaigns across scattered docs, spreadsheets, and social tools, you can see your generated content in one place.",
          ),
          img(hagcStep6, "Generated blog content with content inputs panel in Axy.digital"),
          h2("Step 6: Review the generated content"),
          p(
            "After you click Generate, Axy.digital creates the campaign content. Depending on the brief, this may include:",
          ),
          ul([
            "GEO article",
            "AEO answer content",
            "SEO article",
            "LinkedIn post",
            "LinkedIn post variations",
            "X post",
            "X thread",
            "Campaign CTA",
            "Suggested internal links",
            "Supporting angles",
          ]),
          p("Review the generated content before publishing. Check:"),
          ul([
            "Is the content accurate?",
            "Is the angle strong?",
            "Does it match your strategy?",
            "Does it follow the channel plan?",
            "Does it follow your channel guidelines?",
            "Are the internal links relevant?",
            "Is the CTA correct?",
            "Does it sound like your brand?",
          ]),
          p("You can edit the content before approving it."),
          img(hagcStep7, "Status dropdown for approving and publishing content in Axy.digital"),
          h2("Step 7: Approve, schedule, or publish"),
          p(
            "From the marketing calendar, you can review campaign assets and decide what happens next. Depending on your setup, you may:",
          ),
          ul([
            "Approve content",
            "Schedule posts",
            "Publish content",
            "Export drafts",
            "Send content to your CMS",
            "Share with your team",
            "Save content for later",
          ]),
          p(
            "Axy.digital keeps the campaign connected to the original signal, strategy, and channel plan so you can track why it was generated and how it performs.",
          ),
          img(),
          h2("FAQ"),
          h3("Do I need to write the campaign brief myself?"),
          p(
            "No. Axy.digital generates campaign briefs automatically based on market intelligence, AI visibility gaps, search demand, competitor updates, social trends, and news headlines. You can review the proposed briefs and choose which ones to generate.",
          ),
          h3("Are campaigns already optimized for each channel?"),
          p(
            "Yes. Axy.digital uses your channel-specific plans and guidelines to generate content for each channel. That means a GEO campaign will not be written the same way as a LinkedIn post or X thread. Each asset is adapted to the channel, while staying aligned with your overall strategy.",
          ),
          h3("Can I edit a campaign after it is generated?"),
          p(
            "Yes. You can review and edit generated content before approving, scheduling, or publishing it. You can also update your strategy, channel plans, or guidelines later. Future campaigns will use the updated context.",
          ),
          h3("Where do generated campaigns go?"),
          p(
            "Generated campaign content is populated in your Marketing Calendar. From there, you can review, approve, schedule, publish, or export the content.",
          ),
          img(),
          h2("Best practices"),
          h3("Review Proposed Briefs regularly"),
          p(
            "Axy.digital is continuously surfacing campaign opportunities. Check Proposed Briefs as part of your weekly marketing workflow.",
          ),
          h3("Choose campaigns that match your current priorities"),
          p(
            "Not every campaign needs to be generated. Prioritize briefs that align with your audience, product focus, and growth goals.",
          ),
          h3("Use AI visibility gaps for GEO campaigns"),
          p(
            "If Axy.digital identifies prompts where your brand is missing, generate campaigns that help close those gaps.",
          ),
          h3("Use social trends for LinkedIn and X"),
          p(
            "If a topic is gaining traction socially, it may be a good fit for thought leadership, commentary, or short-form campaigns.",
          ),
          h3("Review internal links before publishing"),
          p(
            "Axy.digital suggests internal links based on your website index. Check that each link is relevant and useful for the reader.",
          ),
          h3("Keep your strategy and guidelines updated"),
          p(
            "The better your strategy and channel guidelines, the better your proposed briefs and generated campaigns will be.",
          ),
        ],
        next: [
          "/tutorials/read-your-market-intelligence-dashboard",
          "/tutorials/read-your-ai-visibility-report",
          "/tutorials/generate-a-geo-article",
          "/tutorials/use-the-marketing-calendar",
        ],
      },
      {
        slug: "read-your-market-intelligence-dashboard",
        title: "How to Read Your Market Intelligence Dashboard",
        metaTitle: "How to Read Your Market Intelligence Dashboard | Axy.digital Tutorial",
        metaDescription:
          "Learn how to use the Axy.digital Market Intelligence Dashboard to review signals, trends, and search demand, and turn insights into channel-ready campaigns.",
        category: "Core Product Tutorials",
        product: "Market Intelligence",
        difficulty: "Beginner",
        estimatedTime: "6 minutes",
        bestFor:
          "Users who want a high-level view of how Axy.digital turns market intelligence into campaigns",
        intro:
          "The Market Intelligence Dashboard shows what your market is reacting to, how narratives are evolving, and where search demand is creating content opportunities. This is the intelligence layer that powers everything downstream in Axy.digital. Instead of generating content from generic prompts, Axy.digital uses market signals, trends, search behavior, competitor movement, and AI visibility data to suggest campaign briefs inside your workspace. From there, you can review briefs in Workspace → Proposed Briefs, click Generate, and move generated content into your Marketing Calendar.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Selected competitors",
            "Reviewed your channel plans",
            "Added relevant resources to your knowledge base",
            "Added your website so Axy.digital can index your pages for internal linking",
          ]),
          p(
            "The dashboard becomes more useful as Axy.digital learns more about your company, market, competitors, and performance.",
          ),
          img(),
          h2("Step 1: Open the Market Intelligence Dashboard"),
          p("From your workspace, open Market Intelligence."),
          p("The dashboard is organized around three core sections:"),
          ul(["Signals", "Trends", "Search"]),
          p(
            "Each section helps Axy.digital understand a different part of your market. Together, they help the engine decide which campaigns are worth creating next.",
          ),
          img(
            midStep2,
            "Market Signals view with weekly summary, detected trends and key coverage",
          ),
          h2("Step 2: Review Signals"),
          p("The Signals section shows what your market is reacting to this week."),
          p("Signals are pulled from sources such as:"),
          ul(["News headlines", "Research", "LinkedIn", "X", "Competitor updates"]),
          p(
            "Signals help you understand what is creating urgency, attention, or conversation in your market right now.",
          ),
          p("Examples include:"),
          ul([
            "A new regulation affecting your industry",
            "A competitor launching a new product",
            "A research report changing buyer priorities",
            "A topic gaining traction on LinkedIn",
            "A debate emerging on X",
            "A new customer pain point appearing in market conversations",
          ]),
          p("You can also toggle to previous weeks to see how signals have evolved over time."),
          img(
            midStep3,
            "Market Trends evolution-over-time grid showing maturity stages across weeks",
          ),
          h2("Step 3: Review Trends"),
          p("The Trends section shows how topics evolve in your space."),
          p(
            "Instead of treating every signal as a one-off event, Axy.digital helps you understand whether a topic is becoming more important over time.",
          ),
          p("Trends can help you see whether a topic is:"),
          ul([
            "An early signal",
            "An emerging trend",
            "An established narrative",
            "A fading topic",
            "A recurring market concern",
          ]),
          p(
            "This helps you decide whether to act quickly, build authority, or create evergreen content.",
          ),
          img(midStep4, "Search Behavior page listing weekly keyword content opportunities"),
          h2("Step 4: Review Search"),
          p(
            "The Search section shows where demand exists and which content opportunities Axy.digital should prioritize.",
          ),
          p("Axy.digital identifies this week’s content opportunities based on:"),
          ul([
            "Search volume",
            "Keyword difficulty",
            "Search intent",
            "Monthly search volume trend",
            "Competitor ownership",
            "Realistic ranking and citation opportunities",
          ]),
          p(
            "Axy.digital uses this search intelligence to prioritize proposed briefs for GEO articles, AEO content, SEO articles, comparison pages, use-case pages, FAQs, LinkedIn posts, X threads, and full campaigns.",
          ),
          img(
            midStep5,
            "Proposed Briefs review page with blog, LinkedIn and Twitter tabs ready to generate",
          ),
          h2("Step 5: Review Proposed Briefs"),
          p(
            "The Market Intelligence Dashboard does not just surface insights. It turns insights into proposed campaign briefs.",
          ),
          p("A proposed brief can be based on:"),
          ul([
            "A market signal",
            "A trend gaining momentum",
            "A search demand opportunity",
            "An AI visibility gap",
            "A competitor update",
            "A social trend",
            "A news headline",
          ]),
          p(
            "Open Workspace → Proposed Briefs to review the campaign ideas Axy.digital has identified.",
          ),
          img(),
          h2("Step 6: Generate campaigns from intelligence"),
          p("When you find a brief you want to act on, click Generate."),
          p("Axy.digital uses:"),
          ul([
            "The source insight",
            "Your approved marketing strategy",
            "Your channel plans",
            "Your channel guidelines",
            "Your competitors",
            "Your knowledge base",
            "Your website index",
            "Your AI visibility data",
          ]),
          p(
            "Generated content is then moved into your Marketing Calendar for review, editing, approval, scheduling, publishing, or export.",
          ),
          img(),
          h2("FAQ"),
          h3("What is the Market Intelligence Dashboard for?"),
          p(
            "The Market Intelligence Dashboard helps you understand what your market is reacting to, how narratives are evolving, and where search demand is creating content opportunities. Axy.digital uses this intelligence to suggest campaign briefs.",
          ),
          h3("How is Market Intelligence different from a normal analytics dashboard?"),
          p(
            "Most analytics dashboards show what already happened. Axy.digital’s Market Intelligence Dashboard helps you decide what to create next based on market signals, trends, search demand, and competitor movement.",
          ),
          h3("Do I need to manually turn insights into content?"),
          p(
            "No. Axy.digital turns relevant insights into proposed briefs. You review the briefs and click Generate on the campaigns you want to create.",
          ),
          h3("Where does generated content go?"),
          p(
            "Generated content is added to your Marketing Calendar for review, editing, approval, scheduling, publishing, or export.",
          ),
          img(),
          h2("Best practices"),
          h3("Check the dashboard weekly"),
          p(
            "Use Market Intelligence as your weekly planning layer instead of starting from a blank content calendar.",
          ),
          h3("Review all three sections together"),
          p(
            "Signals show what is happening now. Trends show how topics are evolving. Search shows where demand exists.",
          ),
          h3("Prioritize briefs connected to demand"),
          p(
            "The strongest briefs are usually supported by market relevance, search demand, AI visibility gaps, or competitor movement.",
          ),
          h3("Keep your strategy updated"),
          p("Better strategy and channel guidelines lead to better campaign recommendations."),
        ],
        next: [
          "/tutorials/read-market-signals",
          "/tutorials/read-market-trends",
          "/tutorials/read-search-opportunities",
          "/tutorials/how-axy-generates-campaigns",
        ],
      },
      {
        slug: "read-market-signals",
        title: "How to Read Market Signals in Axy.digital",
        metaTitle: "How to Read Market Signals in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how to read weekly market signals in Axy.digital from news, research, LinkedIn, X, and competitor updates, and turn the strongest signals into campaigns.",
        category: "Core Product Tutorials",
        product: "Market Intelligence",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor: "Users who want to understand what their market is reacting to each week",
        intro:
          "The Signals section shows what is creating attention, urgency, or conversation in your market. Axy.digital pulls signals from news, research, LinkedIn, X, and competitor updates, then identifies which signals are relevant enough to become campaign opportunities. Use this section to understand what your audience is already reacting to and where your brand can add a useful point of view.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Selected competitors",
            "Reviewed your channel plans",
            "Added relevant resources to your knowledge base",
          ]),
          p(
            "Signals become more relevant when Axy.digital understands your market, audience, competitors, and positioning.",
          ),
          img(mkStep1, "Market Signals dashboard showing detected trends and weekly data points"),
          h2("Step 1: Open Signals"),
          p("From your Market Intelligence Dashboard, open the Signals section."),
          p(
            "This section gives you a weekly deep-dive analysis of what your market is reacting to.",
          ),
          p("Axy.digital pulls signals from:"),
          ul(["News headlines", "Research", "LinkedIn", "X", "Competitor updates"]),
          p(
            "Each signal represents something that could influence customer attention, buyer priorities, market narratives, or campaign opportunities.",
          ),
          img(),
          h2("Step 2: Review this week’s signals"),
          p("Start with the current week."),
          p("Review each signal and ask:"),
          ul([
            "Is this relevant to our audience?",
            "Is this connected to our product or category?",
            "Is this something our customers are already reacting to?",
            "Can we add a useful point of view?",
            "Does this support a campaign, article, or social post?",
            "Is this signal urgent, strategic, or recurring?",
          ]),
          p("Examples of signals include:"),
          ul([
            "A regulatory change",
            "A funding announcement",
            "A new research report",
            "A competitor launch",
            "A high-engagement LinkedIn discussion",
            "An X debate",
            "A customer pain point gaining attention",
            "A shift in category language",
          ]),
          img(mkStep3, "Market Signals header with the previous-week navigation arrow highlighted"),
          h2("Step 3: Toggle to previous weeks"),
          p(
            "You can toggle to previous weeks to review past signals. This helps you understand how topics have evolved over time.",
          ),
          p("Use previous weeks to see whether a topic is:"),
          ul([
            "A one-off spike",
            "An early signal",
            "An emerging trend",
            "An established narrative",
            "A recurring market concern",
            "A fading conversation",
          ]),
          p(
            "This is useful because not every signal deserves immediate action. Some signals are short-lived. Others repeat over time and become stronger campaign opportunities.",
          ),
          img(),
          h2("Step 4: Identify signal momentum"),
          p(
            "When reviewing signals across weeks, look for momentum. A signal is gaining momentum when it appears across multiple weeks, sources, or channels.",
          ),
          p("For example, a topic becomes more important when it appears in:"),
          ul([
            "News headlines",
            "Research reports",
            "LinkedIn posts",
            "X discussions",
            "Competitor content",
            "Search demand",
            "AI visibility gaps",
          ]),
          p("A signal with momentum is usually more valuable than a one-off mention."),
          img(),
          h2("Step 5: Decide whether the signal should become a campaign"),
          p("Not every signal needs a campaign. Prioritize signals that are:"),
          ul([
            "Relevant to your ICP",
            "Connected to your product",
            "Timely",
            "Supported by search demand",
            "Connected to an AI visibility gap",
            "Under-served by competitors",
            "Useful for thought leadership",
            "Strong enough to distribute across GEO, LinkedIn, or X",
          ]),
          p("Axy.digital turns the strongest signals into proposed briefs inside your workspace."),
          img(
            mkStep6,
            "Proposed Briefs page generated from market signals, ready to approve into campaigns",
          ),
          h2("Step 6: Review signal-based Proposed Briefs"),
          p(
            "When Axy.digital identifies a signal worth acting on, it creates a campaign brief in Workspace → Proposed Briefs.",
          ),
          p("The brief includes:"),
          ul([
            "Campaign topic",
            "Source signal",
            "Target audience",
            "Suggested angle",
            "Why the campaign matters",
            "Recommended channel",
            "Search or prompt opportunity",
            "Competitor context",
            "Suggested CTA",
            "Internal link opportunities",
          ]),
          p("Review the brief and click Generate if you want Axy.digital to create the campaign."),
          img(),
          h2("Step 7: Generate content from the signal"),
          p("When you click Generate, Axy.digital turns the signal into channel-ready content."),
          p("Depending on the opportunity, Axy.digital can generate:"),
          ul([
            "GEO articles",
            "AEO answer content",
            "SEO articles",
            "LinkedIn posts",
            "X posts",
            "X threads",
            "Founder commentary",
            "Product education posts",
            "Full cross-channel campaigns",
          ]),
          p("Generated content is added to your Marketing Calendar."),
          img(),
          h2("FAQ"),
          h3("What counts as a market signal?"),
          p(
            "A market signal is any event, trend, conversation, or competitor movement that could create a campaign opportunity. Examples include news headlines, research reports, social conversations, competitor updates, regulatory changes, and customer pain points.",
          ),
          h3("Why should I review previous weeks?"),
          p(
            "Reviewing previous weeks helps you see whether a signal is gaining momentum, repeating, fading, or becoming an established market narrative.",
          ),
          h3("Should I act on every signal?"),
          p(
            "No. Prioritize signals that are relevant to your audience, connected to your product, and useful for your current marketing goals.",
          ),
          h3("Where do signal-based campaigns appear?"),
          p(
            "Signal-based campaign ideas appear in Workspace → Proposed Briefs. Generated content appears in your Marketing Calendar.",
          ),
          img(),
          h2("Best practices"),
          h3("Look for recurring signals"),
          p("Recurring signals are often stronger than one-off spikes."),
          h3("Connect signals to your strategy"),
          p(
            "A signal is only useful if your company has a credible point of view or product connection.",
          ),
          h3("Act early on emerging topics"),
          p("Early signals can help you publish before a narrative becomes crowded."),
          h3("Use past signals to understand momentum"),
          p("Reviewing previous weeks helps you avoid chasing short-lived noise."),
          h3("Turn strong signals into cross-channel campaigns"),
          p("A strong signal can become a GEO article, LinkedIn post, X thread, or full campaign."),
        ],
        next: [
          "/tutorials/read-your-market-intelligence-dashboard",
          "/tutorials/read-market-trends",
          "/tutorials/turn-signals-into-campaigns",
          "/tutorials/how-axy-generates-campaigns",
        ],
      },
      {
        slug: "read-market-trends",
        title: "How to Read Market Trends in Axy.digital",
        metaTitle: "How to Read Market Trends in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital classifies trends as early signals, emerging trends, established narratives, fading topics, or recurring concerns.",
        category: "Core Product Tutorials",
        product: "Market Intelligence",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor:
          "Users who want to understand how topics evolve from early signals into market narratives",
        intro:
          "The Trends section shows how topics evolve in your market over time. Instead of treating every signal as a one-off update, Axy.digital helps you understand whether a topic is emerging, growing, becoming established, or fading. Use Trends to decide when to act quickly, when to build authority, and when to create evergreen content.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Selected competitors",
            "Reviewed your channel plans",
            "Added relevant resources to your knowledge base",
          ]),
          p(
            "Trends become more useful when Axy.digital understands your category, competitors, and audience.",
          ),
          img(
            mtStep1,
            "Market Trends page showing trend evolution over time across maturity stages",
          ),
          h2("Step 1: Open Trends"),
          p("From your Market Intelligence Dashboard, open the Trends section."),
          p("This section gives you a temporal view of how topics evolve in your space."),
          p("Axy.digital helps you understand whether a topic is:"),
          ul([
            "An early signal",
            "An emerging trend",
            "An established narrative",
            "A fading topic",
            "A recurring market concern",
          ]),
          p("This helps you decide what kind of content to create and how urgently to act."),
          img(),
          h2("Step 2: Understand early signals"),
          p(
            "Early signals are weak but potentially important signs that a topic is starting to form.",
          ),
          p("They can come from:"),
          ul([
            "Niche discussions",
            "Early research",
            "Small search changes",
            "Founder conversations",
            "First competitor mentions",
            "Early social traction",
            "New questions from customers",
          ]),
          p("Early signals are useful when you want to act before a topic becomes crowded."),
          p("They are often good for:"),
          ul([
            "Founder commentary",
            "X posts",
            "LinkedIn thought leadership",
            "Short exploratory content",
            "Early POV campaigns",
          ]),
          img(),
          h2("Step 3: Understand emerging trends"),
          p("Emerging trends are topics gaining traction across multiple sources."),
          p("A topic becomes more interesting when it appears across:"),
          ul([
            "News",
            "Research",
            "LinkedIn",
            "X",
            "Competitor content",
            "Search demand",
            "AI visibility gaps",
          ]),
          p(
            "Emerging trends are strong candidates for campaigns because the market is already paying attention, but the narrative is still forming.",
          ),
          p("They are often good for:"),
          ul([
            "GEO articles",
            "LinkedIn posts",
            "X threads",
            "Educational content",
            "Comparison content",
            "Product-led thought leadership",
          ]),
          img(),
          h2("Step 4: Understand established narratives"),
          p(
            "Established narratives are topics that are widely recognized in your market. These are no longer early conversations. They are part of how buyers understand the category.",
          ),
          p("Established narratives are useful for:"),
          ul([
            "Evergreen GEO content",
            "Use-case pages",
            "Comparison pages",
            "Tutorials",
            "Category pages",
            "Case studies",
            "Pillar content",
          ]),
          p(
            "If a topic is already established, your goal is usually to build authority, clarify differentiation, and create content that is easy to find and cite.",
          ),
          img(),
          h2("Step 5: Identify fading topics"),
          p(
            "Some topics lose momentum. A fading topic is one that no longer shows strong attention, search growth, or market relevance.",
          ),
          p(
            "You can still create content for a fading topic if it is strategically important, but it should not always be prioritized over growing opportunities.",
          ),
          p("Use fading topics to decide:"),
          ul([
            "What to stop prioritizing",
            "Which briefs to ignore",
            "Which content to refresh instead of creating from scratch",
            "Which narratives are no longer worth chasing",
          ]),
          img(),
          h2("Step 6: Decide how to act on a trend"),
          p("Different trend stages call for different actions."),
          p("Use this framework:"),
          ul([
            "Early signal: publish a fast POV or short social commentary.",
            "Emerging trend: generate a cross-channel campaign.",
            "Established narrative: create evergreen GEO content, comparison pages, tutorials, or use-case pages.",
            "Fading topic: deprioritize, refresh existing content, or monitor.",
            "Recurring concern: build a content cluster or recurring campaign angle.",
          ]),
          p("Axy.digital uses these trend patterns to prioritize proposed briefs."),
          img(
            mtStep7,
            "Briefs Review page showing trend-derived briefs ready to generate into campaigns",
          ),
          h2("Step 7: Generate campaigns from trends"),
          p(
            "When Axy.digital identifies a trend worth acting on, it creates a brief in Workspace → Proposed Briefs.",
          ),
          p("Review the brief and click Generate to create the campaign."),
          p("Axy.digital uses:"),
          ul([
            "The trend",
            "Your strategy",
            "Your channel plans",
            "Your channel guidelines",
            "Your competitors",
            "Your knowledge base",
            "Your website index",
            "Search and AI visibility data",
          ]),
          p("Generated content is moved to your Marketing Calendar."),
          img(),
          h2("FAQ"),
          h3("What is the difference between a signal and a trend?"),
          p(
            "A signal shows what your market is reacting to now. A trend shows how that topic is evolving over time.",
          ),
          h3("Why does trend stage matter?"),
          p(
            "Trend stage helps you decide what kind of content to create. Early signals are better for fast commentary. Established narratives are better for evergreen content and authority-building pages.",
          ),
          h3("Should I only act on emerging trends?"),
          p(
            "No. Emerging trends are often strong opportunities, but early signals and established narratives are useful for different reasons.",
          ),
          h3("Where do trend-based campaign ideas appear?"),
          p(
            "Trend-based campaign ideas appear in Workspace → Proposed Briefs. Generated content appears in your Marketing Calendar.",
          ),
          img(),
          h2("Best practices"),
          h3("Match content format to trend stage"),
          p(
            "Do not treat every trend the same. Early signals, emerging trends, and established narratives need different campaign strategies.",
          ),
          h3("Act early when your brand has a strong POV"),
          p(
            "Early signals can be powerful if you have a credible angle before competitors crowd the topic.",
          ),
          h3("Use established narratives for evergreen content"),
          p(
            "Established narratives are good for GEO content, tutorials, comparison pages, and use-case pages.",
          ),
          h3("Avoid chasing fading topics"),
          p(
            "If momentum is declining, make sure the topic still supports your strategy before creating new content.",
          ),
          h3("Watch recurring concerns"),
          p(
            "Recurring concerns often reveal durable customer pain points and strong content opportunities.",
          ),
        ],
        next: [
          "/tutorials/read-your-market-intelligence-dashboard",
          "/tutorials/read-market-signals",
          "/tutorials/turn-signals-into-campaigns",
          "/tutorials/how-axy-generates-campaigns",
        ],
      },
      {
        slug: "read-search-opportunities",
        title: "How to Read Search Trends in Axy.digital",
        metaTitle: "How to Read Search Trends in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital uses search volume, difficulty, intent, and competitor ownership to surface content opportunities and prioritize briefs.",
        category: "Core Product Tutorials",
        product: "Market Intelligence, GEO/AEO/SEO Autopilot",
        difficulty: "Beginner",
        estimatedTime: "8 minutes",
        bestFor:
          "Users who want to understand how Axy.digital uses search demand to prioritize content and campaigns",
        intro:
          "The Search section shows where demand exists in your market and which content opportunities Axy.digital should prioritize. Axy.digital analyzes keyword volume, difficulty, search intent, trend momentum, and competitor ownership to identify where your brand can realistically gain ground. This helps your content engine focus on opportunities with real demand, not random topics.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Selected competitors",
            "Reviewed your GEO / AEO / SEO plan",
            "Added your website so Axy.digital can index your pages",
            "Added relevant resources to your knowledge base",
          ]),
          p(
            "Search opportunities become more useful when Axy.digital understands your positioning, competitors, and current content.",
          ),
          img(ssStep1, "Search Behavior page listing this week's keyword content opportunities"),
          h2("Step 1: Open Search"),
          p("From your Market Intelligence Dashboard, open the Search section."),
          p(
            "This section gives you a weekly breakdown of search behavior in your industry. Axy.digital uses this data to identify content opportunities and prioritize which proposed briefs should be generated first.",
          ),
          img(
            ssStep2,
            "Search Behavior table with a keyword volume tooltip showing monthly searches",
          ),
          h2("Step 2: Review this week’s content opportunities"),
          p(
            "Axy.digital identifies this week’s content opportunities by finding keywords and prompts where your brand can realistically gain ground.",
          ),
          p("These opportunities are selected based on four main factors:"),
          ul(["Volume", "Difficulty", "Search intent", "Monthly search volume trend"]),
          p(
            "Axy.digital uses these keywords to prioritize what content to create next. This means search intelligence directly influences proposed briefs for GEO articles, AEO answer content, SEO articles, comparison pages, use-case pages, FAQs, LinkedIn posts, X threads, and full cross-channel campaigns.",
          ),
          img(),
          h2("Step 3: Understand volume"),
          p("Volume refers to average monthly search volume on Google."),
          p(
            "Axy.digital prioritizes keywords with enough demand to be worth acting on. Selected keywords are usually:",
          ),
          ul(["Medium volume", "High volume", "Very high volume"]),
          p(
            "This helps your content engine focus on topics people are already searching for. A keyword with no demand can still be strategically useful, but Axy.digital prioritizes opportunities with meaningful search activity.",
          ),
          img(),
          h2("Step 4: Understand difficulty"),
          p("Difficulty shows how hard it is to rank for a keyword. It is scored from 0–100."),
          p("Axy.digital prioritizes keywords that are realistic to compete for, including:"),
          ul(["Very easy keywords", "Easy keywords", "Medium-difficulty keywords"]),
          p(
            "This helps you avoid wasting effort on topics where entrenched competitors are too hard to displace immediately. The best opportunities often combine meaningful volume with realistic difficulty.",
          ),
          img(),
          h2("Step 5: Understand search intent"),
          p("Search intent explains what the user is trying to do."),
          p("Axy.digital classifies search intent as:"),
          ul([
            "Informational: the user wants to learn something.",
            "Commercial: the user is researching options.",
            "Transactional: the user is ready to take action.",
            "Navigational: the user is looking for a specific brand, site, or page.",
          ]),
          p("Each intent type supports different content. For example:"),
          ul([
            "Informational keywords can become tutorials, explainers, or GEO articles.",
            "Commercial keywords can become comparison pages, buyer guides, or use-case content.",
            "Transactional keywords can support product pages, pricing pages, or conversion-focused landing pages.",
            "Navigational keywords can reveal brand or competitor demand.",
          ]),
          img(),
          h2("Step 6: Review monthly search volume trend"),
          p(
            "Axy.digital selects keywords with an increasing trend. This means the topic is gaining search momentum.",
          ),
          p("In the dashboard, you can hover to see:"),
          ul(["Monthly trend", "Quarterly trend", "Yearly trend"]),
          p(
            "This helps you understand whether demand is growing temporarily or compounding over time. A keyword with increasing trend momentum is often a stronger opportunity than a flat or declining keyword.",
          ),
          img(
            ssStep7,
            "Industry Keyword Analysis dashboard with market coverage and competitor breakdown",
          ),
          h2("Step 7: Review Industry Keyword Analysis"),
          p("The Industry Keyword Analysis section maps your broader market keyword landscape."),
          p("It shows which keywords are:"),
          ul([
            "Owned by you",
            "Contested with competitors",
            "Owned by competitors",
            "Opportunities not owned by competitors",
          ]),
          p(
            "This helps you understand where your brand already has visibility, where competitors are ahead, and where open opportunities exist.",
          ),
          img(),
          h2("Step 8: Understand owned keywords"),
          p("Owned by you means your brand already has visibility for the keyword."),
          p("For owned keywords, consider whether you should:"),
          ul([
            "Strengthen the page with internal links",
            "Refresh the content",
            "Add FAQs",
            "Repurpose the topic into social posts",
            "Build supporting content",
            "Protect your position from competitors",
          ]),
          p("Owned keywords are not always “done.” They can often be strengthened."),
          img(),
          h2("Step 9: Understand contested keywords"),
          p(
            "Contested with competitors means you and competitors are both competing for visibility.",
          ),
          p("For contested keywords, consider whether you need:"),
          ul([
            "Stronger GEO content",
            "Better internal links",
            "Clearer differentiation",
            "Comparison content",
            "Use-case content",
            "A stronger CTA",
            "More specific examples or proof",
          ]),
          p(
            "Contested keywords are often good candidates for campaign briefs because they show real demand and competitive pressure.",
          ),
          img(),
          h2("Step 10: Understand competitor-owned keywords"),
          p("Owned by competitors means competitors have stronger visibility for the keyword."),
          p("For competitor-owned keywords, review:"),
          ul([
            "Which competitors are ranking or being cited",
            "What content type they use",
            "Whether they have comparison or use-case pages",
            "Whether third-party sources support them",
            "Whether your site has a relevant page",
            "Whether you can create a better answer",
          ]),
          p("These keywords can become strategic campaigns if the topic matters to your buyers."),
          img(),
          h2("Step 11: Understand unowned opportunities"),
          p(
            "Opportunities not owned by competitors are keywords with demand that competitors are not strongly owning yet. These can be valuable because the market opportunity exists, but the competitive landscape is more open.",
          ),
          p("For unowned opportunities, Axy.digital can prioritize briefs for:"),
          ul([
            "GEO articles",
            "SEO articles",
            "FAQ content",
            "Use-case pages",
            "Tutorials",
            "Social campaigns",
            "Full cross-channel campaigns",
          ]),
          p("These are often good places to gain ground early."),
          img(),
          h2("Step 12: Generate campaigns from search opportunities"),
          p(
            "When Axy.digital identifies a strong search opportunity, it creates a proposed brief.",
          ),
          p("Open Workspace → Proposed Briefs to review search-backed campaign ideas."),
          p("Each brief includes:"),
          ul([
            "Target topic",
            "Keyword or prompt opportunity",
            "Search intent",
            "Suggested angle",
            "Recommended channel",
            "Why the campaign matters",
            "Competitor context",
            "Suggested CTA",
            "Internal link opportunities",
          ]),
          p(
            "Click Generate to create the campaign. Generated content is moved to your Marketing Calendar.",
          ),
          img(),
          h2("FAQ"),
          h3("How does Axy.digital decide which keywords to prioritize?"),
          p(
            "Axy.digital prioritizes keywords based on volume, difficulty, search intent, monthly search trend, competitor ownership, and strategic relevance to your brand.",
          ),
          h3("What does keyword difficulty mean?"),
          p(
            "Keyword difficulty shows how hard it is to rank for a keyword on a 0–100 scale. Axy.digital prioritizes very easy, easy, and medium-difficulty keywords where your brand can realistically gain ground.",
          ),
          h3("Why does Axy.digital only select keywords with increasing trends?"),
          p(
            "Increasing trends show that demand is growing. Axy.digital prioritizes topics with upward momentum so your content can capture demand while it is forming.",
          ),
          h3("What is Industry Keyword Analysis?"),
          p(
            "Industry Keyword Analysis maps your market keyword landscape. It shows which keywords are owned by you, contested with competitors, owned by competitors, and open opportunities not owned by competitors.",
          ),
          h3("How does Search connect to campaign generation?"),
          p(
            "Axy.digital uses search opportunities to prioritize proposed briefs. Those briefs become GEO articles, AEO content, SEO articles, social posts, and full campaigns.",
          ),
          img(),
          h2("Best practices"),
          h3("Prioritize rising demand"),
          p("Focus on keywords and prompts with increasing search momentum."),
          h3("Balance volume and difficulty"),
          p("High-volume keywords are attractive, but realistic difficulty matters."),
          h3("Match content to intent"),
          p(
            "Informational, commercial, transactional, and navigational keywords need different content.",
          ),
          h3("Watch competitor-owned keywords"),
          p(
            "Competitor-owned keywords reveal where your brand may need better content or stronger positioning.",
          ),
          h3("Act early on unowned opportunities"),
          p("Open opportunities can help you gain ground before competitors dominate the topic."),
        ],
        next: [
          "/tutorials/read-your-market-intelligence-dashboard",
          "/tutorials/generate-a-geo-article",
          "/geo/use-prompt-clusters-to-plan-content",
          "/tutorials/how-axy-generates-campaigns",
        ],
      },
      {
        slug: "read-your-ai-visibility-report",
        title: "How to Read Your AI Visibility Report",
        metaTitle: "How to Read Your AI Visibility Report | Axy.digital Tutorial",
        metaDescription:
          "Learn how to read your AI Visibility Report: prompt-level visibility, mention rate, citation rate, competitor rankings, and monthly tracking.",
        category: "Core Product Tutorials",
        product: "AI Visibility Analytics",
        difficulty: "Beginner",
        estimatedTime: "10 minutes",
        bestFor:
          "Users measuring brand visibility across ChatGPT, Gemini, Perplexity, Claude, and AI search engines",
        intro:
          "Your AI Visibility Report shows whether your brand appears when people ask AI systems about your category, products, competitors, use cases, and customer problems. It helps you understand where your brand is mentioned, where your website is cited, which competitors appear more often, which prompts you are missing from, what sources AI systems are citing, what search queries LLMs use to surface answers, and what content you should create next. Use this report to improve your visibility across AI search and answer engines.",
        blocks: [
          p(
            "New to this? Start with [what AI visibility means](/geo/what-is-ai-visibility) for the definition and why it matters.",
          ),
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Selected competitors",
            "Added relevant website and knowledge base resources",
            "Generated or opened your AI Visibility Report",
          ]),
          p(
            "Your report is stronger when Axy.digital has accurate company context, competitor data, and search context.",
          ),
          img(
            avStep1,
            "AI Visibility Report Analytics tab with per-model mention and citation breakdowns",
          ),
          h2("Step 1: Open your AI Visibility Report"),
          p(
            "From your dashboard, open AI Visibility Analytics or your latest AI Visibility Report. When you open the report, it will already be populated with prompts generated for your brand. These prompts are based on:",
          ),
          ul([
            "Your approved marketing strategy",
            "Your positioning",
            "Your target audience",
            "Your competitors",
            "Search keyword trends",
            "Category demand",
            "Customer intent",
            "Axy.digital’s proprietary prompt-mapping framework",
          ]),
          p(
            "Axy.digital typically generates 89–100 prompts per brand, mapped across the full buyer journey. These prompts are structured around how users typically ask AI systems for recommendations, comparisons, explanations, and buying guidance.",
          ),
          img(avStep2, "Prompt Performance table with the AI model selector dropdown open"),
          h2("Step 2: Understand how prompts are mapped"),
          p("Axy.digital maps prompts across the funnel:"),
          h3("TOFU: Top of funnel"),
          p("These prompts capture early-stage awareness and education. Examples:"),
          ul([
            "“What is AI visibility?”",
            "“How does GEO differ from SEO?”",
            "“Why are companies using AI for marketing?”",
          ]),
          p(
            "TOFU prompts help you understand whether your brand appears in broad educational conversations.",
          ),
          h3("MOFU: Middle of funnel"),
          p("These prompts capture comparison, category, and solution research. Examples:"),
          ul([
            "“Best AI marketing tools for startups”",
            "“AI tools for improving search visibility”",
            "“How to choose a GEO platform”",
          ]),
          p(
            "MOFU prompts show whether your brand appears when users are actively comparing approaches, tools, or categories.",
          ),
          h3("BOFU: Bottom of funnel"),
          p(
            "These prompts capture high-intent buying and competitor comparison behavior. Examples:",
          ),
          ul([
            "“Axy.digital vs Jasper”",
            "“Best alternative to SEO agencies”",
            "“Which AI marketing platform should I use for B2B SaaS?”",
          ]),
          p(
            "BOFU prompts help you understand whether your brand appears when buyers are close to making a decision.",
          ),
          img(
            avStep3,
            "AI Visibility Report Overview tab with weekly summary and trend charts over time",
          ),
          h2("Step 3: Review monthly visibility"),
          p(
            "AI visibility is measured monthly. Each month, Axy.digital checks your selected prompt set across AI systems and tracks how visibility changes over time. Monthly tracking helps you see:",
          ),
          ul([
            "Whether your brand is becoming more visible",
            "Whether competitors are gaining or losing visibility",
            "Which prompts are improving",
            "Which prompts still need content",
            "Whether new GEO content is helping",
            "Whether your citation rate is changing",
          ]),
          p(
            "Your first report creates a baseline. Future reports show whether your AI visibility is improving.",
          ),
          img(
            avStep4,
            "AI Search Visibility cards comparing ChatGPT, Perplexity, Gemini and Claude with the model selector open",
          ),
          h2("Step 4: Review visibility across AI systems"),
          p("Axy.digital measures mentions and citations for each prompt across:"),
          ul(["ChatGPT", "Gemini", "Perplexity", "Claude"]),
          p(
            "For every prompt, Axy.digital checks whether your brand appears, whether your website is cited, which competitors are mentioned, and which sources are used. Your visibility may vary by platform. For example, you may be visible in Perplexity but not in Claude, or cited in Gemini but only mentioned in ChatGPT. This breakdown helps you understand where your brand is strongest and where more content or authority may be needed.",
          ),
          img(),
          h2("Step 5: Understand mention rate"),
          p(
            "Mention rate shows how often your brand is mentioned in AI-generated answers across the tracked prompts. For example, if Axy.digital tracks 100 prompts and your brand appears in 20 of the answers, your mention rate is 20%. Mention rate helps you understand whether AI systems recognize your brand as relevant to your category. A low mention rate may mean:",
          ),
          ul([
            "Your website does not clearly cover the topic",
            "Competitors have stronger content",
            "Your brand is not associated strongly enough with the category",
            "Your content is not structured for AI retrieval",
            "There are not enough credible sources connecting your brand to the topic",
          ]),
          img(),
          h2("Step 6: Understand citation rate"),
          p(
            "Citation rate shows how often AI systems cite your website as a source. This is different from being mentioned. A brand can be mentioned without being cited. Citation rate helps you understand whether AI systems are using your pages as supporting sources. A low citation rate may mean:",
          ),
          ul([
            "Your content is not specific enough",
            "Your pages lack clear structure",
            "Your articles do not answer high-intent questions directly",
            "Your site needs stronger topical authority",
            "You need more citation-worthy pages",
            "Your internal linking structure needs improvement",
          ]),
          p(
            "For GEO, citation rate is especially important because it shows whether your content is being used as a source in AI answers.",
          ),
          img(
            avStep7,
            "Citations Analysis split into First-Party and Third-Party citation domain tables",
          ),
          h2("Step 7: Understand first-party and third-party citations"),
          p("Axy.digital tracks both first-party and third-party citations."),
          h3("First-party citations"),
          p(
            "First-party citations are citations to your own website URL. These show when AI systems use your website as a source. Examples may include:",
          ),
          ul([
            "Your homepage",
            "Product pages",
            "Use-case pages",
            "Blog posts",
            "Tutorials",
            "Case studies",
            "Comparison pages",
            "Documentation",
          ]),
          p(
            "First-party citations are important because they show that AI systems are retrieving and trusting your own content.",
          ),
          h3("Third-party citations"),
          p("Third-party citations are citations to URLs that are not yours. These may include:"),
          ul([
            "Media articles",
            "Directories",
            "Review sites",
            "Partner pages",
            "Research reports",
            "Community pages",
            "Industry publications",
            "Competitor pages",
            "Customer mentions",
            "Social or public profile pages",
          ]),
          p(
            "The third-party citation list is useful because it shows which external sources AI systems are relying on to answer prompts in your category. You can also use this list as a resource when sourcing backlinks, partnerships, directory placements, PR opportunities, or third-party mentions. If a source is frequently cited in your category but does not mention your brand, that may be an opportunity.",
          ),
          img(
            avStep8,
            "Expanded prompt row showing the LLM search queries used and the source domains cited",
          ),
          h2("Step 8: Review LLM web search queries"),
          p(
            "Axy.digital also measures the queries that LLMs use when they perform a web search to surface answers. This helps you understand how AI systems are looking for information about your category. Review these queries to identify:",
          ),
          ul([
            "Search terms AI systems associate with your category",
            "Query patterns that surface competitors",
            "Topics where your site is missing",
            "Content gaps you can address",
            "Pages that may need clearer structure",
            "Opportunities for GEO, AEO, or SEO content",
          ]),
          p(
            "These queries are useful because they show not only the final AI answer, but part of the retrieval path behind the answer.",
          ),
          img(
            avStep9,
            "AI Mentions Comparison bar chart ranking your brand against competitors across AI assistants",
          ),
          h2("Step 9: Review competitor visibility and rank"),
          p(
            "Your AI Visibility Report also identifies competitor visibility. Axy.digital compares your brand against selected competitors and shows how each company ranks across the prompt set. Review:",
          ),
          ul([
            "Which competitors appear most often",
            "Which competitors are cited most often",
            "Which prompts competitors own",
            "Which competitors rank above you",
            "Which LLMs favor which competitors",
            "Which sources are helping competitors appear",
            "Where your brand has an opportunity to displace them",
          ]),
          p(
            "Competitor visibility is useful because AI answers often shape buyer shortlists before buyers reach your website. If competitors are consistently mentioned or cited for important prompts, those prompts may become priority campaign opportunities.",
          ),
          img(
            avStep10,
            "ChatGPT Response modal showing the full assistant answer with cited sources for a prompt",
          ),
          h2("Step 10: Review prompt-level visibility"),
          p(
            "Prompt-level visibility shows how your brand performs on each individual prompt. Review prompts where:",
          ),
          ul([
            "Your brand appears",
            "Your website is cited",
            "Competitors appear",
            "Competitors are cited",
            "Your brand is missing",
            "AI answers include outdated or incomplete information",
            "Third-party sources dominate the citations",
          ]),
          p(
            "This section helps you understand what buyers may see when they ask AI systems questions about your category. Useful prompt types include:",
          ),
          ul([
            "Category prompts",
            "Use-case prompts",
            "Comparison prompts",
            "Alternative prompts",
            "Problem prompts",
            "Local or regional prompts",
            "Industry-specific prompts",
            "Buying-intent prompts",
          ]),
          img(),
          h2("Step 11: Review recommended actions"),
          p("Axy.digital turns AI visibility gaps into recommended actions. These may include:"),
          ul([
            "Create a GEO article",
            "Add or update an FAQ section",
            "Create a comparison page",
            "Create a use-case page",
            "Refresh an existing article",
            "Strengthen internal links",
            "Add clearer product explanations",
            "Create content for a missing prompt cluster",
            "Generate LinkedIn or X content around a visibility gap",
            "Target third-party citation opportunities",
            "Build backlinks from sources AI systems already cite",
          ]),
          p(
            "Axy.digital uses your website index to suggest where new content should link internally.",
          ),
          img(),
          h2("Step 12: Generate a campaign from a visibility gap"),
          p(
            "If you find an important prompt where your brand is missing, generate a campaign from that gap. Axy.digital can turn the gap into:",
          ),
          ul([
            "GEO article",
            "AEO answer content",
            "LinkedIn posts",
            "X posts or threads",
            "Comparison content",
            "Internal linking recommendations",
          ]),
          p(
            "This is one of the most direct ways to improve AI visibility over time. Generated content will be added to your marketing calendar for review, approval, scheduling, or publishing.",
          ),
          img(),
          h2("FAQ"),
          h3("Where do the prompts come from?"),
          p(
            "Axy.digital generates prompts based on your marketing strategy, positioning, competitors, search keyword trends, and category demand. The prompts are mapped across TOFU, MOFU, and BOFU using Axy.digital’s proprietary framework for how users typically write prompts when researching, comparing, and choosing solutions.",
          ),
          h3("What is the difference between mention rate and citation rate?"),
          p(
            "Mention rate tells you how often your brand appears in AI answers. Citation rate tells you how often your website is used as a source. Both matter. Mention rate shows brand presence. Citation rate shows source authority.",
          ),
          h3("What is the difference between first-party and third-party citations?"),
          p(
            "First-party citations are citations to your own website. Third-party citations are citations to any other URL. First-party citations show whether AI systems are using your content directly. Third-party citations show which external sources influence AI answers in your category. The third-party citation list can help you identify backlink, PR, directory, partnership, and authority-building opportunities.",
          ),
          h3("Why is my AI visibility low?"),
          p(
            "Low visibility is common at the start. It may happen because your site does not cover enough high-intent prompts, your content is not structured clearly, competitors have stronger pages, your brand is new or under-cited, your website lacks comparison, use-case, or educational content, AI systems do not yet associate your brand with the category, or third-party sources in your category do not mention your brand. Use the report to find the highest-priority gaps.",
          ),
          h3("How often is AI visibility measured?"),
          p(
            "AI visibility is measured monthly. Monthly tracking gives you enough time to publish content, build authority, and see whether your visibility is improving across prompts and AI systems.",
          ),
          img(),
          h2("Best practices"),
          h3("Treat the first report as your baseline"),
          p(
            "Your first report shows where you are starting from. The goal is to improve over time.",
          ),
          h3("Focus on high-intent prompts"),
          p("Prioritize prompts that are close to buyer research or decision-making."),
          h3("Review competitor rankings"),
          p(
            "If competitors rank above you for important prompts, use those prompts to guide GEO content, comparison pages, and social campaigns.",
          ),
          h3("Create citation-worthy content"),
          p(
            "Direct answers, structured headings, FAQs, internal links, and clear product explanations can help AI systems understand and retrieve your content.",
          ),
          h3("Use third-party citations strategically"),
          p(
            "Look at which external sources AI systems cite often. These sources may reveal backlink, PR, directory, or partnership opportunities.",
          ),
          h3("Turn gaps into campaigns"),
          p("The report is most useful when you act on it."),
        ],
        next: [
          "/geo/turn-ai-visibility-gaps-into-geo-content",
          "/tutorials/generate-a-geo-article",
          "/tutorials/how-axy-generates-campaigns",
        ],
      },
      {
        slug: "generate-a-geo-article",
        title: "How to Generate a GEO Article in Axy.digital",
        metaTitle: "How to Generate a GEO Article in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital generates GEO articles from proposed briefs, AI visibility gaps, search demand, prompt clusters, and market signals.",
        category: "Core Product Tutorials",
        product: "GEO, AEO & SEO Autopilot",
        difficulty: "Beginner",
        estimatedTime: "8 minutes",
        bestFor: "Users creating content for Google, answer engines, and AI search visibility",
        intro:
          "Axy.digital helps you generate GEO articles from the signals already detected inside your workspace. Instead of starting with a blank brief, Axy.digital suggests article opportunities based on market intelligence, AI visibility gaps, search demand, competitor updates, social trends, and news headlines. These opportunities appear as campaign briefs in Workspace → Proposed Briefs. When you see a GEO article brief you want to create, click Generate. Axy.digital creates the article, moves it to your Marketing Calendar, and lets you review, edit, approve, schedule, publish, or export it from there.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Reviewed your GEO / AEO / SEO plan",
            "Configured your GEO guidelines",
            "Selected competitors",
            "Added relevant resources to your knowledge base",
            "Added your website so Axy.digital can index your pages for internal linking",
          ]),
          p(
            "Your GEO output is strongest when Axy.digital has accurate strategy, clear channel guidelines, and a well-populated knowledge base.",
          ),
          img(geoArtStep1, "Proposed briefs review with GEO article suggestions"),
          h2("Step 1: Open Proposed Briefs"),
          p(
            "Go to your workspace and open Proposed Briefs. This is where Axy.digital surfaces campaign ideas it has already identified for your brand.",
          ),
          p("A GEO article brief can be generated from:"),
          ul([
            "An AI visibility gap",
            "A search demand opportunity",
            "A prompt cluster",
            "A competitor update",
            "A market intelligence signal",
            "A social trend",
            "A news headline",
            "A customer question",
          ]),
          p(
            "Each brief appears because Axy.digital has identified a relevant opportunity for your business.",
          ),
          img(),
          h2("Step 2: Review the GEO article brief"),
          p("Open the GEO article brief you want to review. The brief includes:"),
          ul([
            "Article topic",
            "Source signal",
            "Target audience",
            "Search or prompt opportunity",
            "Funnel stage",
            "Suggested angle",
            "Why the article matters",
            "Relevant competitors",
            "Suggested CTA",
            "Internal link opportunities",
          ]),
          p("Use the brief to decide whether the article is worth generating. Ask:"),
          ul([
            "Is this topic relevant to our ICP?",
            "Is there clear search or prompt demand?",
            "Does it support our positioning?",
            "Does it help us improve AI visibility?",
            "Does it support a product page, use-case page, or comparison page?",
            "Is this a topic we can credibly own?",
          ]),
          img(),
          h2("Step 3: Review the prompt and search opportunity"),
          p(
            "Axy.digital connects the article brief to prompt clusters or search demand. These prompts come from your AI Visibility Report, search trends, and Axy.digital’s proprietary prompt framework. Prompts are mapped across:",
          ),
          ul([
            "TOFU: awareness and education",
            "MOFU: category and solution research",
            "BOFU: buying and comparison intent",
          ]),
          p("For example, a GEO article can target prompts like:"),
          ul([
            "“What is AI visibility?”",
            "“How does GEO differ from SEO?”",
            "“Best AI marketing tools for startups”",
            "“How to get cited by ChatGPT”",
            "“Axy.digital vs traditional marketing agency”",
          ]),
          p(
            "This helps the article answer real questions people ask across Google, ChatGPT, Gemini, Perplexity, Claude, and other AI search experiences.",
          ),
          img(),
          h2("Step 4: Click Generate"),
          p(
            "If the brief looks useful, click Generate. Axy.digital generates the GEO article using:",
          ),
          ul([
            "The proposed brief",
            "Your approved marketing strategy",
            "Your GEO / AEO / SEO plan",
            "Your GEO channel guidelines",
            "Your brand voice",
            "Your knowledge base",
            "Your competitor context",
            "Your AI visibility data",
            "Your market intelligence signals",
            "Your website index",
          ]),
          p(
            "The article is automatically optimized for the GEO channel. It is structured for search, answer engines, AI retrieval, citation, and internal linking.",
          ),
          p("Once generated, the article is added to your Marketing Calendar."),
          img(geoArtStep5, "Generated GEO article shown in the marketing calendar"),
          h2("Step 5: Open the article in your Marketing Calendar"),
          p(
            "Go to your Marketing Calendar to view the generated article. From the calendar, you can:",
          ),
          ul([
            "Open the article draft",
            "Review the full article",
            "Edit the content",
            "Approve it",
            "Schedule it",
            "Export it",
            "Move it into your CMS or publishing workflow",
          ]),
          p(
            "The article remains connected to the original brief, source signal, and channel plan, so you can understand why it was generated.",
          ),
          img(geoArtStep6, "Generated GEO article draft with content inputs panel"),
          h2("Step 6: Review the generated article"),
          p("Review the article before publishing. Check:"),
          ul([
            "Is the article accurate?",
            "Does it answer the target question clearly?",
            "Is the structure easy to scan?",
            "Are the claims supported?",
            "Is the angle aligned with your strategy?",
            "Does it match your GEO guidelines?",
            "Is the CTA correct?",
            "Are competitor references fair and accurate?",
            "Are the internal links useful?",
          ]),
          p(
            "GEO content should be clear, specific, and easy for both readers and AI systems to understand. Avoid vague thought leadership that does not directly answer the question.",
          ),
          img(geoArtStep7, "AI edit modal for refining selected text inside an article"),
          h2("Step 7: Make AI edits"),
          p(
            "You can use AI edits to quickly improve specific sections of the article. To make an AI edit:",
          ),
          ul([
            "Highlight the section of text you want to change.",
            "Click the AI Edit button that appears.",
            "Write your edit instruction.",
            "Review the updated text.",
            "Accept the change if it looks right.",
          ]),
          p("You can use AI edits to:"),
          ul([
            "Make a section shorter",
            "Make a paragraph more direct",
            "Add more technical detail",
            "Simplify the language",
            "Rewrite in your brand voice",
            "Add a stronger example",
            "Make the CTA clearer",
            "Make the introduction sharper",
            "Turn a paragraph into bullets",
            "Make the section more founder-led, educational, or product-led",
          ]),
          p("Example instructions:"),
          ul([
            "Make this section more direct and remove generic phrasing.",
            "Add a clearer example for a B2B SaaS audience.",
            "Rewrite this paragraph in a more confident founder-led tone.",
            "Shorten this section and make it easier to scan.",
          ]),
          p("AI edits let you refine the article without rewriting the whole draft manually."),
          img(geoArtStep8, "Adding internal links inside a generated GEO article"),
          h2("Step 8: Review internal links"),
          p(
            "Axy.digital indexes your website pages during onboarding and uses that index to recommend internal links in generated content. Your GEO article includes suggested links to:",
          ),
          ul([
            "Product pages",
            "Use-case pages",
            "Comparison pages",
            "Tutorials",
            "Case studies",
            "Existing blog posts",
            "Documentation",
            "Resource pages",
          ]),
          p("For example, an article about AI visibility can suggest links to:"),
          ul([
            "Your AI Visibility Analytics product page",
            "A tutorial on how to read an AI Visibility Report",
            "A case study about increasing AI visibility",
            "A comparison page against a GEO platform",
            "A related article on citation share",
          ]),
          p(
            "Review these links before publishing to make sure they are accurate, useful, and strategically relevant.",
          ),
          img(geoArtStep9, "Status dropdown for approving and publishing a GEO article"),
          h2("Step 9: Approve, schedule, publish, or export"),
          p(
            "Once the article is ready, use the Marketing Calendar to move it through your publishing workflow. You can:",
          ),
          ul([
            "Approve the article",
            "Schedule it",
            "Publish it",
            "Export it",
            "Move it into your CMS",
            "Save it for later",
          ]),
          p(
            "Use the calendar to manage your GEO content alongside LinkedIn posts, X posts, threads, custom campaigns, and other generated assets.",
          ),
          img(geoArtStep10, "GEO article repurposed into an X post inside the marketing calendar"),
          h2("Step 10: Repurpose the article into LinkedIn and X"),
          p(
            "A strong GEO article can also become social content. Axy.digital can turn the article into:",
          ),
          ul([
            "LinkedIn posts",
            "X posts",
            "X threads",
            "Founder commentary",
            "Product education posts",
            "Follow-up campaign angles",
          ]),
          p(
            "This helps distribute the same idea across multiple channels and reinforces the topic with your audience.",
          ),
          img(),
          h2("FAQ"),
          h3("What makes GEO content different from SEO content?"),
          p(
            "SEO content is usually optimized for search engines. GEO content is optimized for AI-generated answers, retrieval, citation, and recommendation.",
          ),
          p(
            "Good GEO content answers questions directly, uses clear headings, includes specific examples, adds FAQs where useful, links to relevant internal pages, is easy to summarize, builds topical authority, and supports AI citation and retrieval.",
          ),
          h3("Do I need to write the article brief myself?"),
          p(
            "No. Axy.digital suggests GEO article briefs automatically based on market intelligence, AI visibility gaps, search demand, competitor updates, social trends, and news headlines. You only need to review the brief and click Generate when you want to create the article.",
          ),
          h3("Where does the generated article go?"),
          p(
            "Generated GEO articles are added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export the content.",
          ),
          h3("Can I edit the article with AI?"),
          p(
            "Yes. Highlight the section of text you want to edit, click AI Edit, and write instructions for how you want the text changed.",
          ),
          h3("Do I need to approve the article before publishing?"),
          p(
            "Yes. You should review and approve the article before publishing, especially for claims, competitor references, CTAs, and internal links.",
          ),
          img(),
          h2("Best practices"),
          h3("Choose briefs with clear demand"),
          p(
            "Prioritize GEO briefs connected to AI visibility gaps, rising search demand, or high-intent customer questions.",
          ),
          h3("Review the brief before generating"),
          p(
            "The brief controls the direction of the article. Make sure the angle is useful before generating.",
          ),
          h3("Edit specific sections with AI edits"),
          p(
            "Use AI edits when a section needs to be sharper, shorter, more technical, more on-brand, or easier to scan.",
          ),
          h3("Answer the prompt directly"),
          p("AI systems and readers both benefit from clear, direct answers."),
          h3("Review internal links"),
          p("Internal links help each article support your wider content architecture."),
          h3("Repurpose strong articles"),
          p("Turn GEO content into LinkedIn posts, X threads, and follow-up campaigns."),
        ],
        next: [
          "/tutorials/read-your-ai-visibility-report",
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/generate-linkedin-posts",
          "/tutorials/use-the-marketing-calendar",
        ],
      },
      {
        slug: "generate-linkedin-posts",
        title: "How to Generate LinkedIn Posts in Axy.digital",
        metaTitle: "How to Generate LinkedIn Posts in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital generates LinkedIn posts from proposed briefs, market signals, AI visibility gaps, GEO articles, and social trends.",
        category: "Core Product Tutorials",
        product: "LinkedIn Autopilot",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor: "Founders, marketers, agencies, and teams creating LinkedIn content",
        intro:
          "Axy.digital helps you generate LinkedIn posts from campaign briefs already suggested inside your workspace. Instead of manually deciding what to post, Axy.digital uses market intelligence signals, AI visibility gaps, search demand, competitor updates, social trends, news headlines, product updates, and your approved strategy to suggest LinkedIn-ready content opportunities. These opportunities appear as campaign briefs in Workspace → Proposed Briefs. When you see a LinkedIn brief you want to create, click Generate. Axy.digital creates the post, moves it to your Marketing Calendar, and lets you review, edit, approve, schedule, publish, or export it from there.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Reviewed your LinkedIn plan",
            "Configured your LinkedIn guidelines",
            "Connected or added your LinkedIn channel",
            "Added founder voice or company voice context where relevant",
            "Selected competitors",
            "Added relevant resources to your knowledge base",
          ]),
          p("Your LinkedIn output is strongest when your channel guidelines are specific."),
          p(
            "For example, define preferred post length, tone, writing style, words to avoid, CTA preferences, and whether posts should be founder-led, brand-led, educational, opinionated, or product-led.",
          ),
          img(liStep1, "Proposed briefs review screen with LinkedIn briefs in Axy.digital"),
          h2("Step 1: Open Proposed Briefs"),
          p(
            "Go to your workspace and open Proposed Briefs. This is where Axy.digital surfaces campaign ideas it has already identified for your brand.",
          ),
          p("A LinkedIn brief can be generated from:"),
          ul([
            "A market intelligence signal",
            "A social trend",
            "A news headline",
            "An AI visibility gap",
            "A search demand opportunity",
            "A competitor update",
            "A GEO article",
            "A product update",
            "A case study",
            "A weekly recommendation",
          ]),
          p(
            "Each brief appears because Axy.digital has identified a relevant opportunity for your business.",
          ),
          img(),
          h2("Step 2: Review the LinkedIn brief"),
          p("Open the LinkedIn brief you want to review. The brief includes:"),
          ul([
            "Post topic",
            "Source signal",
            "Target audience",
            "Suggested angle",
            "Recommended voice",
            "Content pillar",
            "CTA",
            "Why this post matters",
            "Related campaign or article",
          ]),
          p("Use the brief to decide whether the post is worth generating. Ask:"),
          ul([
            "Is this relevant to our audience?",
            "Does it fit our LinkedIn voice?",
            "Is the idea timely or useful?",
            "Does it support our positioning?",
            "Should this feel more founder-led or brand-led?",
            "Does it connect to a broader campaign?",
          ]),
          p(
            "You do not need to choose the post format manually. Axy.digital automatically generates the right LinkedIn format based on the brief, your strategy, your LinkedIn plan, and your channel guidelines.",
          ),
          img(),
          h2("Step 3: Click Generate"),
          p(
            "If the brief looks useful, click Generate. Axy.digital generates LinkedIn content using:",
          ),
          ul([
            "The proposed brief",
            "Your approved marketing strategy",
            "Your LinkedIn plan",
            "Your LinkedIn guidelines",
            "Your brand voice",
            "Founder voice if added",
            "Your knowledge base",
            "The source signal or campaign context",
            "Previous performance data where available",
          ]),
          p("Axy.digital automatically chooses the right format for LinkedIn. This can include:"),
          ul([
            "Founder thought leadership",
            "Company updates",
            "Educational posts",
            "Market commentary",
            "Product-led posts",
            "Case study posts",
            "Launch content",
            "Campaign extensions",
          ]),
          p(
            "The post is automatically optimized for LinkedIn based on your configured guidelines. Once generated, the post is added to your Marketing Calendar.",
          ),
          img(liStep4, "Marketing calendar showing generated LinkedIn posts"),
          h2("Step 4: Open the post in your Marketing Calendar"),
          p(
            "Go to your Marketing Calendar to view the generated LinkedIn post. From the calendar, you can:",
          ),
          ul([
            "Open the post draft",
            "Review the content",
            "Edit the content",
            "Approve it",
            "Schedule it",
            "Publish it",
            "Export it",
            "Save it for later",
          ]),
          p(
            "If the LinkedIn post is part of a larger campaign, the calendar shows it alongside related GEO articles, X posts, or threads.",
          ),
          img(liStep5, "Generated LinkedIn post draft preview in Axy.digital"),
          h2("Step 5: Review the generated post"),
          p("Review the post before publishing. Check:"),
          ul([
            "Does it sound like your founder, brand, or company page?",
            "Is the hook strong?",
            "Is the idea specific?",
            "Is the length right?",
            "Does it follow your LinkedIn guidelines?",
            "Does it avoid banned words or phrases?",
            "Is the CTA appropriate?",
            "Does it connect clearly to the campaign or signal?",
            "Does it sound useful rather than generic?",
          ]),
          p("Edit anything that feels too broad, too polished, too vague, or too AI-generated."),
          img(liStep6, "Edit selected text modal for AI edits on a LinkedIn post"),
          h2("Step 6: Make AI edits"),
          p(
            "You can use AI edits to quickly improve specific sections of the LinkedIn post. To make an AI edit:",
          ),
          ul([
            "Highlight the section of text you want to change.",
            "Click the AI Edit button that appears.",
            "Write your edit instruction.",
            "Review the updated text.",
            "Accept the change if it looks right.",
          ]),
          p("You can use AI edits to:"),
          ul([
            "Make the hook stronger",
            "Make the post shorter",
            "Make the tone more founder-led",
            "Make the post more direct",
            "Add a stronger example",
            "Remove generic phrasing",
            "Make the CTA clearer",
            "Rewrite the post for a company page",
            "Rewrite the post for a founder profile",
            "Turn a paragraph into shorter lines",
            "Make the post more educational, opinionated, or product-led",
          ]),
          p("Example instructions:"),
          ul([
            "Make the hook sharper and less generic.",
            "Rewrite this in a more direct founder-led voice.",
            "Shorten this post to under 150 words.",
            "Make this sound less corporate and more conversational.",
          ]),
          p("AI edits let you refine the post without rewriting it manually."),
          img(liStep7, "Status dropdown for approving and publishing a LinkedIn post"),
          h2("Step 7: Approve, schedule, publish, or export"),
          p(
            "Once the post is ready, use the Marketing Calendar to move it through your publishing workflow. You can:",
          ),
          ul([
            "Approve the post",
            "Schedule it",
            "Publish it",
            "Export it",
            "Save it for later",
            "Coordinate it with other campaign assets",
          ]),
          p(
            "Use the calendar to manage LinkedIn posts alongside GEO articles, X posts, threads, custom campaigns, and other generated content.",
          ),
          img(),
          h2("Step 8: Track performance"),
          p(
            "After publishing, Axy.digital uses performance data to improve future recommendations. Track:",
          ),
          ul([
            "Impressions",
            "Engagement",
            "Comments",
            "Reposts",
            "Clicks where available",
            "Topic performance",
            "Format performance",
            "Founder vs company performance",
            "Campaign performance",
          ]),
          p(
            "Axy.digital uses these insights to improve future LinkedIn briefs and generated posts.",
          ),
          img(),
          h2("FAQ"),
          h3("Do I need to come up with LinkedIn post ideas myself?"),
          p(
            "No. Axy.digital suggests LinkedIn briefs based on market signals, social trends, AI visibility gaps, competitor updates, search demand, news headlines, and campaign opportunities. You only need to review the brief and click Generate when you want to create the post.",
          ),
          h3("Do I need to choose the LinkedIn format myself?"),
          p(
            "No. Axy.digital automatically chooses the right format based on the brief, your LinkedIn plan, your marketing strategy, and your channel guidelines.",
          ),
          p(
            "It adapts the output for the channel, so you do not need to manually decide whether something should be a founder post, company update, educational post, market commentary, or campaign extension.",
          ),
          h3("Are LinkedIn posts already optimized for my voice?"),
          p(
            "Yes, if your strategy, LinkedIn plan, and LinkedIn guidelines are configured. Axy.digital uses your approved strategy, brand voice, founder voice, channel plan, and channel guidelines to generate posts that match your intended style.",
          ),
          h3("Can I edit the post with AI?"),
          p(
            "Yes. Highlight the section of text you want to edit, click AI Edit, and write instructions for how you want the text changed.",
          ),
          h3("Where does the generated post go?"),
          p(
            "Generated LinkedIn posts are added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export the content.",
          ),
          img(),
          h2("Best practices"),
          h3("Review briefs weekly"),
          p(
            "Axy.digital continuously suggests LinkedIn opportunities. Check Proposed Briefs regularly.",
          ),
          h3("Start from strong signals"),
          p("The better the source signal, article, or insight, the stronger the post."),
          h3("Keep your guidelines specific"),
          p(
            "Post length, tone, words to avoid, and writing style help Axy.digital generate better content.",
          ),
          h3("Review the hook carefully"),
          p("LinkedIn posts need a strong opening line that earns attention."),
          h3("Use AI edits for specific improvements"),
          p("Highlight the section that needs work and give Axy.digital a clear instruction."),
          h3("Use analytics to improve"),
          p("Let performance data guide future angles, topics, and messaging."),
        ],
        next: [
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/generate-x-posts-and-threads",
          "/tutorials/use-the-marketing-calendar",
        ],
      },
      {
        slug: "generate-x-posts-and-threads",
        title: "How to Generate X Posts and Threads in Axy.digital",
        metaTitle: "How to Generate X Posts and Threads in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital generates X posts and threads from proposed briefs, market signals, social trends, news headlines, and competitor updates.",
        category: "Core Product Tutorials",
        product: "X Autopilot",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor:
          "Users creating timely X posts, threads, founder commentary, and short-form campaign content",
        intro:
          "Axy.digital helps you generate X posts and threads from campaign briefs already suggested inside your workspace. Instead of living on the timeline or guessing what to post, Axy.digital uses market intelligence signals, social trends, news headlines, AI visibility gaps, competitor updates, product updates, and your approved strategy to suggest X-ready content opportunities. These opportunities appear as campaign briefs in Workspace → Proposed Briefs. When you see an X brief you want to create, click Generate. Axy.digital creates the post or thread, moves it to your Marketing Calendar, and lets you review, edit, approve, schedule, publish, or export it from there.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Reviewed your X plan",
            "Configured your X guidelines",
            "Connected or added your X account",
            "Added founder voice or brand voice context where relevant",
            "Selected competitors",
            "Added relevant resources to your knowledge base",
          ]),
          p("Your X output is strongest when your channel guidelines are specific."),
          p(
            "For example, define preferred post length, thread style, tone, words to avoid, use of hashtags, level of technical depth, and whether content should be sharp, contrarian, educational, product-led, or founder-led.",
          ),
          img(xStep1, "Proposed briefs review screen with X (Twitter) briefs in Axy.digital"),
          h2("Step 1: Open Proposed Briefs"),
          p(
            "Go to your workspace and open Proposed Briefs. This is where Axy.digital surfaces campaign ideas it has already identified for your brand.",
          ),
          p("An X brief can be generated from:"),
          ul([
            "A market intelligence signal",
            "A social trend",
            "A news headline",
            "A competitor update",
            "An AI visibility gap",
            "A search demand opportunity",
            "A GEO article",
            "A product update",
            "A case study",
            "A weekly recommendation",
          ]),
          p(
            "Each brief appears because Axy.digital has identified a relevant opportunity for your business.",
          ),
          img(),
          h2("Step 2: Review the X brief"),
          p("Open the X brief you want to review. The brief includes:"),
          ul([
            "Post or thread topic",
            "Source signal",
            "Target audience",
            "Suggested angle",
            "Why this post matters",
            "Related trend or narrative",
            "Suggested CTA",
            "Campaign connection",
          ]),
          p("Use the brief to decide whether the post or thread is worth generating. Ask:"),
          ul([
            "Is this timely?",
            "Is this relevant to our audience?",
            "Does this fit our X voice?",
            "Is there a clear point of view?",
            "Is this worth responding to now?",
            "Does this connect to a broader campaign?",
          ]),
          p(
            "You do not need to choose the post format manually. Axy.digital automatically generates the right X format based on the brief, your strategy, your X plan, and your channel guidelines.",
          ),
          img(),
          h2("Step 3: Click Generate"),
          p("If the brief looks useful, click Generate. Axy.digital generates X content using:"),
          ul([
            "The proposed brief",
            "Your approved marketing strategy",
            "Your X plan",
            "Your X guidelines",
            "Your brand or founder voice",
            "Your knowledge base",
            "The source signal or campaign context",
            "Previous performance data where available",
          ]),
          p("Axy.digital automatically chooses the right format for X. This can include:"),
          ul([
            "Short posts",
            "Threads",
            "Founder commentary",
            "Market commentary",
            "Product updates",
            "Educational breakdowns",
            "Launch posts",
            "Community posts",
            "Campaign extensions",
          ]),
          p(
            "The content is automatically optimized for X based on your configured guidelines. Once generated, the post or thread is added to your Marketing Calendar.",
          ),
          img(xStep4, "Marketing calendar showing generated X posts and threads"),
          h2("Step 4: Open the content in your Marketing Calendar"),
          p(
            "Go to your Marketing Calendar to view the generated X post or thread. From the calendar, you can:",
          ),
          ul([
            "Open the post or thread draft",
            "Review the content",
            "Edit the content",
            "Approve it",
            "Schedule it",
            "Publish it",
            "Export it",
            "Save it for later",
          ]),
          p(
            "If the X content is part of a larger campaign, the calendar shows it alongside related GEO articles and LinkedIn posts.",
          ),
          img(xStep5, "Generated X thread preview with multiple connected tweets"),
          h2("Step 5: Review the generated post or thread"),
          p("Review the content before publishing. Check:"),
          ul([
            "Is it concise?",
            "Does it sound natural?",
            "Is the hook strong?",
            "Does it avoid corporate language?",
            "Does it follow your X guidelines?",
            "Does it avoid banned words or phrases?",
            "Is the thread structured clearly, if a thread was generated?",
            "Does it avoid over-explaining?",
            "Does it add a clear point of view?",
            "Is the CTA appropriate?",
          ]),
          p("X content should feel timely, sharp, and easy to engage with."),
          img(),
          h2("Step 6: Make AI edits"),
          p(
            "You can use AI edits to quickly improve specific sections of the X post or thread. To make an AI edit:",
          ),
          ul([
            "Highlight the section of text you want to change.",
            "Click the AI Edit button that appears.",
            "Write your edit instruction.",
            "Review the updated text.",
            "Accept the change if it looks right.",
          ]),
          p("You can use AI edits to:"),
          ul([
            "Make the post shorter",
            "Make the hook sharper",
            "Make the tone more direct",
            "Make the post more opinionated",
            "Simplify the language",
            "Remove corporate phrasing",
            "Turn a paragraph into a thread",
            "Tighten a thread",
            "Add a clearer takeaway",
            "Rewrite in founder voice",
            "Make the CTA less salesy",
            "Make the post more timely or trend-aware",
          ]),
          p("Example instructions:"),
          ul([
            "Make this sharper and more concise.",
            "Rewrite this as a 5-part thread.",
            "Make this sound less corporate and more founder-led.",
            "Cut this down to one punchy X post.",
          ]),
          p("AI edits let you refine the content without rewriting it manually."),
          img(xStep7, "Status dropdown for approving and publishing an X thread"),
          h2("Step 7: Approve, schedule, publish, or export"),
          p(
            "Once the post or thread is ready, use the Marketing Calendar to move it through your publishing workflow. You can:",
          ),
          ul([
            "Approve the content",
            "Schedule it",
            "Publish it",
            "Export it",
            "Save it for later",
            "Coordinate it with other campaign assets",
          ]),
          p(
            "Use the calendar to manage X content alongside GEO articles, LinkedIn posts, custom campaigns, and other generated assets.",
          ),
          img(),
          h2("Step 8: Track performance"),
          p(
            "After publishing, Axy.digital uses performance data to improve future recommendations. Track:",
          ),
          ul([
            "Impressions",
            "Engagement",
            "Reposts",
            "Replies",
            "Clicks where available",
            "Topic performance",
            "Format performance",
            "Thread performance",
            "Campaign performance",
          ]),
          p("Axy.digital uses this data to improve future X briefs and generated posts."),
          img(),
          h2("FAQ"),
          h3("Do I need to find X trends myself?"),
          p(
            "No. Axy.digital surfaces social trends, news headlines, competitor updates, market intelligence signals, and campaign opportunities inside Proposed Briefs. You only need to review the brief and click Generate when you want to create the post or thread.",
          ),
          h3("Do I need to choose whether something is a post or a thread?"),
          p(
            "No. Axy.digital automatically chooses the right format based on the brief, your X plan, your marketing strategy, and your channel guidelines.",
          ),
          p(
            "It adapts the content for X, so you do not need to manually decide whether something should be a short post, thread, product update, market commentary, or campaign extension.",
          ),
          h3("Can I edit the X content with AI?"),
          p(
            "Yes. Highlight the section of text you want to edit, click AI Edit, and write instructions for how you want the text changed.",
          ),
          h3("Where does the generated X content go?"),
          p(
            "Generated X posts and threads are added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export the content.",
          ),
          h3("How do I avoid generic AI posts on X?"),
          p(
            "Configure your X guidelines clearly. Add words to avoid, tone preferences, examples of strong posts, founder opinions, topics to avoid, preferred post length, thread style, level of technical depth, and hashtag preferences.",
          ),
          img(),
          h2("Best practices"),
          h3("Review Proposed Briefs regularly"),
          p("Axy.digital continuously suggests X opportunities based on market activity."),
          h3("Move quickly on timely narratives"),
          p("X rewards speed, relevance, and clarity."),
          h3("Keep posts sharper than LinkedIn"),
          p("X content should usually be more concise and direct."),
          h3("Use AI edits for specific improvements"),
          p("Highlight the section that needs work and give Axy.digital a clear instruction."),
          h3("Avoid over-formatting"),
          p("Do not make posts feel too polished or corporate."),
          h3("Let performance guide future posts"),
          p("Use analytics to understand which topics and formats are worth repeating."),
        ],
        next: [
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/use-the-marketing-calendar",
          "/tutorials/turn-draft-article-or-post-into-campaign",
        ],
      },
      {
        slug: "use-the-marketing-calendar",
        title: "How to Use the Marketing Calendar",
        metaTitle: "How to Use the Marketing Calendar | Axy.digital Tutorial",
        metaDescription:
          "Learn how to use the Axy.digital Marketing Calendar to review, edit, approve, schedule, publish, and manage generated campaigns across GEO, LinkedIn, and X.",
        category: "Core Product Tutorials",
        product: "Marketing Calendar",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor: "Users managing generated content and campaign execution inside Axy.digital",
        intro:
          "The Marketing Calendar is where your generated campaigns become an execution plan. After Axy.digital suggests campaign briefs in Proposed Briefs and you click Generate, the generated content is added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export content across GEO, LinkedIn, and X.",
        blocks: [
          p("The Marketing Calendar is where your generated campaigns become an execution plan."),
          p(
            "After Axy.digital suggests campaign briefs in Proposed Briefs and you click Generate, the generated content is added to your Marketing Calendar.",
          ),
          p(
            "From there, you can review, edit, approve, schedule, publish, or export content across GEO, LinkedIn, and X.",
          ),
          p(
            "The calendar helps you see what is coming up, what needs review, and how each campaign fits into your broader marketing plan.",
          ),
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Reviewed your channel plans",
            "Configured your channel guidelines",
            "Generated at least one campaign from Proposed Briefs or Custom Campaigns",
          ]),
          p("Generated content will appear in the calendar after you create it."),
          img(
            mcStep1,
            "Marketing Calendar showing drafted, in review, approved, published and overdue content with status dropdown open",
          ),
          h2("Step 1: Open the Marketing Calendar"),
          p("From your workspace, open Marketing Calendar."),
          p("This is where Axy.digital organizes generated content across your active channels."),
          p("You may see content such as:"),
          ul([
            "GEO articles",
            "SEO articles",
            "AEO answer content",
            "LinkedIn posts",
            "X posts",
            "X threads",
            "Product launch campaigns",
            "Case study campaigns",
            "Custom campaign assets",
          ]),
          p(
            "The calendar gives you a central view of what Axy.digital has generated and what needs your attention.",
          ),
          img(),
          h2("Step 2: Review your generated content"),
          p("Open any calendar item to review the generated content."),
          p("Each item may include:"),
          ul([
            "Campaign title",
            "Channel",
            "Draft content",
            "Source brief",
            "Source signal",
            "Target audience",
            "Suggested CTA",
            "Internal link suggestions",
            "Status",
            "Suggested publish date",
          ]),
          p("Review the content before approving it."),
          p("Check:"),
          ul([
            "Is the content accurate?",
            "Does it match your strategy?",
            "Does it follow the channel plan?",
            "Does it follow your channel guidelines?",
            "Is the CTA correct?",
            "Are internal links relevant?",
            "Does the post or article sound on-brand?",
            "Does the content need edits before publishing?",
          ]),
          p(
            "Axy.digital handles the first draft and channel optimization, but you still control what gets published.",
          ),
          img(),
          h2("Step 3: Edit content where needed"),
          p("You can edit generated content directly from the Marketing Calendar."),
          p("Common edits include:"),
          ul([
            "Adjusting the hook",
            "Tightening the intro",
            "Changing the CTA",
            "Adding a stronger example",
            "Correcting product details",
            "Removing unsupported claims",
            "Changing tone or length",
            "Updating internal links",
            "Adding customer proof or data",
            "Making founder-led content sound more personal",
          ]),
          p(
            "If you notice repeated issues, update your marketing strategy or channel guidelines. Future content will use the updated context.",
          ),
          img(),
          h2("Step 4: Review internal links for GEO content"),
          p(
            "For GEO, AEO, and SEO content, Axy.digital may suggest internal links based on your website index.",
          ),
          p("These links may point to:"),
          ul([
            "Product pages",
            "Use-case pages",
            "Case studies",
            "Tutorials",
            "Comparison pages",
            "Existing blog posts",
            "Documentation",
            "Resource pages",
          ]),
          p("Review internal links before publishing."),
          p("Good internal links should be:"),
          ul([
            "Relevant to the topic",
            "Useful for the reader",
            "Naturally placed",
            "Connected to your content strategy",
            "Helpful for moving users to the next step",
          ]),
          p("Internal links help each new campaign strengthen your wider content architecture."),
          img(),
          h2("Step 5: Approve content"),
          p("Once a piece of content looks ready, approve it."),
          p("Approving content signals that it is ready for the next step in your workflow."),
          p("Depending on your setup, approved content may be ready to:"),
          ul([
            "Schedule",
            "Publish",
            "Export",
            "Share with your team",
            "Move to your CMS",
            "Add to a launch plan",
          ]),
          p(
            "If you are working with a team or client, approval can also help separate draft content from final content.",
          ),
          img(),
          h2("Step 6: Schedule or publish content"),
          p("From the Marketing Calendar, you can organize when content should go live."),
          p("Depending on your setup, you may be able to:"),
          ul([
            "Schedule LinkedIn posts",
            "Schedule X posts or threads",
            "Plan GEO article publication dates",
            "Coordinate campaign timing across channels",
            "Spread campaign assets across multiple days",
            "Save content for later",
          ]),
          p(
            "For cross-channel campaigns, use the calendar to make sure content is sequenced properly.",
          ),
          p("For example:"),
          ul([
            "Publish the GEO article first",
            "Follow with a LinkedIn post",
            "Share an X thread",
            "Add follow-up social posts later in the week",
          ]),
          p("This helps one campaign create multiple touchpoints across channels."),
          img(),
          h2("Step 7: Manage content status"),
          p("Use content status to understand what stage each asset is in."),
          p("Common statuses may include:"),
          ul([
            "Draft",
            "Needs review",
            "Approved",
            "Scheduled",
            "Published",
            "Exported",
            "Archived",
          ]),
          p("This helps you quickly see what needs action."),
          p("For example:"),
          ul([
            "Draft content may need editing.",
            "Approved content may need scheduling.",
            "Scheduled content is ready to go live.",
            "Published content can be tracked for performance.",
          ]),
          img(),
          h2("Step 8: Use the calendar to plan your week"),
          p("The Marketing Calendar can also act as your weekly marketing plan."),
          p(
            "Instead of managing content across scattered docs, spreadsheets, and social tools, use the calendar to see:",
          ),
          ul([
            "What is ready to publish",
            "What needs review",
            "Which channels are active",
            "Which campaigns are scheduled",
            "Whether your content mix is balanced",
            "Whether you are over-posting or under-posting on a channel",
            "Which campaign themes are being repeated",
          ]),
          p(
            "This helps you maintain consistency without manually building a content calendar from scratch.",
          ),
          img(),
          h2("Step 9: Track what happens after publishing"),
          p(
            "Once content is published, Axy.digital can use performance data to improve future recommendations.",
          ),
          p("Depending on the channel, Axy.digital may track:"),
          ul([
            "AI visibility changes",
            "Mention rate",
            "Citation rate",
            "Search performance",
            "LinkedIn impressions",
            "LinkedIn engagement",
            "X impressions",
            "X engagement",
            "Topic performance",
            "Campaign performance",
          ]),
          p(
            "This performance data helps Axy.digital improve future proposed briefs and generated content.",
          ),
          p(
            "The Marketing Calendar is not just a publishing view. It is part of the feedback loop.",
          ),
          img(),
          h2("FAQ"),
          h3("where does generated content go?"),
          p("Generated content is added to your Marketing Calendar."),
          p("This includes content generated from:"),
          ul([
            "Proposed Briefs",
            "Custom Campaigns",
            "GEO article briefs",
            "LinkedIn briefs",
            "X briefs",
            "Product launch inputs",
            "Case study inputs",
            "Drafts or source links",
          ]),
          p(
            "From the calendar, you can review, edit, approve, schedule, publish, or export the content.",
          ),
          h3("can I edit content after it appears in the calendar?"),
          p("Yes."),
          p(
            "You can edit generated content before approving, scheduling, publishing, or exporting it.",
          ),
          p(
            "If the content is already published, you may need to edit it in the destination platform or CMS, depending on your setup.",
          ),
          h3("do calendar items stay connected to the original brief?"),
          p("Yes."),
          p(
            "Calendar items should stay connected to the original brief, signal, or custom input that generated them.",
          ),
          p(
            "This helps you understand why the content was created and how it fits into your wider strategy.",
          ),
          h3("should I publish everything Axy.digital generates?"),
          p("No."),
          p(
            "Axy.digital gives you campaign opportunities and generated content, but you decide what goes live.",
          ),
          p("Prioritize content that is:"),
          ul([
            "Relevant to your current goals",
            "Aligned with your strategy",
            "Timely",
            "Accurate",
            "Useful to your audience",
            "Strong enough to publish",
          ]),
          img(),
          h2("Best practices"),
          h3("Review the calendar weekly"),
          p("Use the Marketing Calendar as your weekly execution view."),
          h3("Approve before scheduling"),
          p(
            "Make sure each asset is accurate, on-brand, and aligned with your strategy before it goes live.",
          ),
          h3("Sequence cross-channel campaigns"),
          p(
            "For larger campaigns, coordinate GEO, LinkedIn, and X content instead of publishing everything at once.",
          ),
          h3("Keep your content mix balanced"),
          p(
            "Make sure you are not only publishing one type of content. Balance educational, product-led, market commentary, proof-led, and conversion-focused content.",
          ),
          h3("Update guidelines when edits repeat"),
          p(
            "If you keep making the same edits, update your channel guidelines so future content improves.",
          ),
          h3("Track performance after publishing"),
          p("Use results to decide what to repeat, refine, or turn into a follow-up campaign."),
        ],
        next: [
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/create-custom-campaigns",
          "/geo/measure-whether-geo-content-is-working",
        ],
      },
      {
        slug: "create-custom-campaigns",
        title: "How to Create Custom Campaigns in Axy.digital",
        metaTitle: "How to Create Custom Campaigns in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how to create custom campaigns in Axy.digital from product announcements, partnership news, case studies, client feedback, or your own ideas.",
        category: "Core Product Tutorials",
        product: "Campaign Generation",
        difficulty: "Beginner",
        estimatedTime: "8 minutes",
        bestFor:
          "Users who want to create campaigns around launches, announcements, case studies, partnerships, or custom ideas",
        intro:
          "Axy.digital does not only generate weekly evergreen campaigns from market signals. You can also create custom campaigns from your own inputs — product updates, partnership announcements, case studies, client feedback, articles, LinkedIn posts, tweets, drafts, or content ideas.",
        blocks: [
          p("Axy.digital does not only generate weekly evergreen campaigns from market signals."),
          p(
            "You can also create custom campaigns from your own inputs, including product updates, partnership announcements, case studies, client feedback, articles, LinkedIn posts, tweets, drafts, or content ideas.",
          ),
          p(
            "This means your marketing engine can support your real business milestones, not just ongoing content.",
          ),
          p(
            "Use custom campaigns when you already know what you want to promote, but you want Axy.digital to turn it into a full suite of channel-ready content.",
          ),

          img(customCampWhat, "Create campaign button highlighted in Axy.digital briefs review"),
          h2("What you can create with custom campaigns"),
          p("You can use custom campaigns for:"),
          ul([
            "Product launches",
            "Partnership announcements",
            "Case studies",
            "Customer stories",
            "Founder announcements",
            "Feature releases",
            "Event recaps",
            "Funding announcements",
            "Thought leadership ideas",
            "Blog drafts",
            "Social commentary",
            "Repurposed articles",
            "Client wins",
            "New market entries",
            "Webinar or podcast recaps",
          ]),
          p(
            "Axy.digital will use your input, approved strategy, channel plans, website index, knowledge base, and channel guidelines to generate content that fits your brand.",
          ),

          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your marketing strategy",
            "Reviewed your channel plans",
            "Configured your GEO, LinkedIn, and X guidelines",
            "Added relevant resources to your knowledge base",
            "Added your website so Axy.digital can recommend internal links",
          ]),
          p(
            "Your custom campaigns will be stronger when your strategy and channel guidelines are up to date.",
          ),

          img(
            ccStep1,
            "Create New Campaign modal on the Context step with fields for campaign name, description, document upload and context URL",
          ),
          h2("Step 1: Open custom campaign creation"),
          p("From your workspace, open the campaign creation area and choose Custom Campaign."),
          p(
            "This is where you can give Axy.digital your own input instead of choosing from a proposed brief.",
          ),
          p(
            "Use this when you want to create content around a specific milestone, asset, announcement, or idea.",
          ),

          img(),
          h2("Step 2: Choose your campaign input"),
          p("Start by adding the source material for your campaign."),
          p("You can create a custom campaign from several types of input."),

          h3("Upload a product brief"),
          p("Use this when you are launching a new product, feature, integration, or service."),
          p("Axy.digital can turn the brief into:"),
          ul([
            "Product launch announcement",
            "GEO article",
            "LinkedIn posts",
            "X posts or threads",
            "Founder commentary",
            "Product education content",
            "Supporting campaign angles",
          ]),
          p("Example: Upload a product brief → Get a full product launch campaign."),

          h3("Add client feedback and a website"),
          p("Use this when you want to create a case study or customer story."),
          p("You can add:"),
          ul([
            "Client feedback",
            "Customer quotes",
            "Results",
            "Screenshots",
            "Client website",
            "Project context",
            "Before/after details",
          ]),
          p("Axy.digital can turn this into:"),
          ul([
            "Polished case study",
            "LinkedIn case study post",
            "X thread",
            "Customer proof snippets",
            "Sales enablement copy",
            "Campaign CTA",
          ]),
          p("Example: Drop in client feedback + website → Get a polished case study."),

          h3("Link a LinkedIn post, tweet, or article"),
          p(
            "Use this when you find a post or article you want to respond to, build on, or reference.",
          ),
          p("Axy.digital can generate:"),
          ul([
            "On-brand commentary",
            "Founder-led response",
            "LinkedIn post",
            "X post",
            "X thread",
            "Contrarian angle",
            "Educational breakdown",
            "Campaign idea",
          ]),
          p(
            "Example: Link a LinkedIn post, tweet, or article you like → Generate on-brand commentary.",
          ),

          h3("Upload a draft"),
          p(
            "Use this when you have a half-finished blog, post, announcement, or idea that needs refinement.",
          ),
          p("Axy.digital can help:"),
          ul([
            "Complete the draft",
            "Improve structure",
            "Strengthen the hook",
            "Adapt the tone",
            "Add CTAs",
            "Turn it into multiple channel assets",
            "Align it with your strategy and channel plans",
          ]),
          p(
            "Example: Upload that half-baked draft → Let Axy.digital take it over the finish line.",
          ),

          h3("Enter your own idea"),
          p("Use this when you have a campaign idea but no full brief yet."),
          p("You can write a short description such as:"),
          p(
            "“We want to announce our new AI Visibility Analytics dashboard and explain why AI search visibility is becoming a new organic growth channel.”",
          ),
          p(
            "Axy.digital will turn the idea into a structured campaign brief before generating assets.",
          ),

          img(),
          h2("Step 3: Add campaign context"),
          p("After adding your input, give Axy.digital any extra context that matters."),
          p("Useful context includes:"),
          ul([
            "What is being announced",
            "Why it matters",
            "Who the audience is",
            "What outcome you want",
            "Which product or feature this supports",
            "Which customer segment this targets",
            "Whether the tone should be educational, bold, technical, founder-led, or product-led",
            "Which channels you want to generate for",
            "Whether there are claims, stats, or customer quotes to include",
            "Any details to avoid",
          ]),
          p(
            "You do not need to write a perfect brief. Axy.digital will structure the campaign for you.",
          ),

          img(
            ccStep4,
            "Create New Campaign modal Channels and Options step with channel checkboxes, content pillar selector and content option toggles",
          ),
          h2("Step 4: Choose the platform and add custom guidelines"),
          p(
            "After adding your input and context, choose which platform(s) Axy.digital should generate content for, and add any custom guidelines for this campaign.",
          ),

          h3("Choose the platform"),
          p("Select one or more platforms for this campaign:"),
          ul([
            "Blog (GEO / SEO article)",
            "LinkedIn (posts and founder-led commentary)",
            "X (posts and threads)",
          ]),
          p(
            "Axy.digital adapts tone, structure, and length automatically per platform, using your existing channel plan and guidelines.",
          ),

          h3("Add custom guidelines (optional)"),
          p("Add any guidelines that should apply to this specific campaign, such as:"),
          ul([
            "Tone or voice adjustments (more technical, more founder-led, more playful)",
            "Specific phrases, hooks, or CTAs to include",
            "Words, claims, or topics to avoid",
            "Required mentions (product name, customer, partner, event)",
            "Formatting preferences (thread length, post length, use of stats)",
            "Links that must be included",
          ]),
          p(
            "These guidelines apply on top of your standing channel guidelines and only affect this campaign.",
          ),

          img(),
          h2("Step 5: Click Generate"),
          p("Once the brief looks right, click Generate."),
          p(
            "Axy.digital will automatically create the right content suite based on the brief, your strategy, and your channel guidelines.",
          ),
          p("Depending on the campaign, Axy.digital may generate:"),
          ul([
            "GEO article",
            "SEO article",
            "AEO answer content",
            "LinkedIn posts",
            "X posts",
            "X threads",
            "Launch announcement copy",
            "Case study copy",
            "Founder commentary",
            "Product education content",
            "Suggested CTAs",
            "Internal links",
            "Follow-up campaign ideas",
          ]),
          p(
            "Axy.digital automatically adapts the content for each channel, so you do not need to manually decide the format.",
          ),

          img(),
          h2("Step 6: Review the generated content"),
          p("Review each generated asset before approving it."),
          p("Check:"),
          ul([
            "Is the content accurate?",
            "Does it reflect the source material?",
            "Does it match your brand voice?",
            "Does it follow the right channel guidelines?",
            "Are customer quotes or claims used correctly?",
            "Are product details correct?",
            "Is the CTA appropriate?",
            "Are internal links relevant?",
            "Is the content specific enough?",
            "Does it avoid words or phrases you do not want to use?",
          ]),
          p("For announcements and case studies, pay extra attention to accuracy and approval."),
          p(
            "If you are referencing a customer, partner, or third-party post, make sure the content is appropriate to publish.",
          ),

          img(),
          h2("FAQ"),
          h3("how are custom campaigns different from proposed briefs?"),
          p(
            "Proposed Briefs are generated by Axy.digital based on market intelligence, AI visibility gaps, search demand, competitor updates, social trends, and news headlines.",
          ),
          p("Custom Campaigns start from your own input."),
          p("Use Proposed Briefs when you want Axy.digital to suggest what to act on."),
          p(
            "Use Custom Campaigns when you already have a milestone, idea, asset, draft, announcement, or source you want to turn into a campaign.",
          ),

          h3("do I need to write a full brief?"),
          p("No."),
          p(
            "You can give Axy.digital a rough input, draft, link, customer quote, product note, or idea.",
          ),
          p(
            "Axy.digital will turn it into a structured campaign brief before generating the full content suite.",
          ),

          h3("can Axy.digital create a case study from client feedback?"),
          p("Yes."),
          p(
            "You can add client feedback, results, project notes, and the client’s website. Axy.digital can then generate a polished case study and related social content.",
          ),
          p("For best results, include:"),
          ul([
            "Who the client is",
            "What problem they had",
            "What you helped them do",
            "What changed",
            "Any measurable outcomes",
            "Customer quotes",
            "Relevant links or screenshots",
            "Any claims that need approval",
          ]),

          h3("can I use someone else’s post or article as inspiration?"),
          p("Yes."),
          p(
            "You can link a LinkedIn post, tweet, or article you like and ask Axy.digital to generate on-brand commentary.",
          ),
          p(
            "Use this to respond to market conversations, add your point of view, or turn inspiration into original content.",
          ),
          p("Do not copy the original source. Use it as context for your own commentary."),

          h3("can I upload a rough draft?"),
          p("Yes."),
          p(
            "You can upload a half-baked draft and let Axy.digital improve it, complete it, restructure it, or turn it into a full campaign.",
          ),
          p(
            "This is useful when you have the idea but do not want to spend time polishing, formatting, or adapting it for multiple channels.",
          ),

          img(),
          h2("Best practices"),
          h3("Give Axy.digital enough context"),
          p(
            "A short input can work, but campaigns are stronger when you include the audience, goal, key details, and desired outcome.",
          ),
          h3("Use custom campaigns for milestones"),
          p(
            "Product launches, partnerships, customer wins, case studies, and events deserve dedicated campaigns.",
          ),
          h3("Review factual details carefully"),
          p(
            "For launches, partnerships, and case studies, check names, claims, dates, quotes, and outcomes before publishing.",
          ),
          h3("Let Axy.digital adapt the format"),
          p(
            "You do not need to manually decide every asset type. Axy.digital will generate the right content suite based on the campaign brief and channel guidelines.",
          ),
          h3("Turn one milestone into multiple assets"),
          p(
            "A product brief, customer quote, or article can become a GEO article, LinkedIn post, X thread, and follow-up campaign.",
          ),
        ],
        next: [
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/use-the-marketing-calendar",
          "/tutorials/generate-linkedin-posts",
          "/tutorials/generate-x-posts-and-threads",
        ],
      },
      {
        slug: "manage-multiple-brands",
        title: "How to Manage Multiple Brands in Axy.digital",
        metaTitle: "How to Manage Multiple Brands in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how to manage multiple brands or clients in Axy.digital with separate organisations, each with its own strategy, knowledge base, and competitors.",
        category: "Core Product Tutorials",
        product: "Workspace / Organisations",
        difficulty: "Beginner",
        estimatedTime: "6 minutes",
        bestFor:
          "Agencies, studios, venture studios, multi-brand teams, and users managing more than one company in Axy.digital",
        intro:
          "Axy.digital lets you manage multiple brands by creating separate organisations. Each organisation has its own workspace, strategy, knowledge base, competitors, website index, channel plans, language settings, campaigns, and marketing calendar. This is important because Axy.digital customizes the engine for each brand. If you manage multiple companies, clients, or portfolio brands, each one should have its own organisation.",
        blocks: [
          img(),
          h2("Before you start"),
          p(
            "Make sure you know which brand, client, or company you want to set up. For each organisation, you should have:",
          ),
          ul([
            "Website URL",
            "Social channels",
            "Brand materials",
            "Product or service information",
            "Competitors",
            "Marketing strategy",
            "GEO, LinkedIn, and X plans",
            "Target geography and language preferences",
          ]),
          img(mbStep1, "Account dropdown showing organization switcher in Axy.digital"),
          h2("Step 1: Create a new organisation"),
          p("To manage a new brand, create a new organisation."),
          p(
            "Each organisation should represent one brand, company, client, or portfolio business.",
          ),
          p(
            "Do not use one organisation for multiple brands unless they share the same website, strategy, audience, competitors, and content engine.",
          ),
          p(
            "Axy.digital customizes each organisation separately, so keeping brands separate helps the engine generate more accurate campaigns.",
          ),
          img(mbStep2, "Choose an organization modal with create organization option"),
          h2("Step 2: Set up the organisation for that brand"),
          p(
            "Once the organisation is created, complete onboarding for that brand. Axy.digital will analyze:",
          ),
          ul([
            "Website",
            "Social channels",
            "Uploaded resources",
            "Online materials",
            "Competitors",
            "Brand positioning",
            "Target audience",
            "Channel plans",
            "Website pages for internal linking",
          ]),
          p("This creates a dedicated engine for that brand."),
          img(),
          h2("Step 3: Switch between organisations"),
          p("You can switch between organisations from the top-left corner of your workspace."),
          p(
            "Use the organisation switcher to move between brands, clients, or portfolio companies.",
          ),
          p(
            "When you switch organisations, you are switching into that brand's dedicated engine. This means you will see that organisation's:",
          ),
          ul([
            "Strategy",
            "Knowledge base",
            "Market intelligence",
            "AI visibility reports",
            "Proposed briefs",
            "Campaigns",
            "Marketing calendar",
            "Channel plans",
            "Performance data",
          ]),
          img(),
          h2("Step 4: Keep each brand's context separate"),
          p("Each organisation should have its own context. This includes:"),
          ul([
            "Marketing strategy",
            "Audience",
            "Competitors",
            "Website index",
            "Product information",
            "Brand voice",
            "Channel guidelines",
            "Geographic focus",
            "Language preferences",
            "Campaign history",
            "Performance data",
          ]),
          p(
            "This prevents Axy.digital from mixing messaging, competitors, audiences, or content styles across brands.",
          ),
          p(
            "For example, an agency managing a cybersecurity company and a wellness brand should create two separate organisations, because the markets, language, competitors, and content strategy are completely different.",
          ),
          img(),
          h2("Step 5: Generate campaigns inside the right organisation"),
          p(
            "Before generating content, make sure you are inside the correct organisation. Campaigns generated inside an organisation will use that organisation's:",
          ),
          ul([
            "Approved strategy",
            "Website index",
            "Knowledge base",
            "Competitor list",
            "Market intelligence",
            "AI visibility data",
            "Channel plans",
            "Channel guidelines",
            "Language and geography settings",
          ]),
          p("This ensures the campaign is aligned with the correct brand."),
          img(),
          h2("Step 6: Review each organisation separately"),
          p("Each organisation has its own Marketing Calendar and campaign workflow."),
          p(
            "Review generated content inside the correct organisation before approving, scheduling, publishing, or exporting.",
          ),
          p(
            "This is especially important for agencies, studios, and venture teams managing multiple brands.",
          ),
          img(),
          h2("FAQ"),
          h3("Why should I create separate organisations for each brand?"),
          p(
            "Each organisation is customized per brand. Axy.digital uses that brand's website, strategy, competitors, knowledge base, channel plans, and performance data to generate campaigns. Keeping brands separate prevents mixed context and improves output quality.",
          ),
          h3("Can I manage clients in separate organisations?"),
          p("Yes. Agencies and studios can create a separate organisation for each client."),
          h3("Where do I switch organisations?"),
          p("Use the organisation switcher in the top-left corner of your workspace."),
          h3("What happens when I switch organisations?"),
          p(
            "You move into that brand's dedicated workspace, including its strategy, reports, proposed briefs, campaigns, and marketing calendar.",
          ),
          h3("Should sub-brands have separate organisations?"),
          p(
            "If the sub-brand has a different audience, website, positioning, geography, language, or campaign strategy, create a separate organisation. If it shares the same strategy and audience, it can usually stay in the same organisation.",
          ),
          img(),
          h2("Best practices"),
          h3("Create one organisation per brand"),
          p("This keeps each engine clean and focused."),
          h3("Check the organisation before generating content"),
          p("Make sure you are in the right workspace before creating campaigns."),
          h3("Keep each brand's strategy updated"),
          p(
            "Each organisation should have its own current positioning, competitors, and channel guidelines.",
          ),
          h3("Use separate organisations for clients"),
          p("Agencies should avoid mixing client work inside one organisation."),
          h3("Treat each organisation as its own engine"),
          p(
            "Axy.digital works best when each brand has its own dedicated strategy, data, and campaign history.",
          ),
        ],
        next: [
          "/tutorials/set-up-your-axy-engine",
          "/tutorials/review-marketing-strategy-and-channel-plans",
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/use-the-marketing-calendar",
        ],
      },
      {
        slug: "customize-geography-and-language",
        title: "How to Customize Geography and Language in Axy.digital",
        metaTitle: "How to Customize Geography and Language in Axy.digital | Axy.digital Tutorial",
        metaDescription:
          "Learn how to customize geography and language in Axy.digital by setting your geographic focus and adding language instructions to your channel plans.",
        category: "Core Product Tutorials",
        product: "Workspace / Marketing Strategy / Channel Plans",
        difficulty: "Beginner",
        estimatedTime: "6 minutes",
        bestFor:
          "Brands targeting local markets, regional audiences, multilingual audiences, or country-specific campaigns",
        intro:
          "Axy.digital lets you customize the geography and language of your marketing engine. This helps your campaigns align with the markets you sell into and the language your audience actually uses. Axy.digital also detects the language on your website and in your uploaded materials, then aligns the engine and generated campaigns with that language. This is useful for brands marketing to local markets, regional audiences, or non-English-speaking customers.",
        blocks: [
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Added your website",
            "Uploaded relevant brand or product materials",
            "Approved or reviewed your marketing strategy",
            "Reviewed your channel plans",
          ]),
          p(
            "Axy.digital will use your website, materials, strategy, and channel guidelines to align campaigns with your geography and language.",
          ),
          img(geoLangStep1, "Marketing strategy audience and geographic focus settings"),
          h2("Step 1: Open your marketing strategy"),
          p("Go to: Marketing Strategy → Audience → Geographic Focus"),
          p(
            "This is where you define the markets your engine should prioritize. Your geographic focus can include:",
          ),
          ul([
            "Countries",
            "Regions",
            "Cities",
            "Local markets",
            "Language markets",
            "Expansion markets",
            "Priority customer locations",
          ]),
          p("For example:"),
          ul([
            "United Kingdom",
            "Singapore",
            "DACH",
            "Portugal",
            "United States",
            "Dubai",
            "Southeast Asia",
            "French-speaking Europe",
          ]),
          p(
            "This tells Axy.digital which market context to prioritize when generating insights, briefs, and campaigns.",
          ),
          img(),
          h2("Step 2: Set your geographic focus"),
          p(
            "Add or update the geography you want Axy.digital to focus on. This affects how Axy.digital interprets:",
          ),
          ul([
            "Market signals",
            "Search demand",
            "Competitor context",
            "Local narratives",
            "Regional terminology",
            "Customer pain points",
            "Campaign angles",
            "GEO, LinkedIn, and X content",
          ]),
          p(
            "For example, a law firm targeting Singapore should not receive the same campaign suggestions as a law firm targeting the United Kingdom.",
          ),
          p("Geographic focus helps Axy.digital localize the engine."),
          img(),
          h2("Step 3: Open your channel plan"),
          p("To customize language, go to: Channel Plan → Custom Guidelines"),
          p(
            "Use custom guidelines to define the language you want content for that channel to be generated in. You can set language preferences per channel.",
          ),
          p("For example:"),
          ul([
            "GEO content in Portuguese",
            "LinkedIn posts in English",
            "X posts in German",
            "All content in French",
            "English content for global audiences",
            "Local-language content for regional campaigns",
          ]),
          img(geoLangStep4, "Custom guidelines field with language instruction in Axy.digital"),
          h2("Step 4: Add language instructions"),
          p(
            "In the custom guidelines for each channel, write the language instruction clearly. Examples:",
          ),
          ul([
            "Generate all GEO content in Portuguese for a Portugal-based audience.",
            "Generate LinkedIn posts in English, using terminology common in the UK market.",
            "Generate X posts in German for a DACH audience.",
            "Generate content in French and avoid English-language idioms.",
            "Write all content in Spanish for a Latin American audience.",
          ]),
          p(
            "These instructions help Axy.digital generate content in the right language and local context.",
          ),
          img(),
          h2("Step 5: Let Axy.digital detect your existing language"),
          p(
            "Axy.digital also detects the language on your website and in your uploaded materials. This includes:",
          ),
          ul([
            "Website pages",
            "Product pages",
            "Blog posts",
            "Documentation",
            "Whitepapers",
            "Decks",
            "Case studies",
            "Social content",
            "Other uploaded resources",
          ]),
          p(
            "If your site and materials are in a specific language, Axy.digital aligns the engine and campaigns with that language.",
          ),
          p(
            "This helps maintain consistency across your existing brand presence and future generated content.",
          ),
          img(),
          h2("Step 6: Review generated content for local fit"),
          p(
            "After updating geography or language settings, review new generated content to make sure it fits your market. Check:",
          ),
          ul([
            "Language",
            "Tone",
            "Local terminology",
            "Regional spelling",
            "Market examples",
            "Competitor references",
            "Cultural relevance",
            "CTA",
            "Search intent",
            "Industry wording",
          ]),
          p(
            "For example, content for the US market may use different phrasing, examples, or search behavior than content for the UK, Portugal, Singapore, or Germany.",
          ),
          img(),
          h2("Step 7: Update settings as your market changes"),
          p("You can update geography and language settings anytime. Update them when:"),
          ul([
            "You enter a new country",
            "You launch in a new region",
            "You start targeting a new language audience",
            "Your ICP changes",
            "You create a local campaign",
            "You want different channels to use different languages",
            "You want Axy.digital to generate region-specific content",
          ]),
          p("Future campaigns will use the updated strategy and channel guidelines."),
          img(),
          h2("FAQ"),
          h3("Where do I set geographic focus?"),
          p(
            "Go to: Marketing Strategy → Audience → Geographic Focus. This tells Axy.digital which market or region your engine should prioritize.",
          ),
          h3("Where do I set content language?"),
          p(
            "Go to: Channel Plan → Custom Guidelines. Add the language you want that channel's content to be generated in.",
          ),
          h3("Can different channels use different languages?"),
          p(
            "Yes. You can set language instructions per channel. For example, GEO content can be in Portuguese while LinkedIn content stays in English.",
          ),
          h3("Does Axy.digital detect language automatically?"),
          p(
            "Yes. Axy.digital detects the language on your website and in your uploaded materials, then aligns the engine and campaigns with that language.",
          ),
          h3("Is this useful for local market campaigns?"),
          p(
            "Yes. Geography and language customization is especially useful for brands marketing to local markets, regional audiences, or multilingual customer segments.",
          ),
          img(),
          h2("Best practices"),
          h3("Set geography before generating campaigns"),
          p("Geographic focus helps Axy.digital prioritize the right market context."),
          h3("Be specific about the language"),
          p(
            'Write clear instructions like "Generate all GEO content in Portuguese" or "Use German for DACH LinkedIn posts."',
          ),
          h3("Use local terminology"),
          p("Add regional phrasing or industry terms if your market uses specific language."),
          h3("Review the first few outputs"),
          p("Check that the language, tone, and local references feel right."),
          h3("Update settings for expansion markets"),
          p(
            "When entering a new geography, update your audience and channel guidelines so the engine adapts.",
          ),
        ],
        next: [
          "/tutorials/review-marketing-strategy-and-channel-plans",
          "/tutorials/read-search-opportunities",
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/generate-a-geo-article",
        ],
      },
      {
        slug: "update-strategy-with-new-resources",
        title: "How to Update Your Marketing Strategy and Channel Plans with New Resources",
        metaTitle:
          "How to Update Your Marketing Strategy and Channel Plans with New Resources | Axy.digital Tutorial",
        metaDescription:
          "Learn how to keep Axy.digital current with new product updates, documents, and links by regenerating your strategy and channel plans.",
        category: "Core Product Tutorials",
        product: "Knowledge Base / Marketing Strategy / Channel Plans",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor:
          "Users who want to keep Axy.digital aligned with new product updates, positioning changes, documents, links, or market context",
        intro:
          "Axy.digital's marketing engine improves as your context improves. When you upload new documents or add new links to your knowledge base, Axy.digital detects the new information and prompts you to regenerate your marketing strategy and channel plans. This helps the engine stay aligned with your latest positioning, products, audience, offers, proof points, and market focus. You can also toggle between previous strategy versions, such as v1, v2, and future versions, and edit strategy fields directly when you want to make manual changes.",
        blocks: [
          img(),
          h2("When to use this workflow"),
          p("Use this workflow when you have new or updated materials, such as:"),
          ul([
            "Product briefs",
            "Sales decks",
            "Pitch decks",
            "Whitepapers",
            "Case studies",
            "Customer research",
            "Market research",
            "Brand guidelines",
            "Positioning docs",
            "Messaging documents",
            "Pricing updates",
            "Website pages",
            "Blog posts",
            "Documentation pages",
            "GitHub links",
            "Help center articles",
            "Partnership announcements",
            "Product launch materials",
          ]),
          p(
            "This is especially useful when your company's positioning, audience, product, or GTM strategy has changed.",
          ),
          img(),
          h2("Before you start"),
          p("Make sure you have:"),
          ul([
            "Completed onboarding",
            "Approved your current marketing strategy",
            "Reviewed your current channel plans",
            "Prepared the new documents or links you want to add",
          ]),
          p(
            "Your new resources do not need to be perfect. Axy.digital will use them as additional context and suggest updates where relevant.",
          ),
          img(
            usrStep1,
            "Knowledge Base page listing uploaded company documents with PDF and Document tags",
          ),
          h2("Step 1: Open your Knowledge Base"),
          p("Go to your workspace and open Knowledge Base."),
          p(
            "This is where Axy.digital stores the documents, links, and resources it uses to understand your business.",
          ),
          p("Your knowledge base can include:"),
          ul([
            "Uploaded files",
            "Website pages",
            "Online resources",
            "Product docs",
            "Sales materials",
            "Brand documents",
            "Case studies",
            "Technical docs",
            "Market research",
            "Customer proof",
          ]),
          p(
            "Axy.digital uses this context across your strategy, channel plans, proposed briefs, campaigns, and generated content.",
          ),
          img(usrStep2, "Add Knowledge dialog offering From file or From website link options"),
          h2("Step 2: Upload new documents or add new links"),
          p("Add the new materials you want Axy.digital to learn from."),
          p("You can upload documents or add URLs such as:"),
          ul([
            "Product page links",
            "Docs pages",
            "Blog posts",
            "Case studies",
            "Whitepapers",
            "GitHub repositories",
            "Sales decks",
            "Product briefs",
            "Research reports",
            "Brand guidelines",
            "Partnership pages",
          ]),
          p(
            "After you add new resources, Axy.digital analyzes them and updates the knowledge base.",
          ),
          img(),
          h2("Step 3: Review the detected updates"),
          p(
            "When Axy.digital detects new documents or links, it identifies that your knowledge base has changed.",
          ),
          p(
            "Axy.digital then prompts you to regenerate your marketing strategy and channel plans.",
          ),
          p("This prompt appears because the new materials may affect:"),
          ul([
            "Positioning",
            "Target audience",
            "Pain points",
            "Value proposition",
            "Product messaging",
            "Proof points",
            "Content pillars",
            "Geographic focus",
            "Channel priorities",
            "GEO plan",
            "LinkedIn plan",
            "X plan",
            "Custom guidelines",
          ]),
          p(
            "You can choose to regenerate the strategy immediately or review the new resources first.",
          ),
          img(
            usrStep4,
            "Marketing Strategy page with Regenerate Strategy button highlighted in the top right",
          ),
          h2("Step 4: Regenerate your marketing strategy"),
          p(
            "When you regenerate your marketing strategy, Axy.digital creates a new version based on your updated knowledge base.",
          ),
          p("The regenerated strategy uses:"),
          ul([
            "Existing approved strategy",
            "Newly uploaded documents",
            "Newly added links",
            "Website context",
            "Social context",
            "Competitor context",
            "Product information",
            "Previous campaign context",
          ]),
          p(
            "This helps Axy.digital update your engine without forcing you to rebuild everything manually.",
          ),
          p(
            "For example, if you upload a new product brief, Axy.digital can update your product messaging, content pillars, CTAs, and campaign priorities.",
          ),
          p(
            "If you add a new case study, Axy.digital can add proof points and improve future campaign recommendations.",
          ),
          img(
            usrStep5,
            "Marketing Strategy with the Mission field active for editing in the new regenerated version",
          ),
          h2("Step 5: Review the new version"),
          p("After regeneration, review the new version of your strategy."),
          p("Check whether Axy.digital updated the right fields, such as:"),
          ul([
            "Vision",
            "Mission",
            "Problem statement",
            "Value proposition",
            "Taglines",
            "CTAs",
            "Marketing goals",
            "Target audience",
            "Pain points",
            "Industries",
            "Verticals",
            "Brand positioning",
            "Tone",
            "Personality",
          ]),
          p(
            "Make sure the new version reflects the latest information without introducing anything inaccurate.",
          ),
          img(),
          h2("Step 6: Review updated channel plans"),
          p(
            "Axy.digital also updates your channel plans where the new resources affect channel strategy.",
          ),
          p("Review plans for:"),
          ul(["GEO / AEO / SEO", "LinkedIn", "X"]),
          p("Check whether the updated channel plans reflect:"),
          ul([
            "New product priorities",
            "New audience segments",
            "New content pillars",
            "Updated proof points",
            "Updated CTAs",
            "New market focus",
            "New topics to prioritize",
            "New topics to avoid",
            "New language or geography settings",
            "Updated custom guidelines",
          ]),
          p("The goal is to make sure each channel translates the updated strategy correctly."),
          img(
            usrStep7,
            "Strategy version dropdown open showing v1 through v5 with v5 marked as current",
          ),
          h2("Step 7: Toggle between previous versions"),
          p("Axy.digital keeps previous versions of your strategy, such as:"),
          ul(["v1", "v2", "v3"]),
          p("You can toggle between versions to compare what changed."),
          p("Use version history to:"),
          ul([
            "Review previous positioning",
            "Compare old and new strategy fields",
            "Check whether a regenerated version improved the strategy",
            "Restore or reference earlier language",
            "Understand how your engine has evolved over time",
          ]),
          p(
            "This is useful when your team wants to track how messaging, audience, or product focus has changed.",
          ),
          img(),
          h2("Step 8: Edit fields directly"),
          p("You do not need to accept everything Axy.digital generates."),
          p("You can edit fields directly in your marketing strategy and channel plans."),
          p("Use manual edits when you want to:"),
          ul([
            "Tighten positioning",
            "Correct product details",
            "Add a missing audience",
            "Remove inaccurate claims",
            "Adjust tone",
            "Update CTAs",
            "Add words to avoid",
            "Change channel guidelines",
            "Clarify geographic focus",
            "Change language instructions",
            "Add or remove content pillars",
          ]),
          p(
            "Direct edits update the context Axy.digital uses for future briefs, campaigns, and generated content.",
          ),
          img(),
          h2("Step 9: Approve the updated strategy and plans"),
          p("Once the updated strategy and channel plans look right, approve them."),
          p("Axy.digital will use the approved version across the engine."),
          p("Future outputs will reflect the updated context, including:"),
          ul([
            "Market intelligence recommendations",
            "Proposed briefs",
            "GEO articles",
            "LinkedIn posts",
            "X posts and threads",
            "Custom campaigns",
            "Internal link suggestions",
            "Marketing calendar content",
          ]),
          p("This keeps the entire engine aligned with your latest business context."),
          img(),
          h2("FAQ"),
          h3("What happens when I upload new documents or links?"),
          p(
            "Axy.digital analyzes the new resources and adds them to your knowledge base. When new context is detected, Axy.digital prompts you to regenerate your marketing strategy and channel plans.",
          ),
          h3("Do I have to regenerate my strategy every time?"),
          p(
            "No. You can choose when to regenerate. If the new materials affect your positioning, audience, product, or campaign direction, regenerating is usually useful.",
          ),
          h3("Can I compare old and new strategy versions?"),
          p(
            "Yes. You can toggle between previous versions, such as v1, v2, and future versions, to compare how your strategy has changed.",
          ),
          h3("Can I edit the strategy manually?"),
          p(
            "Yes. You can edit strategy and channel plan fields directly. Manual edits update the context Axy.digital uses for future outputs.",
          ),
          h3("Will updated strategy affect future campaigns?"),
          p(
            "Yes. Once approved, the updated strategy and channel plans affect future proposed briefs, generated content, internal links, and campaign recommendations.",
          ),
          h3("Will old campaigns change automatically?"),
          p(
            "No. Updating your strategy affects future outputs. Existing drafts or published campaigns should be reviewed separately if you want them to reflect the new strategy.",
          ),
          img(),
          h2("Best practices"),
          h3("Upload new resources when strategy changes"),
          p(
            "Add new docs whenever your product, positioning, audience, pricing, proof points, or market focus changes.",
          ),
          h3("Regenerate after major updates"),
          p(
            "If you upload a product brief, new deck, case study, or positioning doc, regenerate your strategy so Axy.digital can update the engine.",
          ),
          h3("Compare versions before approving"),
          p("Use version history to make sure the new version improves the strategy."),
          h3("Edit directly when needed"),
          p("Axy.digital gives you a strong draft, but you can always manually refine fields."),
          h3("Keep channel plans aligned"),
          p(
            "After regenerating the main strategy, review GEO, LinkedIn, and X plans to make sure each channel reflects the update correctly.",
          ),
        ],
        next: [
          "/tutorials/review-marketing-strategy-and-channel-plans",
          "/tutorials/customize-geography-and-language",
          "/tutorials/how-axy-generates-campaigns",
        ],
      },
    ],
  },
  {
    title: "Campaign playbooks",
    articles: [
      {
        slug: "turn-signals-into-campaigns",
        title: "How to Turn Signals Into Campaigns",
        metaTitle: "How to Turn Signals Into Campaigns | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital turns market signals, AI visibility gaps, search demand, competitor updates, and news headlines into proposed campaign briefs.",
        category: "Campaign Playbooks",
        product: "Market Intelligence, Campaign Generation",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor:
          "Users who want to understand how Axy.digital turns market activity into campaign opportunities",
        intro:
          "Axy.digital turns live market signals into campaign briefs your team can act on. Instead of starting from a blank content calendar, Axy.digital looks at what is happening in your market, identifies relevant opportunities, and suggests campaigns inside Workspace → Proposed Briefs. From there, you can review the briefs you like, click Generate, and Axy.digital will create channel-ready content for GEO, LinkedIn, and X.",
        blocks: [
          img(),
          h2("What counts as a signal?"),
          p(
            "A signal is any market event, trend, gap, or piece of information that may create a campaign opportunity.",
          ),
          p("Axy.digital can generate proposed briefs from:"),
          ul([
            "Market intelligence signals",
            "AI visibility gaps",
            "Search demand opportunities",
            "Competitor updates",
            "Social trends",
            "News headlines",
          ]),
          p(
            "Each signal is evaluated against your approved marketing strategy, channel plans, competitors, website index, and channel guidelines.",
          ),
          img(),
          h2("Step 1: Review market intelligence signals"),
          p("Market intelligence signals show what your market is reacting to."),
          p("These may come from:"),
          ul([
            "News headlines",
            "Research",
            "LinkedIn",
            "X",
            "Competitor updates",
            "Category shifts",
            "Customer questions",
          ]),
          p(
            "A signal might be a new regulation, an industry debate, a research report, a product launch, or a customer pain point gaining attention.",
          ),
          p(
            "If the signal is relevant to your audience and connected to your positioning, Axy.digital may turn it into a proposed campaign brief.",
          ),
          img(),
          h2("Step 2: Review AI visibility gaps"),
          p(
            "AI visibility gaps show where your brand is missing from important AI-generated answers.",
          ),
          p(
            "For example, Axy.digital may detect that competitors are being mentioned for prompts like:",
          ),
          ul([
            "“Best AI marketing tools for B2B SaaS”",
            "“How to improve AI search visibility”",
            "“Alternatives to SEO agencies”",
            "“GEO tools for startups”",
          ]),
          p(
            "These gaps can become campaign opportunities because they show where your brand needs stronger content, clearer positioning, or better citation signals.",
          ),
          p(
            "Axy.digital can turn these gaps into proposed briefs for GEO articles, comparison pages, LinkedIn posts, X threads, and supporting content.",
          ),
          img(),
          h2("Step 3: Review search demand opportunities"),
          p("Search demand opportunities show what your audience is actively looking for."),
          p("Axy.digital may identify:"),
          ul([
            "Rising keywords",
            "Prompt opportunities",
            "Customer questions",
            "Comparison searches",
            "Use-case searches",
            "Problem-aware searches",
            "Category searches",
          ]),
          p("Search demand is useful because it shows existing intent."),
          p(
            "If a topic has rising search demand and fits your strategy, Axy.digital may suggest a campaign brief designed to help you capture that demand.",
          ),
          img(),
          h2("Step 4: Review competitor updates"),
          p("Competitor updates show what other companies in your market are doing."),
          p("Axy.digital may detect:"),
          ul([
            "New competitor pages",
            "New blog posts",
            "Product launches",
            "Messaging changes",
            "New comparison content",
            "Social campaigns",
            "AI visibility changes",
            "Category positioning shifts",
          ]),
          p(
            "Competitor updates can become campaign opportunities when they reveal a gap, threat, or opening.",
          ),
          p(
            "For example, if a competitor starts owning a narrative you care about, Axy.digital may suggest a campaign that helps you respond with your own point of view.",
          ),
          img(),
          h2("Step 5: Review social trends"),
          p(
            "Social trends show what your audience is discussing across channels like LinkedIn and X.",
          ),
          p("Axy.digital may identify:"),
          ul([
            "Recurring pain points",
            "Viral post formats",
            "Emerging debates",
            "Founder conversations",
            "Customer objections",
            "Category narratives",
            "High-engagement topics",
          ]),
          p(
            "Social trends are especially useful for LinkedIn and X content because they reflect what people are already paying attention to.",
          ),
          p(
            "Axy.digital can turn social trends into thought leadership, commentary, founder posts, short-form posts, or threads.",
          ),
          img(),
          h2("Step 6: Review news headlines"),
          p("News headlines can create timely campaign opportunities."),
          p("Axy.digital may use news to identify:"),
          ul([
            "Regulatory changes",
            "Market events",
            "Funding announcements",
            "Industry reports",
            "Product launches",
            "Economic shifts",
            "Technology changes",
            "Customer behavior changes",
          ]),
          p(
            "A news headline becomes useful when your company has a relevant perspective or product connection.",
          ),
          p(
            "Axy.digital can turn that headline into educational content, market commentary, GEO articles, or social posts.",
          ),
          img(),
          h2("Step 7: Open Proposed Briefs"),
          p(
            "Once Axy.digital identifies a relevant opportunity, it creates a brief in Workspace → Proposed Briefs.",
          ),
          p("Each proposed brief may include:"),
          ul([
            "Campaign topic",
            "Source signal",
            "Target audience",
            "Recommended channel",
            "Suggested angle",
            "Why the campaign matters",
            "Search or prompt opportunity",
            "Competitor context",
            "Suggested CTA",
            "Internal link opportunities",
          ]),
          p("This lets you quickly decide whether the campaign is worth generating."),
          img(),
          h2("Step 8: Generate the campaign"),
          p("When you find a brief you like, click Generate."),
          p("Axy.digital will generate the campaign using:"),
          ul([
            "The source signal",
            "Your approved marketing strategy",
            "Your channel plans",
            "Your channel guidelines",
            "Your competitor context",
            "Your knowledge base",
            "Your website index",
            "Relevant AI visibility and search data",
          ]),
          p(
            "The generated content is added to your Marketing Calendar for review, editing, approval, scheduling, or publishing.",
          ),
          img(),
          h2("FAQ"),
          h3("Do I need to act on every signal?"),
          p(
            "No. Axy.digital may surface more signals than you need. Prioritize signals that are relevant to your ICP, connected to your product, timely, and useful for your current growth goals.",
          ),
          h3("How do I know which proposed briefs to generate?"),
          p(
            "Choose briefs that support your strategy, have clear audience relevance, connect to real demand, or help close an AI visibility gap.",
          ),
          h3("Are signal-based campaigns already optimized for each channel?"),
          p(
            "Yes. Axy.digital uses your GEO, LinkedIn, and X plans and guidelines to adapt the campaign for each channel.",
          ),
          h3("Where does the generated content go?"),
          p(
            "Generated campaign content is added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export it.",
          ),
          img(),
          h2("Best practices"),
          h3("Review Proposed Briefs weekly"),
          p("Use Proposed Briefs as your weekly campaign planning layer."),
          h3("Prioritize demand-backed signals"),
          p(
            "The strongest signals are usually supported by search demand, AI visibility gaps, or social traction.",
          ),
          h3("Act early on emerging trends"),
          p(
            "If a signal is relevant and still forming, publishing early can help you own the narrative.",
          ),
          h3("Use competitors as context, not direction"),
          p(
            "Competitor movement can reveal opportunities, but your campaign should still reflect your own strategy and point of view.",
          ),
          h3("Keep your strategy updated"),
          p("Better strategy and channel guidelines lead to better proposed briefs."),
        ],
        next: [
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/read-your-market-intelligence-dashboard",
          "/tutorials/read-your-ai-visibility-report",
          "/tutorials/use-the-marketing-calendar",
        ],
      },
      {
        slug: "turn-product-brief-into-launch-campaign",
        title: "How to Turn a Product Brief Into a Product Launch Campaign",
        metaTitle:
          "How to Turn a Product Brief Into a Product Launch Campaign | Axy.digital Tutorial",
        metaDescription:
          "Learn how to turn a product brief, feature update, or launch note into a full product launch campaign across GEO, LinkedIn, and X with Axy.digital.",
        category: "Campaign Playbooks",
        product: "Custom Campaigns",
        difficulty: "Beginner",
        estimatedTime: "8 minutes",
        bestFor: "Users launching a new product, feature, integration, service, or major update",
        intro:
          "Product launches need more than one announcement post. A good launch usually needs a clear narrative, product education, social distribution, search-friendly content, founder commentary, and follow-up angles. With Axy.digital, you can upload or paste a product brief and turn it into a full campaign across GEO, LinkedIn, and X. Axy.digital uses your product brief, approved marketing strategy, channel plans, website index, knowledge base, competitors, and channel guidelines to generate launch content that fits your brand and audience.",
        blocks: [
          img(),
          h2("When to use this workflow"),
          p("Use this workflow when you want to announce or promote:"),
          ul([
            "A new product",
            "A new feature",
            "A new integration",
            "A product update",
            "A new service",
            "A beta launch",
            "A public launch",
            "A platform upgrade",
            "A new dashboard or report",
            "A major workflow improvement",
          ]),
          p(
            "This is useful when you already know what changed, but need help turning that update into clear, channel-ready marketing assets.",
          ),
          img(),
          h2("Before you start"),
          p(
            "Prepare a short product brief. It does not need to be polished. Axy.digital can work from rough notes.",
          ),
          p("Useful details include:"),
          ul([
            "Product or feature name",
            "What is launching",
            "Who it is for",
            "What problem it solves",
            "Why it matters now",
            "Key benefits",
            "Key features",
            "Target audience",
            "Use cases",
            "Proof points or early results",
            "Launch date, if relevant",
            "CTA",
            "Any claims or phrases to avoid",
          ]),
          p("The more specific the brief, the stronger the generated campaign will be."),
          img(),
          h2("Step 1: Open Custom Campaigns"),
          p("From your workspace, open the campaign creation area and choose Custom Campaign."),
          p(
            "Use Custom Campaigns when you want to generate content from your own source material instead of choosing from Axy.digital’s Proposed Briefs.",
          ),
          p(
            "For a product launch, your source material will usually be a product brief, feature note, release summary, launch announcement draft, or internal product document.",
          ),
          img(),
          h2("Step 2: Upload or paste your product brief"),
          p("Add your product brief to Axy.digital."),
          p("You can upload or paste content such as:"),
          ul([
            "Product brief",
            "Launch notes",
            "Feature description",
            "Internal memo",
            "Product requirements document",
            "Sales enablement notes",
            "Existing announcement draft",
            "Customer feedback about the feature",
            "Help docs or product documentation",
            "Website or product page URL",
          ]),
          p(
            "Your brief can be rough. It just needs to give Axy.digital enough context to understand what is launching and why it matters.",
          ),
          img(),
          h2("Step 3: Add launch context"),
          p(
            "After adding the product brief, add any extra context that will help Axy.digital frame the campaign.",
          ),
          p("Useful context includes:"),
          ul([
            "Is this a beta launch, public launch, or feature update?",
            "Who is the primary audience?",
            "What is the main pain point?",
            "What should the audience do next?",
            "Is the launch educational, product-led, founder-led, or announcement-led?",
            "Should the tone be bold, practical, technical, premium, or conversational?",
            "Are there customer quotes, metrics, or proof points?",
            "Are there competitors or alternatives this launch should be positioned against?",
            "Are there topics or claims to avoid?",
          ]),
          p("For example:"),
          {
            type: "callout",
            text: "We are launching AI Visibility Analytics for B2B SaaS companies. The goal is to explain why AI search visibility matters, show how Axy.digital tracks prompts, mentions, citations, and competitor visibility, and invite users to generate their first report.",
          },
          p("This context helps Axy.digital turn the product update into a stronger campaign."),
          img(),
          h2("Step 4: Review the generated campaign brief"),
          p("Axy.digital will turn your product brief into a structured campaign brief."),
          p("The brief may include:"),
          ul([
            "Campaign topic",
            "Launch narrative",
            "Target audience",
            "Main pain point",
            "Key message",
            "Product benefits",
            "Recommended channels",
            "Suggested CTA",
            "Supporting proof",
            "Internal link opportunities",
            "Channel-specific considerations",
          ]),
          p("Review the brief before generating the full campaign."),
          p("Check:"),
          ul([
            "Is the product described accurately?",
            "Is the audience correct?",
            "Is the launch angle strong?",
            "Is the value proposition clear?",
            "Are the benefits specific?",
            "Is the CTA right?",
            "Are any claims unsupported?",
            "Are important product details missing?",
          ]),
          p(
            "Edit the brief if needed. This is the best place to fix the campaign direction before generating assets.",
          ),
          img(),
          h2("Step 5: Click Generate"),
          p("Once the launch brief looks right, click Generate."),
          p(
            "Axy.digital will automatically generate the right content suite based on the brief, your approved strategy, and your channel guidelines.",
          ),
          p("Depending on your setup and selected channels, Axy.digital may generate:"),
          ul([
            "Launch announcement copy",
            "GEO article",
            "SEO article",
            "AEO answer content",
            "LinkedIn posts",
            "X posts",
            "X threads",
            "Founder commentary",
            "Product education posts",
            "Feature explainers",
            "Suggested CTAs",
            "Internal links",
            "Follow-up campaign ideas",
          ]),
          p("Axy.digital automatically adapts the campaign for each channel."),
          img(),
          h2("Step 6: Review the generated launch assets"),
          p(
            "Review each generated asset before approving it. For a product launch, accuracy matters.",
          ),
          p("Check:"),
          ul([
            "Product name",
            "Feature description",
            "Use cases",
            "Audience",
            "Claims",
            "Metrics",
            "Dates",
            "CTA",
            "Links",
            "Internal links",
            "Tone of voice",
            "Technical accuracy",
            "Customer or partner references",
            "Competitor references",
          ]),
          p("Make sure the campaign explains the launch clearly and does not overpromise."),
          img(),
          h2("Step 7: Find the campaign in your Marketing Calendar"),
          p("Once generated, your product launch campaign is added to your Marketing Calendar."),
          p("From the calendar, you can:"),
          ul([
            "Review each asset",
            "Edit drafts",
            "Approve content",
            "Schedule posts",
            "Publish or export content",
            "Coordinate launch timing",
            "Save follow-up posts for later",
          ]),
          p("This lets you manage the launch as a sequence, not a one-off post."),
          img(),
          h2("Step 8: Sequence your launch campaign"),
          p("A strong product launch usually benefits from multiple touchpoints."),
          p("For example, you might sequence the campaign like this:"),
          ul([
            "Publish a launch article or GEO page.",
            "Share a founder LinkedIn post explaining the point of view behind the launch.",
            "Publish a company LinkedIn post with the product update and CTA.",
            "Share an X thread breaking down the problem, solution, and workflow.",
            "Publish follow-up posts with use cases, customer questions, or proof points.",
          ]),
          p("The Marketing Calendar helps you spread these assets across the launch window."),
          img(),
          h2("FAQ"),
          h3("Do I need a polished product brief?"),
          p(
            "No. Axy.digital can work from rough notes, internal docs, or an unfinished announcement draft. The output will be stronger if you include clear details about the audience, problem, benefits, use cases, and CTA.",
          ),
          h3("Can Axy.digital create the full launch campaign from one brief?"),
          p(
            "Yes. Axy.digital can turn one product brief into a full suite of launch content across GEO, LinkedIn, and X. The exact assets depend on your channel plans, guidelines, and campaign setup.",
          ),
          h3("Can I use this for feature updates, not just big launches?"),
          p(
            "Yes. This workflow works for major launches, smaller feature updates, integrations, dashboards, reports, service updates, and workflow improvements.",
          ),
          h3("Where does the generated launch content go?"),
          p(
            "Generated launch content is added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export the assets.",
          ),
          img(),
          h2("Best practices"),
          h3("Include the “why now”"),
          p(
            "A launch is stronger when it connects to a market shift, customer problem, or timely reason the product matters.",
          ),
          h3("Be specific about the audience"),
          p(
            "A product launch for founders should sound different from one for enterprise marketing teams, agencies, or technical buyers.",
          ),
          h3("Add proof where possible"),
          p(
            "Metrics, customer feedback, screenshots, or early results make launch content more credible.",
          ),
          h3("Review claims carefully"),
          p(
            "Product launch content can easily overstate what a feature does. Check accuracy before publishing.",
          ),
          h3("Turn one launch into multiple assets"),
          p(
            "Do not waste a strong product update on one announcement post. Use Axy.digital to turn it into GEO content, LinkedIn posts, X threads, and follow-up campaigns.",
          ),
        ],
        next: [
          "/tutorials/create-custom-campaigns",
          "/tutorials/use-the-marketing-calendar",
          "/tutorials/turn-client-feedback-into-case-study",
          "/tutorials/repurpose-one-campaign-across-channels",
        ],
      },
      {
        slug: "turn-client-feedback-into-case-study",
        title: "How to Turn Client Feedback Into a Case Study Campaign",
        metaTitle: "How to Turn Client Feedback Into a Case Study Campaign | Axy.digital Tutorial",
        metaDescription:
          "Learn how to use Axy.digital to turn client feedback, results, quotes, notes, and a customer website into a polished case study and supporting campaign assets.",
        category: "Campaign Playbooks",
        product: "Custom Campaigns",
        difficulty: "Beginner",
        estimatedTime: "8 minutes",
        bestFor:
          "Users creating proof-led marketing from client wins, customer feedback, testimonials, or project results",
        intro:
          "Client feedback is one of the strongest inputs you can give your marketing engine. With Axy.digital, you can turn rough customer notes, client quotes, project context, results, and a customer website into a polished case study campaign. Axy.digital can generate the case study itself, plus supporting LinkedIn posts, X posts, proof snippets, and follow-up content. This helps you turn customer proof into marketing assets without starting from scratch.",
        blocks: [
          img(),
          h2("When to use this workflow"),
          p("Use this workflow when you have:"),
          ul([
            "Client feedback",
            "Customer quotes",
            "Testimonial notes",
            "Project results",
            "Before-and-after details",
            "A successful implementation",
            "A customer story",
            "Screenshots or examples",
            "A client website",
            "Sales notes from a customer call",
          ]),
          p(
            "This is especially useful when you know there is a good story, but the raw material is scattered across messages, notes, docs, or calls.",
          ),
          img(),
          h2("Before you start"),
          p("Prepare any source material you have."),
          p("Useful inputs include:"),
          ul([
            "Client name",
            "Client website",
            "Industry",
            "Company description",
            "Original problem",
            "Why they chose you",
            "What you helped them do",
            "Product or service used",
            "Timeline",
            "Results",
            "Metrics",
            "Client quotes",
            "Screenshots",
            "Before-and-after notes",
            "Any claims that require approval",
          ]),
          p(
            "You do not need all of these. Axy.digital can work from partial notes, but the more context you provide, the stronger the case study will be.",
          ),
          img(),
          h2("Step 1: Open Custom Campaigns"),
          p("From your workspace, open the campaign creation area and choose Custom Campaign."),
          p(
            "Use this when you want to create a campaign from your own customer proof instead of choosing from Proposed Briefs.",
          ),
          img(),
          h2("Step 2: Add client feedback and source material"),
          p("Add the client feedback, project notes, or testimonial content."),
          p("You can paste or upload:"),
          ul([
            "Customer quotes",
            "Notes from calls",
            "Client messages",
            "Project summaries",
            "Results or metrics",
            "Before-and-after details",
            "Implementation notes",
            "Screenshots",
            "Relevant links",
          ]),
          p(
            "If you have the client website, add it too. Axy.digital can use the website to understand the client’s business, category, audience, and positioning.",
          ),
          img(),
          h2("Step 3: Add case study context"),
          p("Add any extra context that will help Axy.digital tell the story accurately."),
          p("Useful context includes:"),
          ul([
            "What problem did the client have?",
            "What were they trying to achieve?",
            "What did your team or product help them do?",
            "What changed after using your product?",
            "What results can you mention?",
            "Which product or feature should the case study highlight?",
            "Which audience should the case study speak to?",
            "Are there any sensitive details to avoid?",
            "Does the client need to approve the final version?",
          ]),
          p("For example:"),
          {
            type: "callout",
            text: "The client is a B2B SaaS company that used Axy.digital to improve AI visibility and generate weekly GEO and LinkedIn campaigns. They were struggling to publish consistently and wanted content tied to real market demand. We want the case study to highlight faster execution, better content quality, and improved visibility.",
          },
          img(),
          h2("Step 4: Review the generated case study brief"),
          p("Axy.digital will turn your inputs into a structured case study brief."),
          p("The brief may include:"),
          ul([
            "Client overview",
            "Original problem",
            "Solution used",
            "Implementation summary",
            "Key outcomes",
            "Suggested narrative",
            "Target audience",
            "Recommended channels",
            "Supporting quotes",
            "Suggested CTA",
            "Internal link opportunities",
          ]),
          p("Review the brief carefully before generating the full campaign."),
          p("Check:"),
          ul([
            "Is the client described accurately?",
            "Is the problem clear?",
            "Are the results correct?",
            "Are the claims approved or supportable?",
            "Does the story highlight the right product or service?",
            "Is the angle relevant to future buyers?",
            "Are there any details that should be removed?",
          ]),
          img(),
          h2("Step 5: Click Generate"),
          p("Once the brief looks right, click Generate."),
          p("Axy.digital may generate:"),
          ul([
            "Full case study",
            "Short case study summary",
            "LinkedIn case study post",
            "Founder-led proof post",
            "X thread",
            "X proof snippets",
            "Sales enablement copy",
            "Customer quote cards",
            "Follow-up campaign angles",
            "Internal link suggestions",
          ]),
          p(
            "Axy.digital automatically adapts the campaign to your strategy, channel plans, and channel guidelines.",
          ),
          img(),
          h2("Step 6: Review the generated case study"),
          p("Review the case study carefully."),
          p("Check:"),
          ul([
            "Client name",
            "Industry",
            "Problem statement",
            "Solution description",
            "Product details",
            "Results",
            "Metrics",
            "Quotes",
            "Timeline",
            "Claims",
            "Internal links",
            "CTA",
          ]),
          p("Case studies need a higher level of factual review than general content."),
          p(
            "If you are using client quotes or naming the client publicly, make sure you have approval where needed.",
          ),
          img(),
          h2("Step 7: Review supporting campaign assets"),
          p("Axy.digital may also generate supporting content for LinkedIn and X."),
          p("Review whether the social assets:"),
          ul([
            "Use proof accurately",
            "Avoid overstating results",
            "Respect client confidentiality",
            "Link to the case study where relevant",
            "Match your channel guidelines",
            "Clearly explain why the story matters",
            "Use the right CTA",
          ]),
          p("You can edit or remove any asset before approving."),
          img(),
          h2("Step 8: Add the campaign to your Marketing Calendar"),
          p("Once generated, the case study campaign appears in your Marketing Calendar."),
          p("From the calendar, you can:"),
          ul([
            "Review assets",
            "Edit drafts",
            "Approve content",
            "Schedule posts",
            "Publish or export content",
            "Coordinate case study promotion",
            "Save follow-up posts for later",
          ]),
          p("This helps you turn one client story into a coordinated proof campaign."),
          img(),
          h2("FAQ"),
          h3("Do I need metrics to create a case study?"),
          p(
            "No, but metrics help. If you do not have numbers, you can still create a strong qualitative case study using the client’s problem, process, quote, and outcome.",
          ),
          h3("Can Axy.digital use a client website as context?"),
          p(
            "Yes. Adding the client website helps Axy.digital understand the client’s business, audience, category, and positioning.",
          ),
          h3("Can Axy.digital create a case study from rough notes?"),
          p(
            "Yes. You can paste rough notes, client messages, or internal summaries. Axy.digital will structure them into a clearer case study brief and campaign.",
          ),
          h3("Should I get client approval before publishing?"),
          p(
            "Yes, if you are naming the client, using quotes, sharing results, or revealing project details.",
          ),
          h3("Where does the generated case study campaign go?"),
          p(
            "Generated case study assets are added to your Marketing Calendar for review, editing, approval, scheduling, or export.",
          ),
          img(),
          h2("Best practices"),
          h3("Add the client’s original problem"),
          p("The story is stronger when readers understand what was hard before your solution."),
          h3("Include specific outcomes"),
          p(
            "Metrics, time saved, visibility improvements, engagement growth, or qualitative wins make the case study more credible.",
          ),
          h3("Use quotes carefully"),
          p("Client quotes are powerful, but they should be accurate and approved."),
          h3("Keep the story buyer-relevant"),
          p("A case study should help future buyers see themselves in the problem and outcome."),
          h3("Turn proof into multiple assets"),
          p(
            "A good case study can become a page, LinkedIn post, X thread, sales snippet, and follow-up campaign.",
          ),
        ],
        next: [
          "/tutorials/create-custom-campaigns",
          "/tutorials/use-the-marketing-calendar",
          "/tutorials/turn-product-brief-into-launch-campaign",
          "/tutorials/repurpose-one-campaign-across-channels",
        ],
      },
      {
        slug: "turn-draft-article-or-post-into-campaign",
        title: "How to Turn a Draft, Article, or Social Post Into a Campaign",
        metaTitle:
          "How to Turn a Draft, Article, or Social Post Into a Campaign | Axy.digital Tutorial",
        metaDescription:
          "Learn how to use Axy.digital to turn rough drafts, articles, LinkedIn posts, tweets, and content ideas into full campaigns across GEO, LinkedIn, and X.",
        category: "Campaign Playbooks",
        product: "Custom Campaigns",
        difficulty: "Beginner",
        estimatedTime: "8 minutes",
        bestFor:
          "Users who already have source material and want Axy.digital to turn it into finished campaign assets",
        intro:
          "Sometimes you do not need Axy.digital to find the signal. You already have the idea. Maybe it is a rough draft, a half-written post, an article you like, a tweet you want to respond to, or a LinkedIn post that sparked a point of view. Axy.digital can take that source material and turn it into a full campaign across GEO, LinkedIn, and X. This workflow helps you turn unfinished or external inspiration into on-brand, channel-ready content.",
        blocks: [
          img(),
          h2("When to use this workflow"),
          p("Use this workflow when you have:"),
          ul([
            "A rough blog draft",
            "A half-written LinkedIn post",
            "A tweet or X post you want to respond to",
            "A LinkedIn post you like",
            "An article you want to comment on",
            "A podcast transcript",
            "A founder note",
            "A research snippet",
            "A customer conversation",
            "A content idea",
            "A messy internal memo",
            "A draft that needs polishing",
          ]),
          p(
            "This is useful when the raw idea exists, but it needs structure, positioning, channel adaptation, or finishing.",
          ),
          img(),
          h2("Before you start"),
          p("Prepare the source material you want Axy.digital to use."),
          p("You can provide:"),
          ul([
            "A pasted draft",
            "A URL",
            "A LinkedIn post",
            "A tweet or X post",
            "An article",
            "Notes",
            "Bullet points",
            "A transcript",
            "A short content idea",
            "Supporting context",
          ]),
          p("You should also clarify what you want Axy.digital to do with it. For example:"),
          ul([
            "Finish this draft",
            "Turn this into LinkedIn commentary",
            "Turn this into a GEO article",
            "Create an X thread from this idea",
            "Turn this article into our own point of view",
            "Create a full cross-channel campaign from this draft",
          ]),
          img(),
          h2("Step 1: Open Custom Campaigns"),
          p(
            "From your workspace, open the campaign creation area and choose Custom Campaign. This lets you create a campaign from your own source material.",
          ),
          img(),
          h2("Step 2: Add your source material"),
          p("Paste, upload, or link the content you want Axy.digital to work from."),
          p("This might be:"),
          ul([
            "A rough draft",
            "A LinkedIn post",
            "An X post",
            "An article URL",
            "A Google Doc",
            "A transcript",
            "A note",
            "A content idea",
            "A customer quote",
            "A set of bullets",
          ]),
          p(
            "Axy.digital will use this as the starting point, then align the output with your approved strategy, knowledge base, and channel guidelines.",
          ),
          img(),
          h2("Step 3: Add your point of view"),
          p(
            "If you are using someone else’s post or article as inspiration, add your own take. This helps Axy.digital generate original commentary instead of simply summarizing the source.",
          ),
          p("Useful context includes:"),
          ul([
            "Do you agree or disagree?",
            "What is your angle?",
            "What would your audience find useful?",
            "What should the content argue?",
            "What should it avoid saying?",
            "Should the tone be educational, contrarian, practical, technical, or founder-led?",
            "Should the output promote a product, explain a concept, or respond to a trend?",
          ]),
          p("For example:"),
          {
            type: "callout",
            text: "Use this article as inspiration, but our point of view is that most companies are not struggling with content volume. They are struggling with knowing what to create while demand is still active.",
          },
          img(),
          h2("Step 4: Review the generated campaign brief"),
          p("Axy.digital will turn your input into a structured campaign brief."),
          p("The brief may include:"),
          ul([
            "Source summary",
            "Campaign angle",
            "Target audience",
            "Key message",
            "Recommended channels",
            "Suggested CTA",
            "Supporting points",
            "Internal link opportunities",
            "Channel-specific considerations",
          ]),
          p("Review the brief before generating the full campaign."),
          p("Check:"),
          ul([
            "Does the angle reflect your point of view?",
            "Is the source interpreted correctly?",
            "Is the audience right?",
            "Is the CTA appropriate?",
            "Is the campaign original enough?",
            "Does it avoid copying the source?",
            "Does it align with your strategy?",
          ]),
          p("Edit the brief if needed."),
          img(),
          h2("Step 5: Click Generate"),
          p("Once the brief looks right, click Generate."),
          p("Axy.digital may generate:"),
          ul([
            "Finished blog draft",
            "GEO article",
            "LinkedIn post",
            "Founder commentary",
            "X post",
            "X thread",
            "Article response",
            "Campaign extension",
            "Suggested CTA",
            "Internal links",
            "Follow-up ideas",
          ]),
          p(
            "Axy.digital automatically adapts the content for each channel based on your strategy and channel guidelines.",
          ),
          img(),
          h2("Step 6: Review the generated content"),
          p("Review the content before approving it."),
          p("Check:"),
          ul([
            "Is it original?",
            "Does it reflect your point of view?",
            "Does it avoid copying the source?",
            "Is the argument clear?",
            "Does it match your voice?",
            "Does it follow channel guidelines?",
            "Is the CTA right?",
            "Are internal links relevant?",
            "Are claims accurate?",
            "Does it need more specificity?",
          ]),
          p(
            "If the content sounds too close to the source material, edit the brief or add a stronger point of view.",
          ),
          img(),
          h2("Step 7: Add the campaign to your Marketing Calendar"),
          p("Once generated, the campaign appears in your Marketing Calendar."),
          p("From the calendar, you can:"),
          ul([
            "Review each asset",
            "Edit drafts",
            "Approve content",
            "Schedule posts",
            "Publish or export content",
            "Save follow-up ideas",
            "Coordinate timing across channels",
          ]),
          p("This lets you turn a single draft or source into a complete marketing sequence."),
          img(),
          h2("FAQ"),
          h3("Can I upload a rough draft?"),
          p(
            "Yes. You can upload or paste a rough draft, and Axy.digital can help finish, restructure, polish, or repurpose it.",
          ),
          h3("Can I use a LinkedIn post, tweet, or article as inspiration?"),
          p(
            "Yes. You can link to content you like and ask Axy.digital to generate on-brand commentary. Use the source as context, not something to copy.",
          ),
          h3("Will Axy.digital copy the source content?"),
          p(
            "No. Axy.digital should use the source as context and generate original content aligned with your strategy and point of view. You should still review the output before publishing.",
          ),
          h3("Can Axy.digital turn one draft into multiple assets?"),
          p(
            "Yes. One draft can become a GEO article, LinkedIn post, X thread, founder commentary, and follow-up campaign.",
          ),
          h3("Where does the generated content go?"),
          p(
            "Generated assets are added to your Marketing Calendar for review, editing, approval, scheduling, or export.",
          ),
          img(),
          h2("Best practices"),
          h3("Add your own point of view"),
          p(
            "The strongest campaigns do not just summarize source material. They add a perspective.",
          ),
          h3("Use rough drafts as inputs"),
          p(
            "You do not need polished copy. Axy.digital can help structure and finish messy ideas.",
          ),
          h3("Avoid copying external sources"),
          p("Use articles and posts as inspiration, then make the output original and on-brand."),
          h3("Clarify the desired outcome"),
          p(
            "Tell Axy.digital whether you want education, commentary, product promotion, or thought leadership.",
          ),
          h3("Review before publishing"),
          p("Make sure claims, references, and tone are accurate."),
        ],
        next: [
          "/tutorials/create-custom-campaigns",
          "/tutorials/use-the-marketing-calendar",
          "/tutorials/turn-product-brief-into-launch-campaign",
          "/tutorials/repurpose-one-campaign-across-channels",
        ],
      },
      {
        slug: "repurpose-one-campaign-across-channels",
        title: "How to Repurpose One Campaign Across GEO, LinkedIn, and X",
        metaTitle:
          "How to Repurpose One Campaign Across GEO, LinkedIn, and X | Axy.digital Tutorial",
        metaDescription:
          "Learn how Axy.digital turns one campaign idea into channel-specific content across GEO, LinkedIn, and X while keeping everything aligned with your strategy.",
        category: "Campaign Playbooks",
        product: "Campaign Generation, Marketing Calendar",
        difficulty: "Beginner",
        estimatedTime: "7 minutes",
        bestFor: "Users who want to turn one strong idea into a coordinated cross-channel campaign",
        intro:
          "One strong idea should not live in one format. A market signal, AI visibility gap, product launch, case study, or draft can become a full campaign across GEO, LinkedIn, and X. Axy.digital helps you repurpose one campaign idea into channel-specific assets while keeping the message aligned with your strategy. This means the same campaign can capture search demand, build thought leadership, and stay visible in fast-moving social conversations.",
        blocks: [
          img(),
          h2("Why repurposing matters"),
          p("Different channels serve different jobs."),
          ul([
            "GEO / AEO / SEO helps your content get found, cited, and recommended.",
            "LinkedIn helps build trust, authority, and professional credibility.",
            "X helps you respond quickly to narratives, trends, and conversations.",
          ]),
          p(
            "Repurposing lets one strong idea work across all three channels without manually rewriting everything from scratch.",
          ),
          img(),
          h2("When to use this workflow"),
          p("Use this workflow when you have:"),
          ul([
            "A GEO article",
            "A market intelligence signal",
            "An AI visibility gap",
            "A product launch",
            "A case study",
            "A competitor update",
            "A news headline",
            "A founder point of view",
            "A custom campaign",
            "A high-performing post",
            "A draft or article you want to expand",
          ]),
          p(
            "If the idea is important enough to publish once, it may be worth distributing across multiple channels.",
          ),
          img(),
          h2("Step 1: Start with the campaign idea"),
          p("Start with one clear campaign idea."),
          p("This could come from:"),
          ul([
            "Proposed Briefs",
            "Custom Campaigns",
            "AI Visibility Report",
            "Market Intelligence Dashboard",
            "Search demand",
            "Social performance",
            "Product updates",
            "Client feedback",
          ]),
          p("The idea should be specific enough to support multiple pieces of content."),
          p("For example:"),
          {
            type: "callout",
            text: "AI visibility is becoming a new organic growth channel because buyers are asking AI systems for recommendations before visiting websites.",
          },
          p(
            "That idea could become a GEO article, LinkedIn post, X thread, and follow-up social posts.",
          ),
          img(),
          h2("Step 2: Generate or open the campaign"),
          p(
            "If the campaign already exists, open it from your workspace or Marketing Calendar. If it is still a brief, click Generate.",
          ),
          p("Axy.digital will use:"),
          ul([
            "Your approved strategy",
            "Your channel plans",
            "Your channel guidelines",
            "Your website index",
            "Your knowledge base",
            "Your competitor context",
            "The source signal or input",
          ]),
          p(
            "The goal is to create assets that share the same strategic idea but are adapted to each channel.",
          ),
          img(),
          h2("Step 3: Review the GEO asset"),
          p("The GEO asset is usually the deepest version of the idea."),
          p("It may include:"),
          ul([
            "Direct answers",
            "Structured headings",
            "FAQs",
            "Internal links",
            "Prompt targeting",
            "Search intent",
            "Comparison or use-case sections",
            "CTA",
          ]),
          p(
            "Review whether it clearly answers the target question and supports AI visibility. The GEO asset can act as the foundation for social content because it contains the most complete explanation.",
          ),
          img(),
          h2("Step 4: Review the LinkedIn assets"),
          p(
            "LinkedIn content should translate the campaign into a professional, trust-building format.",
          ),
          p("Axy.digital may generate:"),
          ul([
            "Founder thought leadership",
            "Company page post",
            "Educational breakdown",
            "Product-led post",
            "Case study post",
            "Market commentary",
            "Launch post",
          ]),
          p("Review whether the LinkedIn content:"),
          ul([
            "Has a strong hook",
            "Matches your voice",
            "Feels useful to your audience",
            "Connects to the larger campaign",
            "Uses the right CTA",
            "Does not sound too generic",
            "Fits your LinkedIn guidelines",
          ]),
          p("LinkedIn should usually explain why the idea matters to your market."),
          img(),
          h2("Step 5: Review the X assets"),
          p("X content should make the campaign more concise, timely, and conversation-ready."),
          p("Axy.digital may generate:"),
          ul([
            "Short posts",
            "Threads",
            "Founder commentary",
            "Market commentary",
            "Product updates",
            "Campaign extensions",
          ]),
          p("Review whether the X content:"),
          ul([
            "Is concise",
            "Has a clear point of view",
            "Feels timely",
            "Avoids corporate language",
            "Matches your X guidelines",
            "Works as a standalone post or thread",
            "Connects back to the larger campaign where useful",
          ]),
          p("X is often best for sharper commentary, fast reactions, or condensed takeaways."),
          img(),
          h2("Step 6: Check consistency across channels"),
          p(
            "Before approving the campaign, check that the core message is consistent. The content should not be identical across channels, but it should feel connected.",
          ),
          p("Review:"),
          ul([
            "Is the main idea consistent?",
            "Is the CTA aligned?",
            "Are claims consistent?",
            "Is the audience the same or intentionally different?",
            "Are product details accurate?",
            "Do the social posts support the GEO article?",
            "Are internal links and external links correct?",
          ]),
          p("A good cross-channel campaign should feel coordinated, not copied and pasted."),
          img(),
          h2("Step 7: Schedule the campaign in your Marketing Calendar"),
          p("Once the assets are ready, use the Marketing Calendar to sequence the campaign."),
          p("A common sequence might be:"),
          ul([
            "Publish the GEO article.",
            "Share a LinkedIn post introducing the idea.",
            "Publish an X thread with the key takeaways.",
            "Share a follow-up LinkedIn post with a specific lesson or proof point.",
            "Post shorter X commentary later in the week.",
          ]),
          p("This gives the campaign multiple chances to reach your audience."),
          img(),
          h2("Step 8: Track performance by channel"),
          p("After publishing, review performance across GEO, LinkedIn, and X."),
          p("Look at:"),
          ul([
            "AI visibility movement",
            "Citation changes",
            "Search performance",
            "LinkedIn impressions and engagement",
            "X impressions and engagement",
            "Comments and replies",
            "Topic performance",
            "CTA performance",
            "Campaign-level performance",
          ]),
          p(
            "Use what you learn to decide whether the idea should become a follow-up campaign, tutorial, case study, or comparison page.",
          ),
          img(),
          h2("FAQ"),
          h3("Does repurposing mean posting the same thing everywhere?"),
          p(
            "No. Repurposing means adapting one idea for each channel. The message stays aligned, but the format, tone, length, and CTA should fit the channel.",
          ),
          h3("Which channel should I start with?"),
          p(
            "If the idea is search-driven or tied to AI visibility, start with GEO. If the idea is opinion-led or narrative-driven, start with LinkedIn or X. If the idea is a launch or case study, generate a full cross-channel campaign.",
          ),
          h3("Can Axy.digital automatically adapt content for each channel?"),
          p(
            "Yes. Axy.digital uses your channel plans and guidelines to adapt content for GEO, LinkedIn, and X.",
          ),
          h3("Where do repurposed assets go?"),
          p(
            "Generated assets are added to your Marketing Calendar. From there, you can review, edit, approve, schedule, publish, or export them.",
          ),
          h3("Should every campaign be cross-channel?"),
          p(
            "Not always. Some ideas are only worth one post. But strong ideas, high-intent topics, product launches, case studies, and AI visibility gaps usually benefit from cross-channel distribution.",
          ),
          img(),
          h2("Best practices"),
          h3("Start with one clear idea"),
          p("Repurposing works best when the campaign has a focused message."),
          h3("Let each channel do its job"),
          p(
            "GEO should answer and rank. LinkedIn should build trust. X should create timely visibility.",
          ),
          h3("Avoid copy-pasting"),
          p(
            "Adapt the message for each channel instead of duplicating the same content everywhere.",
          ),
          h3("Sequence the campaign"),
          p("Use the Marketing Calendar to spread assets across a few days or weeks."),
          h3("Track campaign-level performance"),
          p(
            "Do not only evaluate individual posts. Look at whether the full campaign moved visibility, engagement, or demand.",
          ),
        ],
        next: [
          "/tutorials/how-axy-generates-campaigns",
          "/tutorials/use-the-marketing-calendar",
          "/tutorials/generate-a-geo-article",
        ],
      },
    ],
  },
];

export const allTutorials: Article[] = tutorialSections.flatMap((s) => s.articles);

export function getTutorial(slug: string): Article | undefined {
  return allTutorials.find((t) => t.slug === slug);
}
